import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'
import { Location } from '@angular/common'
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ErrorHandler, HostListener, Injector, OnDestroy, OnInit, ViewChild, ViewEncapsulation, inject, signal } from '@angular/core'
import { form } from '@angular/forms/signals'
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete'
import { DateAdapter } from '@angular/material/core'
import { MatDialog } from '@angular/material/dialog'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'

import { RaporttiType } from '@lemon/core-firebase/model/reports-shared'
import { BankBalanceCalcAlgorithm, SahkoisenTiliotteenAlatyyppi, Tilitapahtuma, ValuuttakonversionTiedotTilitapahtumassa } from '@lemon/core-firebase/model/tiliote'
import { LocalDate, LocalMonth, NumberDate, NumberMonth, Timestamp } from '@lemon/core/model/common'

import { KopioijaPalvelu } from '@lemon/core-firebase/service/kopioija.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { StringService } from '@lemon/core/service/string.service'
import { AsiakasService, AsiakkaanAvainTiedot } from 'app/_angular/service/asiakas/asiakas.service'
import { KirjanpitajaService } from 'app/_angular/service/kirjanpitaja/kirjanpitaja.service'
import { KirjanpitoImageService } from 'app/_angular/service/kirjanpito/kirjanpito-image.service'
import { KirjanpitoImageHandlerService, KirjanpitoService, TositeJaNaytettavaSivut } from 'app/_angular/service/kirjanpito/kirjanpito.service'
import { KirjautunutKayttajaService } from 'app/_angular/service/kirjautunut-kayttaja.service'
import { KirjautunutTilintarkastajaService } from 'app/_angular/service/kirjautunut-tilintarkastaja.service'
import { TilikarttaService } from 'app/_angular/service/tilikartta.service'

import { KirjanpitajanRooli } from '@lemon/core-firebase/lemonator/model/kirjanpitaja'
import { OmaveroYhteisomyyntiDraft, OmaveroYhteisomyyntilaskuLahetetty, YHTEISOMYYNTI_ALOITUSPVM } from '@lemon/lemonaid-lemonator-functions-and-lemonator-angular/model/omavero'
import { AlvIlmoitusjakso, Asiakas, AsiakkaanMaksutapa, Tilikausi } from 'app/_jaettu-lemonator/model/asiakas'
import { KirjanpitajanNimitiedot, KirjanpitoRaporttiValilehti } from 'app/_jaettu-lemonator/model/kirjanpitaja'
import {
  AlvIlmoitus,
  AlvMaaritys,
  Kirjanpitotili,
  KirjanpitotilinAlvTyyppi,
  KirjaukseenLiitettyjenTiedostojenSivut,
  KirjauksenTallennuspyyntoUusi,
  KirjauksenTallennusvastaus,
  KirjauksenTyyppi,
  KirjauksienLuontityyppi,
  Kirjaus,
  Kirjausrivi,
  MuutaKirjausSuoriteperusteiseksiPyynto,
  MyyntiAlvt,
  OstoAlvt,
  PoistokirjauksienLuontiasetukset,
  PoistotilienMuutostiedot,
  Raportointikirjaus,
  RaporttiPdfResponse,
  RaporttiRequest,
  TilikaudenAvainluvut,
} from 'app/_jaettu-lemonator/model/kirjanpito'
import { AsiakasJaettuService, AsiakkaanMaksutavat } from 'app/_jaettu-lemonator/service/asiakas-jaettu.service'
import { KirjanpitoJaettuService } from 'app/_jaettu-lemonator/service/kirjanpito-jaettu.service'
import { KirjanpitoUriService } from 'app/_jaettu-lemonator/service/kirjanpito-uri.service'

import { KirjanpitoKirjausnumeronPaivittaminenTyojonotiedot, KirjanpitoKuukausiruutujenErotustenPaivittaminenTyojonotiedot } from '../../_jaettu-lemonator/model/tyojono'
import { KirjanpitoLahetysComponent } from '../../kirjanpito/kirjanpito-lahetys.component'

import { AreYouSureDialog, AreYouSureDialogData } from 'app/_jaettu-angular/_components/are-you-sure.dialog'
import { KirjausMuutaPaivamaaraDialog, KirjausMuutaPaivamaaraDialogData } from '../../kirjanpito/dialogit/kirjaus.muuta-pvm.dialog'
import { KirjausMuutaVatDialog, KirjausMuutaVatDialogData } from '../../kirjanpito/dialogit/kirjaus.muuta-vat.dialog'
import { KirjausPoistaDialog, KirjausPoistaDialogData, KirjausPoistaDialogResult } from '../../kirjanpito/dialogit/kirjaus.poista.dialog'

import { BehaviorSubject, combineLatest, EMPTY, firstValueFrom, Observable, of as observableOf, of, ReplaySubject, Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged, filter, map, startWith, switchMap, takeUntil, tap, withLatestFrom } from 'rxjs/operators'

import { KirjanpitoComponentData } from 'app/_angular/_resolvers/asiakas.resolve'
import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'
import { KuukausiruudunTiedot } from 'app/asiakkaat/listaus/asiakkaat.datasource.service'
import { DocumentData, Query, QuerySnapshot } from 'firebase/firestore'
import * as hotFormulaParser from 'hot-formula-parser'
import { fromRef } from '../../_jaettu-angular/rxfire/firestore'
import { KirjausDiagnoseHelpDialog, KirjausDiagnoseHelpDialogData } from '../../kirjanpito/dialogit/kirjaus.diagnose-help.dialog'

import { BankBalancesPerMonth } from '@lemon/core-firebase/model/tiliote'

import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { MatSnackBar } from '@angular/material/snack-bar'
import { MatTabGroup } from '@angular/material/tabs'
import { KirjanpidonPeruste, MAKSUTAPA_AUTOMAATTISET_JAKSOTUKSET, SopimusPalvelupaketti, Yritysmuoto } from '@lemon/core-firebase/model/kayttaja'
import { KirjanpidonProjekti } from '@lemon/core-firebase/model/kirjanpito-projektit'
import { Laskuasetukset } from '@lemon/core-firebase/model/lasku'
import { TimestampProviderBase } from '@lemon/core/service/timestamp-provider.interface'
import { AlvLemonatorService } from 'app/_angular/service/alv-lemonator.service'
import { DebugService } from 'app/_angular/service/debug.service'
import { FirebaseLemonaid, FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { KirjanpitoNavigationService } from 'app/_angular/service/kirjanpito/kirjanpito-navigation.service'
import { KirjanpitoTositeService } from 'app/_angular/service/kirjanpito/kirjanpito-tosite.service'
import { InfoDialog, InfoDialogData } from 'app/_jaettu-angular/_components/info.dialog'
import { arvonMuutokset, asetaArvo } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { lemonShare } from 'app/_jaettu-angular/_rxjs/lemon-share.operator'
import { FileSaverService } from 'app/_jaettu-angular/service/file-saver'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'
import { VasenValikkoService } from 'app/_jaettu-angular/service/vasen-valikko.service'
import { AsiakkaanSopimuskausiService } from 'app/_jaettu-lemonator/service/sopimuskausi.service'
import { LaskunToimittajaTypeahead } from '../../_angular/service/lasku/lasku.typeahead'
import { LaskunToimittajaTypeaheadBase } from '../../_jaettu-angular/service/lasku/typeahead.service'
import { TilikarttaJaettuService } from '../../_jaettu-lemonator/service/tilikartta-jaettu.service'
import { KirjanpitoLisaaTiliotteenSaldoDialog, KirjanpitoLisaaTiliotteenSaldoDialogData } from '../../kirjanpito/dialogit/kirjanpito-lisaa-tiliotteen-saldo.dialog'
import { KirjausJaksotaKuluDialog, KirjausJaksotaKuluDialogData } from '../../kirjanpito/dialogit/kirjaus-jaksota-kulu.dialog'
import { KirjausJaksotaDialog, KirjausJaksotaDialogData } from '../../kirjanpito/dialogit/kirjaus.jaksota.dialog'
import { KirjausKopioiDialog, KirjausKopioiDialogData } from '../../kirjanpito/dialogit/kirjaus.kopioi.dialog'
import { KirjausMuokkaaViitenumeroaDialog, KirjausMuokkaaViitenumeroaDialogData } from '../../kirjanpito/dialogit/kirjaus.muokkaa-viitenumeroa.dialog'
import {
  KirjausMuutaSuoriteperusteiseksiDialog,
  KirjausMuutaSuoriteperusteiseksiDialogData,
  KirjausMuutaSuoriteperusteiseksiDialogReturnValue,
} from '../../kirjanpito/dialogit/kirjaus.muuta-suoriteperusteiseksi.dialog'
import { KirjausPoistotDialog, KirjausPoistotDialogData, KirjausPoistotDialogResult } from '../../kirjanpito/dialogit/kirjaus.poistot.dialog'
import { KirjausSiirraDialog, KirjausSiirraDialogData } from '../../kirjanpito/dialogit/kirjaus.siirra.dialog'
import { LisaaTilitapahtumaDialog, LisaaTilitapahtumaDialogData } from '../../kirjanpito/dialogit/lisaa-tilitapahtuma.dialog'
import { BroadcastChannelKlikattuRaportointikirjausPayload } from '../../kirjanpito/raportit-standalone.component'
import { KlikattuKirjaus } from '../../kirjanpito/raportit.component'

interface SuodatusLomake {
  naytaVainTileihinRajatut: string
}

interface AdminAsetuksetLomake {
  bankBalanceAlgoComparisonFirst: BankBalanceCalcAlgorithm | null
  bankBalanceAlgoComparisonSecond: BankBalanceCalcAlgorithm | null
}

interface Ensilataustiedot {
  isInitialLoadForMonth: boolean
  preselectedMaksutapaTunniste: string
  preselectedKirjausAvain: string
  preselectedKirjausnumero: string
}

interface KuukausiJaLataustiedot {
  lataustiedot: Ensilataustiedot
  kuukausi: LocalMonth
}
interface KuukausiJaLataustiedotJaRuutu extends KuukausiJaLataustiedot {
  ruutu: KuukausiruudunTiedot
}

interface HarvoinMuuttuvatTiedot1 {
  asiakas: AsiakkaanAvainTiedot
  maksutavat: AsiakkaanMaksutapa[]
  projektitMap: Map<string, NaytettavaKirjanpidonProjekti>
}

interface HarvoinMuuttuvatTiedot2 extends HarvoinMuuttuvatTiedot1 {
  kuukausi: KuukausiJaLataustiedotJaRuutu
  alvIlmoitusjakso: AlvIlmoitusjakso
  tilikausiLukossa: boolean
}

interface MaksutavatJaKirjauksetJaHarvoinMuuttuvatTiedot {
  harvoinMuuttuvatTiedot: HarvoinMuuttuvatTiedot2
  mjk: MaksutapaJaKirjaukset[]
}

export interface NaytettavaKirjaus {
  kirjaus: Kirjaus
  tapahtuma: Tilitapahtuma
  tilitapahtumanPvm: string
  tilitapahtumanSumma: string
  debetyhteensa: string
  kredityhteensa: string
  naytettavatKirjausrivit: NaytettavaKirjausrivi[]
  kirjauksenVirhe: string
  tallennetaan: boolean
  tallennustiedot: string
  nykyisenVersionTimestamp: Timestamp
  edellisiaVersioita: boolean
  seuraaviaVersioita: boolean
  seuraavaOnNykyinen: boolean
  latauksenAikainenTila: NaytettavaKirjaus
  lukittu: boolean
  kirjauksessaYhteisomyyntiVatKentta: boolean
  naytaPoisto?: true
  naytaSiirra?: true
  naytaKopioi?: true
  uusiPaivamaara?: number
  uusiMaksutapa?: string
  uusiViitenumero?: string
  uusiVat?: string
  tallentamattomiaMuutoksia: boolean
  poistetaan?: boolean
  pvmSaldo?: string
  pvmOtot?: string
  pvmPanot?: string
  kirjausKonversioTiedot?: string
}

interface NaytettavaKirjausrivi {
  kirjausrivi: Kirjausrivi
  tilivirhe: boolean
  tilinumero: string
  tilinimi: string
  debet: string
  debetvirhe: boolean
  kredit: string
  kreditvirhe: boolean
  alv: string
  alvvirhe: boolean
  kommentti: string
  lukittu: boolean
  debetlukittu: boolean
  kreditlukittu: boolean
  alvlukittu: boolean
  knTabIndexPoistettu: boolean
  tunniste: string
  projektiNimi?: string
  projektiNayta?: boolean
  projektiVariLuokka?: string
}

interface NaytettavaKirjanpidonProjekti {
  projekti: KirjanpidonProjekti
}

interface ValittavaKirjanpidonProjekti extends NaytettavaKirjanpidonProjekti {
  valittu: boolean
}

export interface MaksutapaJaKirjaukset {
  maksutapa: AsiakkaanMaksutapa
  maksutavanKuva: SafeUrl
  kasiteltyja: number
  kasittelematta: number
  naytaLisaa: boolean
  valittu: boolean
  kirjaukset: NaytettavaKirjaus[]
  sivutetutKirjaukset: NaytettavaKirjaus[]
  otot?: string
  panot?: string
}

interface Sivutiedot {
  sivu: number
  aktivoiEnsimmainen: boolean
}

export interface EditoitavaData {
  kuukausi: LocalMonth
  kirjaukset: NaytettavaKirjaus[]
}

export type TabTyypit = 'ilmoitukset' | 'maksutapa' | 'laheta' | 'vero'

type TekstiboksinTunnus = 'kn' | 'kd' | 'kk' | 'ka' | 'kko'

// 'raportit'
type ValilehdenTunnus = 'tositteet' | 'raportit-uusi' | 'tiedot' | 'tilikartta' | 'projektit' | 'tilinpaatos' | 'reskontra' | 'hallinto'
interface LastKnownFocus {
  arvoavain: string
  tekstiboksi: TekstiboksinTunnus
}

@Component({
  templateUrl: './tilintarkastus-kirjanpito.component.html',
  styleUrls: ['./tilintarkastus-kirjanpito.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  // Pidetään toimittaja typeahead kirjanpitokomponenttitasolla (valuu raportteihin + reskontraan ja tuhoutuu kun lähdetään pois)
  providers: [{ provide: LaskunToimittajaTypeaheadBase, useClass: LaskunToimittajaTypeahead }],
})
export class KirjanpitoTilintarkastusComponent implements OnInit, OnDestroy {
  @ViewChild('tnroInput', { static: true }) private _tnroInput: ElementRef<HTMLInputElement>
  @ViewChild('debetInput', { static: true }) private _debetInput: ElementRef<HTMLInputElement>
  @ViewChild('kreditInput', { static: true }) private _kreditInput: ElementRef<HTMLInputElement>
  @ViewChild('alvInput', { static: true }) private _alvInput: ElementRef<HTMLInputElement>
  @ViewChild('kommenttiInput', { static: true }) private _kommenttiInput: ElementRef<HTMLInputElement>

  // @ViewChild('kkpikaDatePicker', { read: MatDatepicker }) private _kkpikaDatePicker: MatDatepicker<Date>

  @ViewChild('tnroInput', { read: MatAutocompleteTrigger, static: true }) private _tiliAutocompleteTrigger: MatAutocompleteTrigger
  @ViewChild('alvInput', { read: MatAutocompleteTrigger, static: true }) private _alvAutocompleteTrigger: MatAutocompleteTrigger
  @ViewChild('kommenttiInput', { read: MatAutocompleteTrigger, static: true }) private _kommenttiAutocompleteTrigger: MatAutocompleteTrigger

  @ViewChild('tiliAuto', { static: true }) private _tiliAutocomplete: MatAutocomplete
  @ViewChild('alvAuto', { static: true }) private _alvAutocomplete: MatAutocomplete
  @ViewChild('kommenttiAuto', { static: true }) private _kommenttiAutocomplete: MatAutocomplete

  @ViewChild('kirjanpitoLahetysComponent', { read: KirjanpitoLahetysComponent }) kirjanpitoLahetysComponent: KirjanpitoLahetysComponent
  // @ViewChild('kirjanpitoKirjaamattomatTositteetComponent', { static: true, read: KirjanpitoKirjaamattomatTositteetComponent }) private _kirjanpitoKirjaamattomatTositteetComponent: KirjanpitoKirjaamattomatTositteetComponent
  // @ViewChild('kirjanpitoKirjauksenTositteidenKatseluComponent', { static: true, read: KirjanpitoKirjauksenTositteidenKatseluComponent }) private _kirjanpitoKirjauksenTositteidenKatseluComponent: KirjanpitoKirjauksenTositteidenKatseluComponent

  @ViewChild('kirjausPaginator', { static: false, read: MatPaginator }) paginator: MatPaginator
  @ViewChild('ilmoitusTabGroup', { static: false }) ilmoitusTabGroup: MatTabGroup

  private _ngUnsubscribe = new Subject<void>()
  private readonly _injector = inject(Injector)

  // private _onkoHolviAsiakas: boolean = false

  private _kirjausSelectedBroadcastChannel: BroadcastChannel
  private _kirjausnumeroBroadcastChannel: BroadcastChannel

  // private _vahintaanYhdellaKayttajallaOlevatMaksutavatSet: Set<string> = new Set()

  kirjanpitajanAnnetaanMuokataMitaTahansaKirjauksiaObservable: Observable<boolean>
  private _useValidationBeforeSaveSubject: BehaviorSubject<boolean> = new BehaviorSubject(true)
  private _allKirjauksetAndAccountsCanBeEdited: BehaviorSubject<boolean> = new BehaviorSubject(false)
  kirjanpitajanAnnetaanMuokataMitaTahansaKirjauksiaValittunaObservable: Observable<boolean> = this._allKirjauksetAndAccountsCanBeEdited.asObservable()
  private _mainImageQualityEnhanceSubject: BehaviorSubject<boolean> = new BehaviorSubject(false)
  mainImageQualityEnhanceObservable: Observable<boolean> = this._mainImageQualityEnhanceSubject.asObservable()
  toggleMainEnhance() {
    this._mainImageQualityEnhanceSubject.next(!this._mainImageQualityEnhanceSubject.value)
  }

  private _kirjauksetLataaSubject: BehaviorSubject<boolean> = new BehaviorSubject(true)
  private _muistiinpanojaTallennetaanSubject: BehaviorSubject<boolean> = new BehaviorSubject(false)
  muistiinpanojaTallennetaanObservable = this._muistiinpanojaTallennetaanSubject.asObservable()

  private _maksutavatJoissaOnKirjaamattomiaTositteitaSubject: BehaviorSubject<AsiakkaanMaksutapa[]> = new BehaviorSubject([])

  suodatetutKirjanpitotilitObservable: Observable<Kirjanpitotili[]>
  valitunKuukaudenTilikausiObservable: Observable<Tilikausi | null>
  tilinpaatosWarningObservable: Observable<string>
  kirjanpidonPerusteKirjaukselleObservable: Observable<KirjanpidonPeruste>

  private _suodatetutAlvtSubject: BehaviorSubject<AlvMaaritys[]> = new BehaviorSubject([])
  suodatetutAlvtObservable: Observable<AlvMaaritys[]> = this._suodatetutAlvtSubject.asObservable()

  private _suodatetutKommentitSubject: BehaviorSubject<string[]> = new BehaviorSubject([])
  suodatetutKommentitObservable: Observable<string[]> = this._suodatetutKommentitSubject.asObservable()

  readonly DEFAULT_KIRJ_PER_PAGE = 200
  readonly kirjauksienLuontityypit = KirjauksienLuontityyppi
  valittuSivuSubject: BehaviorSubject<Sivutiedot> = new BehaviorSubject({ sivu: 1, aktivoiEnsimmainen: true })
  kirjauksiaPerSivuSubject: BehaviorSubject<number> = new BehaviorSubject(this.DEFAULT_KIRJ_PER_PAGE)

  private _valittuKuukausiSubject: BehaviorSubject<LocalMonth> = new BehaviorSubject({ month: new Date().getMonth() + 1, year: new Date().getFullYear() })
  _ensilataustiedotSubject: BehaviorSubject<Map<NumberMonth, Ensilataustiedot>> = new BehaviorSubject(new Map())
  private _valittuKuukausiruutuSubject: BehaviorSubject<KuukausiruudunTiedot> = new BehaviorSubject(null)
  private valittuKuukausiJaLataustiedotJaRuutuObservable: Observable<KuukausiJaLataustiedotJaRuutu> = combineLatest([
    this._valittuKuukausiSubject,
    this._ensilataustiedotSubject,
    this._valittuKuukausiruutuSubject,
  ]).pipe(
    filter(([kuukausi, lataustiedot, ruutu]) => {
      if (!kuukausi || !lataustiedot || !ruutu) {
        return false
      }
      // Emit only if ruutu kuukausi and kuukausi are in sync
      if (ruutu.k === this._dateService.localMonthToNumber(kuukausi)) {
        return true
      }
      return false
    }),
    map(([kuukausi, lataustiedot, ruutu]) => {
      return {
        kuukausi: kuukausi,
        lataustiedot: lataustiedot.get(ruutu.k) ?? null,
        ruutu: ruutu,
      }
    }),
    distinctUntilChanged((prev, curr) => {
      return this._dateService.compareLocalMonths(prev.kuukausi, '==', curr.kuukausi)
    }),
  )

  /** DO NOT USE THIS IN THE CODE! ONLY IN TEMPLATE OR OTHERWISE WE MIGHT HAVE TIMING MISMATCHES! */
  valittuKuukausiObservable = this._valittuKuukausiSubject.asObservable()
  /** DO NOT USE THIS IN THE CODE! ONLY IN TEMPLATE OR OTHERWISE WE MIGHT HAVE TIMING MISMATCHES! */
  valittuKuukausiruutuObservable = this._valittuKuukausiruutuSubject.asObservable()

  nykyinenAsiakasObservable: Observable<Asiakas>
  // tiedostojenValimuistinTilaObservable: Observable<string>
  laskuasetuksetObservable: Observable<Laskuasetukset>
  esikatseltavatTositteetObservable: Observable<TositeJaNaytettavaSivut[]>
  veroilmoitusLahetettyObservable: Observable<boolean>

  kirjanpidonProjektitObservable: Observable<KirjanpidonProjekti[]> = this._kirjanpitoService.kirjanpidonProjektitObservable

  valittuNaytettavaProjekti: BehaviorSubject<string> = new BehaviorSubject<string>(null)
  naytettavatKirjanpidonProjektit: Observable<ValittavaKirjanpidonProjekti[]> = combineLatest([this.kirjanpidonProjektitObservable, this.valittuNaytettavaProjekti]).pipe(
    map(([projektit, valittu]) => {
      const projs: ValittavaKirjanpidonProjekti[] = []
      if (projektit) {
        const pn: ValittavaKirjanpidonProjekti = {
          projekti: {
            avain: null,
            color: null,
            nimi: 'Poista valinta',
            usableInLemonator: false,
            viewableInLemonaid: false,
            viewableInLemonator: false,
          },
          valittu: !valittu,
        }

        projs.push(pn)

        for (const projekti of projektit) {
          if (projekti.usableInLemonator) {
            const n: ValittavaKirjanpidonProjekti = {
              projekti: projekti,
              valittu: valittu === projekti.avain,
            }
            projs.push(n)
          }
        }
      }
      return projs
    }),
  )

  private _kirjanpidonProjektitMap: Map<string, NaytettavaKirjanpidonProjekti> = new Map<string, NaytettavaKirjanpidonProjekti>()
  private _kirjanpidonProjektitAktiivisia: boolean = false
  private _kirjanpidonProjektitMapObservable: Observable<Map<string, NaytettavaKirjanpidonProjekti>> = this.kirjanpidonProjektitObservable.pipe(
    map(projektit => {
      const projektitMap = new Map<string, NaytettavaKirjanpidonProjekti>()
      if (projektit) {
        for (const projekti of projektit) {
          const n: NaytettavaKirjanpidonProjekti = {
            projekti: projekti,
          }
          projektitMap.set(projekti.avain, n)
        }
      }
      return projektitMap
    }),
  )

  previousMonthEndingSaldoObservable: Observable<string>
  private _dailyBalanceTextsMap: Map<string, string> = new Map()

  saldoEncodedUriObservable: Observable<string>
  saldoUriObservable: Observable<string>

  availablebankBalanceAlgorithms: BankBalanceCalcAlgorithm[] = [BankBalanceCalcAlgorithm.AIIA_OLD, BankBalanceCalcAlgorithm.VERSION_ONE]

  private _bankBalanceComparisonSubject: BehaviorSubject<{ first: BankBalanceCalcAlgorithm; second: BankBalanceCalcAlgorithm }> = new BehaviorSubject({
    first: BankBalanceCalcAlgorithm.AIIA_OLD,
    second: BankBalanceCalcAlgorithm.AIIA_OLD,
  })
  bankBalanceComparisonObservable = this._bankBalanceComparisonSubject.asObservable()

  asetaValittuProjekti(rivi: NaytettavaKirjausrivi) {
    const pr = rivi.kirjausrivi.pr || null
    if (this.valittuNaytettavaProjekti.value !== pr) {
      this.valittuNaytettavaProjekti.next(pr)
    }
  }

  asetaProjekti(kirjaus: NaytettavaKirjaus, rivi: NaytettavaKirjausrivi, projekti: KirjanpidonProjekti) {
    rivi.kirjausrivi.pr = projekti?.avain || null
    this.asetaProjektiNaytettavaanRiviin(rivi.kirjausrivi, rivi)
    kirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(kirjaus)
    this.asetaViimeisinTiedossaOlevaFokus(rivi.tunniste, 'kn')
    this.palautaViimeisinTiedossaOlevaFokus()
  }

  private _kirjauksetMaksutavoittainSubject: BehaviorSubject<MaksutavatJaKirjauksetJaHarvoinMuuttuvatTiedot> = new BehaviorSubject({ harvoinMuuttuvatTiedot: null, mjk: [] })
  private _kirjauksetMaksutavoittainTabeilleSubject: BehaviorSubject<MaksutapaJaKirjaukset[]> = new BehaviorSubject([])
  private _kirjauksetMaksutavoittainObservable: Observable<MaksutavatJaKirjauksetJaHarvoinMuuttuvatTiedot> = this._kirjauksetMaksutavoittainSubject.asObservable()

  private _valittuMaksutapaSubject: BehaviorSubject<AsiakkaanMaksutapa> = new BehaviorSubject(null)
  valittuMaksutapaObservable: Observable<AsiakkaanMaksutapa> = this._valittuMaksutapaSubject.asObservable()

  private _valittuTabSubject: BehaviorSubject<TabTyypit> = new BehaviorSubject(null)
  valittuTabObservable: Observable<TabTyypit> = this._valittuTabSubject.asObservable()

  private _valittuIlmoitusTabSubject: BehaviorSubject<'alv' | 'yhteisomyynti'> = new BehaviorSubject('alv')
  valittuIlmoitusTabObservable: Observable<'alv' | 'yhteisomyynti'> = this._valittuIlmoitusTabSubject.asObservable()
  ilmoitusTabSelectedIndexObservable: Observable<number>
  /** Lippu joka estää automaattisen välilehden valinnan kun käyttäjä on manuaalisesti valinnut välilehden */
  private _kayttajaValitsiIlmoitusTabinManuaalisesti = false
  /** Edellinen kuukausi ilmoitusvälilehden automaattista valintaa varten */
  private _edellinenIlmoitusKuukausi: string | null = null

  valitunKuukaudenJaMaksutavanKirjauksetObservable: Observable<MaksutapaJaKirjaukset>

  private _valittuNaytettavaKirjausSubject: BehaviorSubject<NaytettavaKirjaus> = new BehaviorSubject(null)
  valittuNaytettavaKirjausObservable: Observable<NaytettavaKirjaus> = this._valittuNaytettavaKirjausSubject.asObservable()

  private _nykyisellaKuukaudellaOnAlvMuutoksiaSubject: BehaviorSubject<'yes' | 'no' | 'not-saved-yet'> = new BehaviorSubject('not-saved-yet')
  nykyisellaKuukaudellaOnAlvMuutoksiaObservable: Observable<'yes' | 'no' | 'not-saved-yet'> = this._nykyisellaKuukaudellaOnAlvMuutoksiaSubject.asObservable()

  private _nykyisellaKuukaudellaOnYhteisomyyntiMuutoksiaSubject: BehaviorSubject<'yes' | 'no' | 'not-saved-yet'> = new BehaviorSubject('not-saved-yet')
  nykyisellaKuukaudellaOnYhteisomyyntiMuutoksiaObservable: Observable<'yes' | 'no' | 'not-saved-yet'> = this._nykyisellaKuukaudellaOnYhteisomyyntiMuutoksiaSubject.asObservable()

  // Yhdistetty status observable joka huomioi sekä ALV että yhteisömyynti-ilmoitukset
  yhdistettyStatusObservable: Observable<'yes' | 'no' | 'not-saved-yet'>

  naytaIlmoitusValilehtiObservable: Observable<boolean>
  naytaAlvIlmoitusValilehtiObservable: Observable<boolean>
  naytaYhteisomyyntiIlmoitusValilehtiObservable: Observable<boolean>
  naytaVeroilmoitusValilehtiObservable: Observable<boolean>
  naytaLahetysValilehtiObservable: Observable<boolean>
  naytaTestiObservable: Observable<boolean> = this._tilintarkastajaService.tilintarkastajaObservable.pipe(
    switchMap(tilintarkastaja => {
      // Tilintarkastajat eivät näe test-ominaisuuksia
      if (tilintarkastaja) {
        return of(false)
      }
      return this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(map(kirjanpitaja => kirjanpitaja && kirjanpitaja.rooli === KirjanpitajanRooli.SUPER))
    }),
  )
  isAdminObservable: Observable<boolean> = this._tilintarkastajaService.tilintarkastajaObservable.pipe(
    switchMap(tilintarkastaja => {
      // Tilintarkastajat eivät ole admineja
      if (tilintarkastaja) {
        return of(false)
      }
      return this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
        map(kirjanpitaja => {
          return (
            kirjanpitaja &&
            (kirjanpitaja.uid === 'AHiu6xZimwXgxmd3d5vqzbC8ce42' || // Jon
              kirjanpitaja.uid === 'dqUiLNmLRaMNbyNgMhWG1AUmVGI2' || // Valtteri
              kirjanpitaja.uid === '4sNRp7LvWTeZ9WTomoKOA9jD42y1' || // Ville
              kirjanpitaja.uid === 'IbKDXwWiLLNbV4e0ZxtqrcmGPik2' || // Lauri
              kirjanpitaja.uid === 'H6KU6K9S39QaqDnpe1apaUV3dsz1' || // Elina P.
              kirjanpitaja.uid === '3d4UG33dpERg5CqyF1TmafusXNa2' || // Ville H.
              kirjanpitaja.uid === 'nwGu99bXkWfX40Hk5nLVMKDn3lP2' || // Veera
              kirjanpitaja.uid === '2v5K8Nw5YdSYL5H7No54oOeP4be2' || // Topias
              kirjanpitaja.uid === 'pOUBE2FEeOQ8d5OkZg5oT23Me9J2') // Ilkka
          )
        }),
      )
    }),
  )
  yberSuperObservable: Observable<boolean> = this._tilintarkastajaService.tilintarkastajaObservable.pipe(
    switchMap(tilintarkastaja => {
      // Tilintarkastajat eivät ole yberSupereja
      if (tilintarkastaja) {
        return of(false)
      }
      return this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
        map(kirjanpitaja => {
          if (
            kirjanpitaja &&
            (kirjanpitaja.uid === 'AHiu6xZimwXgxmd3d5vqzbC8ce42' || // Jon
              kirjanpitaja.uid === 'dqUiLNmLRaMNbyNgMhWG1AUmVGI2' || // Valtteri
              kirjanpitaja.uid === '4sNRp7LvWTeZ9WTomoKOA9jD42y1' || // Ville
              kirjanpitaja.uid === 'IbKDXwWiLLNbV4e0ZxtqrcmGPik2' || // Lauri
              kirjanpitaja.uid === 'H6KU6K9S39QaqDnpe1apaUV3dsz1' || // Elina P.
              kirjanpitaja.uid === '3d4UG33dpERg5CqyF1TmafusXNa2' || // Ville H.
              kirjanpitaja.uid === 'nwGu99bXkWfX40Hk5nLVMKDn3lP2' || // Veera
              // kirjanpitaja.uid === '3J8SOb4AYubt6Lmf3xBIibdXqC43' || // Maria
              kirjanpitaja.uid === '2v5K8Nw5YdSYL5H7No54oOeP4be2' || // Topias
              kirjanpitaja.uid === 'pOUBE2FEeOQ8d5OkZg5oT23Me9J2') // Ilkka
          ) {
            return true
          }
          return false
        }),
      )
    }),
  )
  userRolesObservable: Observable<{ isYberSuper: boolean; isAdmin: boolean }> = combineLatest([this.yberSuperObservable, this.isAdminObservable]).pipe(
    map(([yber, admin]) => {
      return { isYberSuper: yber, isAdmin: admin }
    }),
  )

  onkoDevaajaObservable = this._tilintarkastajaService.tilintarkastajaObservable.pipe(
    switchMap(tilintarkastaja => {
      // Tilintarkastajat eivät ole kehittäjiä
      if (tilintarkastaja) {
        return of(false)
      }
      return this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaObservable
    }),
  )

  showReskontraObservable: Observable<boolean>

  displayAlgoComparisonToolObservable: Observable<boolean>
  displayBankBalanceEditDialogObservable: Observable<boolean>

  rivinKirjauksetMaksutavottainObservable: Observable<MaksutapaJaKirjaukset[]>

  // private _sidefeedChangesSubject: Subject<firebase.firestore.DocumentChange[]> = new Subject()

  private lastKnownFocus: LastKnownFocus = null
  // private isInitialLoadForMonth: boolean = true
  // private isInitialLoadForMonthPreselectedMaksutapaTunniste: string = null
  // private isInitialLoadForMonthPreselectedKirjausAvain: string = null
  // private isInitialLoadForMonthPreselectedKirjausnumero: string = null

  lataaObservable: Observable<boolean> = this._kirjauksetLataaSubject.asObservable()
  valittuvalilehti: ValilehdenTunnus = 'tositteet'
  showSmallTabsObservable: Observable<boolean>
  namename = 'asdryuopw' + Math.random()

  private tilinumeroSubject: BehaviorSubject<string> = new BehaviorSubject(null)
  tilinumeroObservable = this.tilinumeroSubject.asObservable()
  private alvSubject: BehaviorSubject<string> = new BehaviorSubject(null)
  private kommenttiSubject: BehaviorSubject<string> = new BehaviorSubject(null)

  private _riviMap: Map<string, NaytettavaKirjausrivi> = new Map()
  private _kirjausMap: Map<string, NaytettavaKirjaus> = new Map()

  // Alvt
  private _kaikkiAlvMaarityksetMap: Map<string, AlvMaaritys> // As parameter to this component
  private _kaikkiAlvtTunnisteenMukaanMap: Map<string, AlvMaaritys> = new Map()
  private _kaikkiAlvtLyhenteenMukaanMap: Map<string, AlvMaaritys> = new Map()
  private _kaikkiValittavissaOlevatAlvt: BehaviorSubject<AlvMaaritys[]> = new BehaviorSubject([])
  private _asiakkaanAlvtLukossa = false
  private _tilikausiLukossa = false

  // Tilit
  private _kaikkiTilitMap: Map<string, Kirjanpitotili> // As parameter to this component
  private _kaikkiValittavissaOlevatTilitMap: Map<string, Kirjanpitotili> = new Map()
  private _kaikkiValittavissaOlevatTilitList: Kirjanpitotili[] = []
  private _selvitettavatOstotTilitMap: Map<string, Kirjanpitotili> = new Map()
  private _selvitettavatMyynnitTilitMap: Map<string, Kirjanpitotili> = new Map()

  private _kirjanpitajienNimitiedotMap: Map<string, KirjanpitajanNimitiedot> // As parameter to this component
  private _kaikkiMaksutavatMap: Map<string, AsiakkaanMaksutapa> = new Map()
  private _asiakas: Asiakas // As parameter to this component

  private _naytaVainHyvaksymattomatSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  naytaVainHyvaksymattomatObservable: Observable<boolean> = this._naytaVainHyvaksymattomatSubject.asObservable()

  suodatusLomake = form(signal<SuodatusLomake>({ naytaVainTileihinRajatut: '' }))
  private _naytaVainTileihinRajatutSubject: BehaviorSubject<Set<string>> = new BehaviorSubject<Set<string>>(new Set())

  private _naytaPoistetutKirjauksetSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  naytaPoistetutKirjauksetObservable: Observable<boolean> = this._naytaPoistetutKirjauksetSubject.asObservable()

  onkoSuodattimiaKaytossaObservable: Observable<boolean> = combineLatest([this._naytaVainHyvaksymattomatSubject, this._naytaVainTileihinRajatutSubject]).pipe(
    map(([naytaVainHyvaksymattomat, naytaVainTileihinRajatut]) => {
      return naytaVainHyvaksymattomat || naytaVainTileihinRajatut.size > 0
    }),
  )
  onkoSuoriteTaiLaskuperusteinenObservable: Observable<boolean>

  poistaSuodattimet() {
    if (this._naytaVainHyvaksymattomatSubject.value) {
      this._naytaVainHyvaksymattomatSubject.next(false)
    }
    if (this.suodatusLomake.naytaVainTileihinRajatut().value()) {
      asetaArvo(this.suodatusLomake.naytaVainTileihinRajatut, '')
    }
  }

  adminAsetuksetLomake = form(
    signal<AdminAsetuksetLomake>({
      bankBalanceAlgoComparisonFirst: BankBalanceCalcAlgorithm.AIIA_OLD,
      bankBalanceAlgoComparisonSecond: null,
    }),
  )

  /** string on mapissa kirjauksen avain */
  private naytettavatKirjauksetByKirjausavainMap: Map<string, NaytettavaKirjaus> = new Map()

  /** string on mapissa maksutavan tunniste */
  private maksutavatJaKirjauksetMap: Map<string, MaksutapaJaKirjaukset> = new Map()

  onkoSpostejaLahetetty: boolean
  private latestAlvIlmoitusSubject: ReplaySubject<AlvIlmoitus> = new ReplaySubject(1)
  latestAlvIlmoitusObservable: Observable<AlvIlmoitus> = this.latestAlvIlmoitusSubject.asObservable()

  tiliValittiin(event: MatAutocompleteSelectedEvent) {
    const value = event.option.value as Kirjanpitotili
    this._tilinumeroMuuttui(this._tnroInput.nativeElement, value?.numero ?? null)
    this._closeTiliAuto()
    this.unfocusInput(this._tnroInput.nativeElement)
    // const inputEvent = new Event('input', {
    //   'bubbles': true,
    //   'cancelable': true
    // })
    // this._tnroInput.nativeElement.dispatchEvent(inputEvent)
  }

  alvValittiin(event: MatAutocompleteSelectedEvent) {
    const value = event.option.value as AlvMaaritys
    // console.log('ALV valittiin 1 ' + value)
    this._alvMuuttui(this._alvInput.nativeElement, value?.lyhenne ?? null)
    this._closeAlvAuto()
    this.unfocusInput(this._alvInput.nativeElement)
    // console.log('ALV valittiin 2 ' + value)
    // const inputEvent = new Event('input', {
    //   'bubbles': true,
    //   'cancelable': true
    // })
    // this._alvInput.nativeElement.dispatchEvent(inputEvent)
  }

  kommenttiValittiin(event: MatAutocompleteSelectedEvent) {
    // console.log('In kommentti valittu', event.option.value)
    this._kommenttiMuuttui(this._kommenttiInput.nativeElement, event.option.value)
    this._closeKommenttiAuto()
    this.unfocusInput(this._kommenttiInput.nativeElement)
    // const inputEvent = new Event('input', {
    //   'bubbles': true,
    //   'cancelable': true
    // })
    // this._kommenttiInput.nativeElement.dispatchEvent(inputEvent)
  }

  nykyisellaKuukaudellaOnAlvMuutoksia(muutoksia: 'yes' | 'no' | 'not-saved-yet') {
    this._nykyisellaKuukaudellaOnAlvMuutoksiaSubject.next(muutoksia)
  }

  nykyisellaKuukaudellaOnYhteisomyyntiMuutoksia(muutoksia: 'yes' | 'no' | 'not-saved-yet') {
    this._nykyisellaKuukaudellaOnYhteisomyyntiMuutoksiaSubject.next(muutoksia)
  }

  constructor(
    private _errorHandler: ErrorHandler,
    private _router: Router,
    private _route: ActivatedRoute,
    private _location: Location,
    private _snackbar: MatSnackBar,
    private _changeDetectorRef: ChangeDetectorRef,
    private _asiakasService: AsiakasService,
    private _asiakasJaettuService: AsiakasJaettuService,
    private _sopimuskausiService: AsiakkaanSopimuskausiService,
    private _lemonatorFirebase: FirebaseLemonator,
    private _lemonaidFirebase: FirebaseLemonaid,
    private _dateService: DateService,
    private _stringService: StringService,
    private _currencyService: CurrencyService,
    private _tilikarttaService: TilikarttaService,
    private _dateAdapter: DateAdapter<Date>,
    private _vasenValikkoService: VasenValikkoService,
    private _kirjanpitajaService: KirjanpitajaService,
    private _kirjanpitoService: KirjanpitoService,
    private _kirjanpitoJaettuService: KirjanpitoJaettuService,
    private _kirjanpitoImageService: KirjanpitoImageService,
    private _kirjanpitoUriService: KirjanpitoUriService,
    private _kirjanpitoNavigationService: KirjanpitoNavigationService,
    private _kopipoijaPalvelu: KopioijaPalvelu,
    private _dialog: MatDialog,
    private _sanitizer: DomSanitizer,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _tilintarkastajaService: KirjautunutTilintarkastajaService,
    private _kirjanpitoImageHandlerService: KirjanpitoImageHandlerService,
    private _ladataanService: LadataanService,
    private _kirjanpitoTositeService: KirjanpitoTositeService,
    private _alvService: AlvLemonatorService,
    private _debugService: DebugService,
    private _tilikarttaJaettuService: TilikarttaJaettuService,
    private _formValidationService: FormValidationService,
    private _breakpointObserver: BreakpointObserver,
    private _timestampService: TimestampProviderBase,
    private _fileSaverService: FileSaverService,
  ) {
    const mnth = _dateService.localMonthToNumber(this._valittuKuukausiSubject.value)
    this._ensilataustiedotSubject.value.set(mnth, { isInitialLoadForMonth: true, preselectedKirjausAvain: null, preselectedKirjausnumero: null, preselectedMaksutapaTunniste: null })
  }

  private suodataJaJarjestaMaksutavat(maksutavoittain: MaksutapaJaKirjaukset[], kirjaamattomia: AsiakkaanMaksutapa[]): MaksutapaJaKirjaukset[] {
    if (maksutavoittain.length > 10) {
      return maksutavoittain.filter(a => {
        return a.kirjaukset.length > 0 || kirjaamattomia.findIndex(kirjaamaton => kirjaamaton.avain === a.maksutapa.avain) > -1
      })
    } else if (maksutavoittain.length > 5) {
      return maksutavoittain.filter(a => {
        return (
          a.kirjaukset.length > 0 ||
          (a.maksutapa.aktiivinen && a.maksutapa.kirjauksienLuontityyppi === KirjauksienLuontityyppi.KASIN_SYOTETTAVA_TILIOTE) ||
          (a.maksutapa.aktiivinen && a.maksutapa.kirjauksienLuontityyppi === KirjauksienLuontityyppi.TOSITTEISTA_GENEROITAVA_TILIOTE) ||
          kirjaamattomia.findIndex(kirjaamaton => kirjaamaton.avain === a.maksutapa.avain) > -1
        )
      })
    }
    return maksutavoittain
  }

  private paivitaKirjaamattomienMaara(maksutapaJaKirjaukset: MaksutapaJaKirjaukset) {
    maksutapaJaKirjaukset.kasiteltyja = 0
    maksutapaJaKirjaukset.kasittelematta = 0
    for (const kirjaus of maksutapaJaKirjaukset.kirjaukset) {
      if (kirjaus.kirjaus.kirjanpitajaHyvaksynyt) {
        maksutapaJaKirjaukset.kasiteltyja++
      } else {
        maksutapaJaKirjaukset.kasittelematta++
      }
    }
  }

  async raporttikirjaustaKlikatiin(arvot: { avain: string; kirjaus: Raportointikirjaus }) {
    this.poistaSuodattimet()
    this.poistaValittuNaytettavaKirjaus()
    const kirjaus = arvot.kirjaus
    const kirjauksenKuukausi = this._dateService.numberToLocalDate(kirjaus.p)
    await this._raportointiKirjausValittiin(arvot.avain, null, kirjauksenKuukausi, kirjaus.t)
  }

  private async _raportointiKirjausValittiin(kirjauksenAvain: string, kirjausnumero: string, kirjauksenKuukausi: LocalMonth, maksutavanTunniste: string) {
    console.log('_raportointiKirjausValittiin')
    const tiedot = await firstValueFrom(this.valittuKuukausiJaLataustiedotJaRuutuObservable)
    await this._vaihdaKuukausiJosTarvitsee(kirjauksenKuukausi.year, kirjauksenKuukausi.month, kirjauksenAvain, kirjausnumero, maksutavanTunniste, tiedot.kuukausi)
  }

  async raporttikirjaustaKlikatiinUusi(arvot: KlikattuKirjaus) {
    this.poistaSuodattimet()
    this.poistaValittuNaytettavaKirjaus()

    const start = arvot.kirjausnumero.split('-')[0]
    const maksutavanTunniste = start.substring(0, start.length - 4)
    const vvkk = start.substring(start.length - 4)
    const kirjauksenKuukausi = this._dateService.numberToLocalMonth(Number(vvkk))
    await this._raportointiKirjausValittiin(null, arvot.kirjausnumero, kirjauksenKuukausi, maksutavanTunniste)
  }

  private async _vaihdaKirjauksenSivuTarvittaessa(kirjausnumero: string, maksutavanTunniste: string) {
    const maksutapaJaKirjaukset = this.maksutavatJaKirjauksetMap.get(maksutavanTunniste)
    console.log('_vaihdaKirjauksenSivuTarvittaessa 1')
    if (maksutapaJaKirjaukset?.kirjaukset?.length > this.kirjauksiaPerSivuSubject.value) {
      console.log('_vaihdaKirjauksenSivuTarvittaessa 2')
      const pageIndex = this._laskeKirjauksenSivu(kirjausnumero, this.kirjauksiaPerSivuSubject.value)
      if (pageIndex !== undefined && pageIndex !== null) {
        console.log('_vaihdaKirjauksenSivuTarvittaessa 3')
        const pageEvent: PageEvent = {
          pageIndex: pageIndex,
          pageSize: this.kirjauksiaPerSivuSubject.value,
          length: maksutapaJaKirjaukset.kirjaukset.length,
        }
        await this.vaihdaSivu(pageEvent)
      }
    }
  }

  private _laskeKirjauksenSivu(kirjausnumero: string, pageSize: number): number | null {
    const numeroString = kirjausnumero.split('-')[1]
    if (this._currencyService.onkoMerkkijonoKokonaisluku(numeroString)) {
      const numero = this._currencyService.muutaMerkkijonoNumeroksi(numeroString, 0)
      return Math.floor((numero - 1) / pageSize)
    }
    return null
  }

  async vaihdaSivu(event: PageEvent) {
    console.log('vaihdaSivu 1', event.pageIndex, event.pageSize, event.length)
    if (this.paginator) {
      console.log('vaihdaSivu 2')
      if (this.paginator.pageIndex !== event.pageIndex) {
        console.log('vaihdaSivu 3')
        this.paginator.pageIndex = event.pageIndex
      }
      if (this.paginator.pageSize !== event.pageSize) {
        console.log('vaihdaSivu 4')
        this.paginator.pageSize = event.pageSize
      }
    }
    if (this.valittuSivuSubject.value.sivu !== event.pageIndex + 1) {
      console.log('vaihdaSivu 5', event.pageIndex + 1)
      this.valittuSivuSubject.value.sivu = event.pageIndex + 1
      this.valittuSivuSubject.next(this.valittuSivuSubject.value)
    }
    if (this.kirjauksiaPerSivuSubject.value !== event.pageSize) {
      console.log('vaihdaSivu 6')
      this.kirjauksiaPerSivuSubject.next(event.pageSize)
    }
    // Give the system a bit time to render the changes.
    await this.sleep(10)
  }

  trackByKirjausAvainAndUpdateTime(index: number, item: NaytettavaKirjaus) {
    return item.kirjaus.avain + '_' + item.kirjaus.kirjausTallennettu?.toMillis()
  }

  private async odotaKirjauksenIlmestymista(kirjauksenAvain: string): Promise<HTMLDivElement> {
    const query = 'div[data-kirjausavain="' + kirjauksenAvain + '"]'
    return this._waitUntilElementVisible(query)
  }

  private async odotaKirjauksenIlmestymistaKirjausnumerolla(kirjausnumero: string): Promise<HTMLDivElement> {
    const query = 'div[data-kirjausnumero="' + kirjausnumero + '"]'
    return this._waitUntilElementVisible(query)
  }

  private async _waitUntilElementVisible(query: string): Promise<HTMLDivElement> {
    const maxRetries = 200 // 200 * 50ms = 10000ms = 10s
    for (let i = 0; i < maxRetries; i++) {
      const div: HTMLDivElement = document.querySelector(query)
      if (div) {
        await this.sleep(5)
        return div
      }
      await this.sleep(50)
    }
    return null
  }

  private async vaihdaMaksutapaJosTarvitseeJaKohdistaKirjaukseenKirjausnumerolla(kirjausnumerolla: string, maksutavanTunniste: string) {
    const valittuMaksutapa = this._valittuMaksutapaSubject.value
    if (!valittuMaksutapa || valittuMaksutapa.tunniste + '' !== maksutavanTunniste) {
      const maksutapaJaKirjaukset = this.maksutavatJaKirjauksetMap.get(maksutavanTunniste)
      if (maksutapaJaKirjaukset) {
        if (await this._vaihdaValittuMaksutapaInternal(maksutapaJaKirjaukset, this._kirjauksetMaksutavoittainTabeilleSubject.value)) {
          this._kirjauksetMaksutavoittainTabeilleSubject.next(this._kirjauksetMaksutavoittainTabeilleSubject.value)
          this._kirjauksetMaksutavoittainSubject.next(this._kirjauksetMaksutavoittainSubject.value)
        }
        await this._vaihdaKirjauksenSivuTarvittaessa(kirjausnumerolla, maksutavanTunniste)
        await this.odotaKirjauksenIlmestymistaKirjausnumerolla(kirjausnumerolla)
        await this.sleep(10)
        await this.vaihdaValittuKirjausKirjausnumerolla(kirjausnumerolla, true)
      }
    } else {
      await this._vaihdaKirjauksenSivuTarvittaessa(kirjausnumerolla, maksutavanTunniste)
      await this.odotaKirjauksenIlmestymistaKirjausnumerolla(kirjausnumerolla)
      await this.sleep(10)
      await this.vaihdaValittuKirjausKirjausnumerolla(kirjausnumerolla, true)
    }
  }

  private async vaihdaMaksutapaJosTarvitseeJaKohdistaKirjaukseen(kirjauksenAvain: string, maksutavanTunniste: string) {
    console.log('a1')
    const valittuMaksutapa = this._valittuMaksutapaSubject.value
    if (maksutavanTunniste && (!valittuMaksutapa || valittuMaksutapa.tunniste + '' !== maksutavanTunniste)) {
      const maksutapaJaKirjaukset = this.maksutavatJaKirjauksetMap.get(maksutavanTunniste)
      console.log('a2')
      if (maksutapaJaKirjaukset) {
        console.log('a3')
        if (await this._vaihdaValittuMaksutapaInternal(maksutapaJaKirjaukset, this._kirjauksetMaksutavoittainTabeilleSubject.value)) {
          this._kirjauksetMaksutavoittainTabeilleSubject.next(this._kirjauksetMaksutavoittainTabeilleSubject.value)
          this._kirjauksetMaksutavoittainSubject.next(this._kirjauksetMaksutavoittainSubject.value)
        }
        const valittuKirjaus = this._kirjausMap.get(kirjauksenAvain)
        if (valittuKirjaus) {
          console.log('a4')
          await this._vaihdaKirjauksenSivuTarvittaessa(valittuKirjaus.kirjaus.kirjausnumero, maksutavanTunniste)
        }
        await this._odotaKirjauksenIlmestymistaJaAktivoiSe(kirjauksenAvain)
      }
    } else {
      console.log('a10')
      const valittuKirjaus = this._kirjausMap.get(kirjauksenAvain)
      if (valittuKirjaus) {
        console.log('a11')
        await this._vaihdaKirjauksenSivuTarvittaessa(valittuKirjaus.kirjaus.kirjausnumero, maksutavanTunniste)
      }
      await this._odotaKirjauksenIlmestymistaJaAktivoiSe(kirjauksenAvain)
    }
  }

  private async _odotaKirjauksenIlmestymistaJaAktivoiSe(kirjauksenAvain: string) {
    const element = await this.odotaKirjauksenIlmestymista(kirjauksenAvain)
    // await this.sleep(250)
    if (element) {
      console.log('a5', kirjauksenAvain)
      await this._aktivoiKirjausJaKohdistaFokusViimeiseenTiliboksiin(element, true)
    } else {
      console.log('a6', kirjauksenAvain)
      await this.vaihdaValittuKirjausKirjausavaimella(kirjauksenAvain, true)
    }
  }

  async tallennaMuistiinpanot(value: string) {
    // console.log('Muistiinpanot:', value)
    this._muistiinpanojaTallennetaanSubject.next(true)
    firstValueFrom(this._asiakasService.nykyinenAsiakasObservable)
      .then(asiakas => {
        return this._asiakasService.tallennaKirjanpidonMuistiinpano(asiakas, value)
      })
      .then(() => {
        this._muistiinpanojaTallennetaanSubject.next(false)
      })
      .catch(error => {
        this._muistiinpanojaTallennetaanSubject.next(false)
        this._errorHandler.handleError(error)
      })
  }

  // private async odotaElementtiaJaKohdista(arvoavain: string, scrollaa: boolean): Promise<void> {
  //   return this._ngZone.runOutsideAngular(async () => {
  //     const query = '[data-arvoavain="' + arvoavain + '"]'
  //     let element: HTMLElement = document.querySelector(query)
  //     let i = 0
  //     while (!element) {
  //       if (i > 100) { return }
  //       await this.sleep(50)
  //       element = document.querySelector(query)
  //       i++
  //     }
  //     await this._aktivoiKirjausJaKohdistaFokusViimeiseenTiliboksiin(element.parentElement.parentElement as HTMLElement, scrollaa)
  //   })
  // }

  private tarkistaOnkoValittuKirjausNakyvissa(): Promise<void> {
    return this.sleep(100).then(async () => {
      const query = '.kl.valittu'
      let kirjaus: HTMLElement = document.querySelector(query)
      let i = 0
      while (!kirjaus) {
        if (i > 100) {
          return
        }
        await this.sleep(50)
        kirjaus = document.querySelector(query)
        i++
      }
      const bounding = kirjaus.getBoundingClientRect()
      if (bounding.top < 0 || bounding.bottom > window.innerHeight) {
        this.scrollaaKirjausNakyviin(kirjaus)
      }
    })
  }

  async vaihdaValittuMaksutapa(maksutapaJaKirjaukset: MaksutapaJaKirjaukset): Promise<void> {
    console.log('vaihdaValittuMaksutapa 1')
    if (await this._vaihdaValittuMaksutapaInternal(maksutapaJaKirjaukset, this._kirjauksetMaksutavoittainTabeilleSubject.value)) {
      console.log('vaihdaValittuMaksutapa 2')
      this._kirjauksetMaksutavoittainTabeilleSubject.next(this._kirjauksetMaksutavoittainTabeilleSubject.value)
      this._kirjauksetMaksutavoittainSubject.next(this._kirjauksetMaksutavoittainSubject.value)
    }
    if (this.valittuSivuSubject.value.sivu !== 1 || !this.valittuSivuSubject.value.aktivoiEnsimmainen) {
      this.valittuSivuSubject.value.sivu = 1
      this.valittuSivuSubject.value.aktivoiEnsimmainen = true
      this.valittuSivuSubject.next(this.valittuSivuSubject.value)
    }
  }

  private async _vaihdaValittuMaksutapaInternal(maksutapaJaKirjaukset: MaksutapaJaKirjaukset, maksutavatJaKirjaukset: MaksutapaJaKirjaukset[]): Promise<boolean> {
    this.poistaValittuNaytettavaKirjaus()
    this.vaihdaValittuTab('maksutapa')

    let paivita = false
    for (const mjk of maksutavatJaKirjaukset) {
      const valittu = mjk.maksutapa.avain === maksutapaJaKirjaukset.maksutapa.avain
      if (mjk.valittu !== valittu) {
        mjk.valittu = valittu
        paivita = true
      }
    }
    if (this._valittuMaksutapaSubject.value?.avain !== maksutapaJaKirjaukset.maksutapa.avain) {
      this._valittuMaksutapaSubject.next(maksutapaJaKirjaukset.maksutapa)
    }

    return paivita
  }

  private async _aktivoiEnsimmaistaKertaa(kuukausiJaLataustiedot: KuukausiJaLataustiedot, maksutavoittain: MaksutapaJaKirjaukset[]): Promise<boolean> {
    // Jos on jo aktiivisena, älä aktivoi toista kertaa.
    if (this._valittuNaytettavaKirjausSubject.value && !kuukausiJaLataustiedot.lataustiedot.preselectedMaksutapaTunniste) {
      return
    }

    // Jos tietty maksutapa on pyydetty aktivoitavaksi, käytä sitä.
    if (kuukausiJaLataustiedot.lataustiedot.preselectedMaksutapaTunniste) {
      const preselected: MaksutapaJaKirjaukset = maksutavoittain.find(a => {
        return a.maksutapa.tunniste + '' === kuukausiJaLataustiedot.lataustiedot.preselectedMaksutapaTunniste
      })
      if (preselected) {
        console.log('Löytyi preselected maksutapa')
        return this._vaihdaValittuMaksutapaInternal(preselected, maksutavoittain)
      }
    }

    // Aktivoidaan ensimmäinen käsittelemätön kirjaus, jos sellainen löytyy
    const ekaKasittelematta: MaksutapaJaKirjaukset = maksutavoittain.find(a => {
      return a.kirjaukset.findIndex(b => !b.kirjaus.kirjanpitajaHyvaksynyt) > -1
    })
    if (ekaKasittelematta) {
      if (!kuukausiJaLataustiedot.lataustiedot.preselectedKirjausAvain && !kuukausiJaLataustiedot.lataustiedot.preselectedKirjausnumero) {
        const eka = ekaKasittelematta.kirjaukset.find(b => !b.kirjaus.kirjanpitajaHyvaksynyt)
        if (eka) {
          kuukausiJaLataustiedot.lataustiedot.preselectedKirjausAvain = eka.kirjaus.avain
        }
      }
      console.log('Löytyi eka käsittelemättä')
      return this._vaihdaValittuMaksutapaInternal(ekaKasittelematta, maksutavoittain)
    }

    const [ilmoitusMuutoksia, naytaVeroilmoitusValilehti] = await firstValueFrom(combineLatest([this.yhdistettyStatusObservable, this.naytaVeroilmoitusValilehtiObservable]))

    // Aktivoidaan ilmoitukset välilehti, jos ALV-ilmo tai yhteisömyynti-ilmo on lähettämättä tai tarvitsee
    // uudelleen lähetyksen
    if (ilmoitusMuutoksia === 'yes' || ilmoitusMuutoksia === 'not-saved-yet') {
      console.log('Aktivoi ilmoitukset')
      this.vaihdaIlmoituksiin()
      return false
    }

    // Aktivoidaan Lähetä välilehti, jos on jo kaikki hyväksytty + ilmoitukset lähetetty,
    // mutta sähköpostia ei ole lähetetty
    if (!this.onkoSpostejaLahetetty) {
      console.log('Vaihda lähetykseen')
      this.vaihdaLahetaNakymaan()
      return false
    }

    if (naytaVeroilmoitusValilehti) {
      console.log('Vaihda veroilmoitukseen')
      this.vaihdaVeroilmoitukseen()
      return false
    }

    // Jos kaikki on jo käsitelty, aktivoidaan ensimmäinen kirjaus
    const ekaKasitelty: MaksutapaJaKirjaukset = maksutavoittain.find(a => {
      return a.kirjaukset.findIndex(b => b.kirjaus.kirjanpitajaHyvaksynyt) > -1
    })
    if (ekaKasitelty) {
      console.log('Löytyi eka käsitelty')
      return this._vaihdaValittuMaksutapaInternal(ekaKasitelty, maksutavoittain)
    }

    // Aktivoi ensimmäinen maksutapa
    if (maksutavoittain.length > 0) {
      console.log('Aktivoidaan eka')
      return this._vaihdaValittuMaksutapaInternal(maksutavoittain[0], maksutavoittain)
    }
  }

  vaihdaIlmoituksiin() {
    this.poistaValittuNaytettavaKirjaus()
    this.poistaValittuMaksutapa()
    for (const mjk of this._kirjauksetMaksutavoittainSubject.value.mjk) {
      mjk.valittu = false
    }
    this.vaihdaValittuTab('ilmoitukset')
  }

  vaihdaLahetaNakymaan() {
    // this.poistaValittuNaytettavaKirjaus()
    // this.poistaValittuMaksutapa()
    // for (const mjk of this._kirjauksetMaksutavoittainSubject.value.mjk) {
    //   mjk.valittu = false
    // }
    // this.vaihdaValittuTab('laheta')
    // setTimeout(() => {
    //   if (this.kirjanpitoLahetysComponent) {
    //     this.kirjanpitoLahetysComponent.focus()
    //   }
    //   setTimeout(() => {
    //     this._changeDetectorRef.markForCheck()
    //   }, 35)
    // }, 10)
  }

  vaihdaVeroilmoitukseen() {
    this.poistaValittuNaytettavaKirjaus()
    this.poistaValittuMaksutapa()
    for (const mjk of this._kirjauksetMaksutavoittainSubject.value.mjk) {
      mjk.valittu = false
    }
    this.vaihdaValittuTab('vero')
  }

  private poistaValittuMaksutapa() {
    if (this._valittuMaksutapaSubject !== null) {
      this._valittuMaksutapaSubject.next(null)
    }
  }

  private vaihdaValittuTab(valittuTab: TabTyypit) {
    if (this._valittuTabSubject.value !== valittuTab) {
      this._valittuTabSubject.next(valittuTab)
      window.scrollTo({ top: 0, behavior: 'auto' })
    }
  }

  maksutavatJoissaOnKirjaamattomiaTositteitaMuuttui(maksutavat: AsiakkaanMaksutapa[]) {
    let change = maksutavat.length !== this._maksutavatJoissaOnKirjaamattomiaTositteitaSubject.value.length
    if (!change) {
      for (const maksutapa of maksutavat) {
        if (this._maksutavatJoissaOnKirjaamattomiaTositteitaSubject.value.findIndex(a => a.avain === maksutapa.avain) < 0) {
          change = true
          break
        }
      }
    }
    if (change) {
      this._maksutavatJoissaOnKirjaamattomiaTositteitaSubject.next(maksutavat)
    }
  }

  private _getBankBalanceAlgo(maksutapa: AsiakkaanMaksutapa) {
    if (maksutapa.bankBalanceCalcAlgorithm) {
      return maksutapa.bankBalanceCalcAlgorithm
    }
    return maksutapa.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.AIIA ? BankBalanceCalcAlgorithm.AIIA_OLD : BankBalanceCalcAlgorithm.VERSION_ONE
  }

  private _annaMaksutapaJaKirjauksetMaksutavalle(maksutapa: AsiakkaanMaksutapa, valittuKuukausi: LocalMonth): MaksutapaJaKirjaukset {
    const maksutapaJaKirjaukset: MaksutapaJaKirjaukset = {
      kasiteltyja: 0,
      kasittelematta: 0,
      maksutapa: maksutapa,
      maksutavanKuva: this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + maksutapa.base64Kuva),
      kirjaukset: [],
      naytaLisaa: this._naytetaankoMaksutavalleLisaaJaPoistaNappi(maksutapa, valittuKuukausi),
      valittu: false,
      sivutetutKirjaukset: [],
    }
    return maksutapaJaKirjaukset
  }

  private _naytetaankoMaksutavalleLisaaJaPoistaNappi(maksutapa: AsiakkaanMaksutapa, valittuKuukausi: LocalMonth): boolean {
    if (this._tilikausiLukossa || !maksutapa) {
      return false
    }
    if (maksutapa.tunniste === AsiakkaanMaksutavat.MAKSUTAPA_AUTOMAATTISET_JAKSOTUKSET.tunniste) {
      return false
    }
    return (
      maksutapa.kirjauksienLuontityyppi === KirjauksienLuontityyppi.KASIN_SYOTETTAVA_TILIOTE ||
      maksutapa.kirjauksienLuontityyppi === KirjauksienLuontityyppi.TOSITTEISTA_GENEROITAVA_TILIOTE || // Allow accountants to create kirjaukset BEFORE the start date of the electronic bank connection in case the maksutapa type was Luodaan tositteista before that.
      ((maksutapa.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.AIIA || maksutapa.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.WEB_SERVICES) &&
        !!maksutapa.tilitapahtumatSynkronoidaanAlkaen &&
        this._dateService.compareLocalMonths(maksutapa.tilitapahtumatSynkronoidaanAlkaen, '>', valittuKuukausi))
    )
  }

  private _varmistaMaksutavat(maksutavat: AsiakkaanMaksutapa[], valittuKuukausi: LocalMonth) {
    for (const maksutapa of maksutavat) {
      const olemassaOleva = this.maksutavatJaKirjauksetMap.get(maksutapa.tunniste + '')
      if (olemassaOleva) {
        olemassaOleva.naytaLisaa = this._naytetaankoMaksutavalleLisaaJaPoistaNappi(maksutapa, valittuKuukausi)
      } else {
        const maksutapaJaKirjaukset = this._annaMaksutapaJaKirjauksetMaksutavalle(maksutapa, valittuKuukausi)
        this.maksutavatJaKirjauksetMap.set(maksutapa.tunniste + '', maksutapaJaKirjaukset)
      }
    }
  }

  private poistaKirjausMaksutavasta(naytettavaKirjaus: NaytettavaKirjaus) {
    const olemassaOleva = this.maksutavatJaKirjauksetMap.get(naytettavaKirjaus.kirjaus.maksutavanTunniste)
    if (olemassaOleva) {
      const index = olemassaOleva.kirjaukset.indexOf(naytettavaKirjaus)
      if (index > -1) {
        olemassaOleva.kirjaukset.splice(index, 1)
      }
    }
  }

  private _paivitaLukituksetJaMapit(naytettavaKirjaus: NaytettavaKirjaus, maksutapa: AsiakkaanMaksutapa, valittuKuukausi: LocalMonth) {
    this._kirjausMap.set(naytettavaKirjaus.kirjaus.avain, naytettavaKirjaus)
    if (naytettavaKirjaus.naytettavatKirjausrivit && naytettavaKirjaus.naytettavatKirjausrivit.length > 0) {
      let riviIndex = 0
      const kirjausOnLukittu = this.onkoKirjausLukittu(naytettavaKirjaus.kirjaus)
      const alku = maksutapa.tunniste + '_' + naytettavaKirjaus.kirjaus.avain + '_'
      for (const rivi of naytettavaKirjaus.naytettavatKirjausrivit) {
        rivi.tunniste = alku + riviIndex
        this._riviMap.set(rivi.tunniste, rivi)
        if (!rivi.lukittu) {
          if (this._allKirjauksetAndAccountsCanBeEdited.value) {
            rivi.lukittu = false
          } else {
            rivi.lukittu = this._tilikausiLukossa || kirjausOnLukittu || this._onkoRiviLukittuMaksutavanTakia(riviIndex, rivi, maksutapa, valittuKuukausi) || this.onkoNaytettavariviAlvrivi(rivi)
          }
        }
        riviIndex++
      }
    }
  }

  private _asetaKirjausMaksutapaan(naytettavaKirjaus: NaytettavaKirjaus, valittuKuukausi: LocalMonth) {
    const olemassaOleva = this.maksutavatJaKirjauksetMap.get(naytettavaKirjaus.kirjaus.maksutavanTunniste)
    if (olemassaOleva) {
      // Do not change the order of these, kirjaus.naytaPoisto is used to determine naytaSiirra & naytaKopioi as well
      this._paivitaNaytaPoisto(olemassaOleva, naytettavaKirjaus)

      this._paivitaLukituksetJaMapit(naytettavaKirjaus, olemassaOleva.maksutapa, valittuKuukausi)
      const index = olemassaOleva.kirjaukset.indexOf(naytettavaKirjaus)
      if (index > -1) {
        olemassaOleva.kirjaukset[index] = naytettavaKirjaus
      } else {
        olemassaOleva.kirjaukset.push(naytettavaKirjaus)
      }
    } else {
      const maksutapa = this._kaikkiMaksutavatMap.get(naytettavaKirjaus.kirjaus.maksutavanTunniste)
      const maksutapaJaKirjaukset = this._annaMaksutapaJaKirjauksetMaksutavalle(maksutapa, valittuKuukausi)

      // Do not change the order of these, kirjaus.naytaPoisto is used to determine naytaSiirra & naytaKopioi as well
      this._paivitaNaytaPoisto(maksutapaJaKirjaukset, naytettavaKirjaus)

      this._paivitaLukituksetJaMapit(naytettavaKirjaus, maksutapa, valittuKuukausi)
      maksutapaJaKirjaukset.kirjaukset.push(naytettavaKirjaus)
      this.maksutavatJaKirjauksetMap.set(naytettavaKirjaus.kirjaus.maksutavanTunniste, maksutapaJaKirjaukset)
    }

    this._paivitaNaytaSiirra(naytettavaKirjaus)
    this._paivitaNaytaKopioi(naytettavaKirjaus)
  }

  private _paivitaNaytaPoisto(maksutapaJaKirjaukset: MaksutapaJaKirjaukset, naytettavaKirjaus: NaytettavaKirjaus) {
    if (maksutapaJaKirjaukset.maksutapa?.tunniste === MAKSUTAPA_AUTOMAATTISET_JAKSOTUKSET.tunniste) {
      naytettavaKirjaus.naytaPoisto = true
    } else if (maksutapaJaKirjaukset.naytaLisaa && (!naytettavaKirjaus.lukittu || naytettavaKirjaus.kirjaus.avain.startsWith('alv_automaattikirjaus'))) {
      naytettavaKirjaus.naytaPoisto = true
    } else {
      delete naytettavaKirjaus.naytaPoisto
    }
  }

  private _paivitaNaytaSiirra(naytettavaKirjaus: NaytettavaKirjaus) {
    if (
      !naytettavaKirjaus.naytaPoisto &&
      naytettavaKirjaus.kirjaus.t !== 'b' &&
      naytettavaKirjaus.kirjaus.maksutavanTunniste !== '' + AsiakkaanMaksutavat.MAKSUTAPA_AUTOMAATTISET_JAKSOTUKSET.tunniste
    ) {
      naytettavaKirjaus.naytaSiirra = true
    } else {
      delete naytettavaKirjaus.naytaSiirra
    }
  }

  private _paivitaNaytaKopioi(naytettavaKirjaus: NaytettavaKirjaus) {
    if (
      !naytettavaKirjaus.naytaPoisto &&
      !naytettavaKirjaus.kirjaus.avain?.includes('_palkat_') &&
      naytettavaKirjaus.kirjaus.maksutavanTunniste !== '' + AsiakkaanMaksutavat.MAKSUTAPA_AUTOMAATTISET_JAKSOTUKSET.tunniste
    ) {
      naytettavaKirjaus.naytaKopioi = true
    } else {
      delete naytettavaKirjaus.naytaKopioi
    }
  }

  private asetaKirjausValimuistiin(naytettavaKirjaus: NaytettavaKirjaus) {
    this.naytettavatKirjauksetByKirjausavainMap.set(naytettavaKirjaus.kirjaus.avain, naytettavaKirjaus)
  }

  private etsiKirjausCachestaKirjauksella(kirjaus: Kirjaus): NaytettavaKirjaus | null {
    return this.naytettavatKirjauksetByKirjausavainMap.get(kirjaus.avain) ?? null
  }

  // private paivitaInflightSaveNaytettavaKirjausKirjauksesta(naytettavaKirjaus: NaytettavaKirjaus, kirjaus: Kirjaus) {

  //   // We will use the kirjausrivit from the current kirjaus, so take those now
  //   kirjaus.rivit = naytettavaKirjaus.kirjaus.rivit

  //   naytettavaKirjaus.kirjaus = kirjaus
  //   naytettavaKirjaus.tilitapahtumanPvm = this._dateService.muotoilePaikallinenPaiva(this._dateService.timestampToLocalDate(kirjaus.p), 'fi')
  //   naytettavaKirjaus.tilitapahtumanSumma = this._currencyService.formatoiRaha(kirjaus.kirjauksenSumma, 'EUR', 'fi')
  //   naytettavaKirjaus.tilitapahtumanViitenumero = kirjaus.kirjauksenViitenumero
  //   naytettavaKirjaus.tallennustiedot = this.annaKirjauksenTallennustiedot(kirjaus)
  //   naytettavaKirjaus.nykyisenVersionTimestamp = kirjaus.kirjausTallennettu
  //   naytettavaKirjaus.edellisiaVersioita = !!kirjaus.versioita
  //   naytettavaKirjaus.seuraaviaVersioita = false

  //   naytettavaKirjaus.latauksenAikainenTila = this.kopioiNaytettavaKirjausIlmanKuvaCachea(naytettavaKirjaus)

  // }

  private paivitaNaytettavaKirjausKirjauksesta(naytettavaKirjaus: NaytettavaKirjaus, kirjaus: Kirjaus) {
    // const naytettavatKuitit = this.annaPaivitetytNaytettavatKuititKirjauksesta(naytettavaKirjaus, kirjaus)

    if (naytettavaKirjaus.tallentamattomiaMuutoksia) {
      kirjaus.rivit = naytettavaKirjaus.kirjaus.rivit
      naytettavaKirjaus.kirjaus = kirjaus
    } else {
      const kirjauksenRivit: NaytettavaKirjausrivi[] = []
      let debetYhteensa = 0
      let kreditYhteensa = 0
      for (const rivi of kirjaus.rivit) {
        debetYhteensa += rivi.d ? rivi.d : 0
        kreditYhteensa += rivi.k ? rivi.k : 0

        const naytettavaRivi: NaytettavaKirjausrivi = this.luoNaytettavaKirjausriviKirjausrivista(rivi)

        this.paivitaNaytettavanRivinLukitustiedot(naytettavaKirjaus.kirjaus, naytettavaRivi)

        kirjauksenRivit.push(naytettavaRivi)
      }

      debetYhteensa = this._currencyService.roundHalfUp(debetYhteensa, 2)
      kreditYhteensa = this._currencyService.roundHalfUp(kreditYhteensa, 2)

      // console.log('Luodaan')
      if (debetYhteensa !== kreditYhteensa) {
        // console.log('Lisätään', debetYhteensa, kreditYhteensa)
        const uusiKirjausrivi: Kirjausrivi = {
          av: this._lemonatorFirebase.firestoreCreateId(),
          a: null,
          d: null,
          k: null,
          t: null,
        }
        const erotus = this._currencyService.roundHalfUp(debetYhteensa - kreditYhteensa, 2)
        if (erotus > 0) {
          // debet on suurempi, lisää kreditiin
          uusiKirjausrivi.k = erotus
        } else if (erotus < 0) {
          // debet on pienempi, lisää debettiin
          uusiKirjausrivi.d = Math.abs(erotus)
        }
        debetYhteensa += uusiKirjausrivi.d ? uusiKirjausrivi.d : 0
        kreditYhteensa += uusiKirjausrivi.k ? uusiKirjausrivi.k : 0

        const naytettavaRivi: NaytettavaKirjausrivi = this.luoNaytettavaKirjausriviKirjausrivista(uusiKirjausrivi)

        this.paivitaNaytettavanRivinLukitustiedot(naytettavaKirjaus.kirjaus, naytettavaRivi)

        kirjaus.rivit.push(uusiKirjausrivi)
        kirjauksenRivit.push(naytettavaRivi)
      }

      naytettavaKirjaus.naytettavatKirjausrivit = kirjauksenRivit
      naytettavaKirjaus.debetyhteensa = this._currencyService.formatoiRahaIlmanValuuttaSymbolia(debetYhteensa, 'fi')
      naytettavaKirjaus.kredityhteensa = this._currencyService.formatoiRahaIlmanValuuttaSymbolia(kreditYhteensa, 'fi')
    }

    naytettavaKirjaus.kirjaus = kirjaus
    naytettavaKirjaus.tilitapahtumanPvm = this._dateService.muotoileNumberPaiva(kirjaus.p, 'fi')
    naytettavaKirjaus.tilitapahtumanSumma = this._currencyService.formatoiRaha(kirjaus.kirjauksenSumma, kirjaus.kirjauksenValuuttaTilitapahtumasta ?? 'EUR', 'fi')

    // Update conversion info
    naytettavaKirjaus.kirjausKonversioTiedot = this.annaKirjauksenKonversioTiedot(kirjaus)

    naytettavaKirjaus.tallennustiedot = this.annaKirjauksenTallennustiedot(kirjaus)
    naytettavaKirjaus.nykyisenVersionTimestamp = kirjaus.kirjausTallennettu
    naytettavaKirjaus.edellisiaVersioita = !!kirjaus.versioita
    naytettavaKirjaus.seuraaviaVersioita = false

    naytettavaKirjaus.latauksenAikainenTila = this.kopioiNaytettavaKirjausIlmanKuvaCachea(naytettavaKirjaus)
  }

  private paivitaNaytettavanRivinLukitustiedot(kirjaus: Kirjaus, naytettavaRivi: NaytettavaKirjausrivi) {
    if (naytettavaRivi.kredit) {
      naytettavaRivi.debetlukittu = true
      naytettavaRivi.kreditlukittu = false
    } else if (naytettavaRivi.debet) {
      naytettavaRivi.debetlukittu = false
      naytettavaRivi.kreditlukittu = true
    }

    if (this._allKirjauksetAndAccountsCanBeEdited.value) {
      naytettavaRivi.lukittu = false
    } else {
      naytettavaRivi.lukittu = this._tilikausiLukossa || this.onkoKirjausLukittu(kirjaus) || this.onkoNaytettavariviAlvrivi(naytettavaRivi)
    }
  }

  private _onkoRiviLukittuMaksutavanTakia(index: number, naytettavaRivi: NaytettavaKirjausrivi, maksutapa: AsiakkaanMaksutapa, valittuKuukausi: LocalMonth): boolean {
    if (
      index === 0 &&
      this._kirjanpitoJaettuService.onkoMaksutapaSahkoinenTiliote(maksutapa) &&
      naytettavaRivi.tilinumero === maksutapa.oletusVastatili && // Allow accountants to create kirjaukset BEFORE the start date of the electronic bank connection in case the maksutapa type was Luodaan tositteista before that.
      ((maksutapa.sahkoisenTiliotteenAlatyyppi !== SahkoisenTiliotteenAlatyyppi.AIIA &&
        maksutapa.sahkoisenTiliotteenAlatyyppi !== SahkoisenTiliotteenAlatyyppi.WEB_SERVICES &&
        maksutapa.sahkoisenTiliotteenAlatyyppi !== SahkoisenTiliotteenAlatyyppi.HOLVI_API &&
        maksutapa.sahkoisenTiliotteenAlatyyppi !== SahkoisenTiliotteenAlatyyppi.ENABLE_BANKING) ||
        this._dateService.compareLocalMonths(maksutapa.tilitapahtumatSynkronoidaanAlkaen, '<=', valittuKuukausi))
    ) {
      return true
    }
    return false
  }

  private luoNaytettavaKirjausKirjauksesta(kirjaus: Kirjaus): NaytettavaKirjaus {
    const kirjauksenRivit: NaytettavaKirjausrivi[] = []
    let debetYhteensa = 0
    let kreditYhteensa = 0
    if (kirjaus.rivit) {
      for (const rivi of kirjaus.rivit) {
        debetYhteensa += rivi.d ? rivi.d : 0
        kreditYhteensa += rivi.k ? rivi.k : 0
        const maaritys = this._kaikkiAlvMaarityksetMap.get(rivi.a)
        const tili = this._kaikkiTilitMap.get(rivi.t) ?? null
        const naytettavaRivi: NaytettavaKirjausrivi = {
          kirjausrivi: rivi,
          // NOTE! Needs the parenthesis to work properly!
          alvlukittu: this._asiakkaanAlvtLukossa || tili?.alvTyyppi === KirjanpitotilinAlvTyyppi.EI_ALV_KASITTELYA,
          alv: maaritys ? maaritys.lyhenne : '',
          debet: this._currencyService.formatoiRahaIlmanValuuttaSymbolia(rivi.d, 'fi'),
          kredit: this._currencyService.formatoiRahaIlmanValuuttaSymbolia(rivi.k, 'fi'),
          kommentti: rivi.s || '',
          tilinimi: tili ? this._tilikarttaJaettuService.annaKirjanpitotilinNimi(tili, 'fi') : '',
          tilinumero: tili ? tili.numero : '',
          lukittu: false,
          debetlukittu: false,
          kreditlukittu: false,
          alvvirhe: false,
          debetvirhe: false,
          kreditvirhe: false,
          tilivirhe: false,
          knTabIndexPoistettu: false,
          tunniste: null,
        }

        this.asetaProjektiNaytettavaanRiviin(rivi, naytettavaRivi)

        kirjauksenRivit.push(naytettavaRivi)
        this.paivitaNaytettavanRivinLukitustiedot(kirjaus, naytettavaRivi)
      }
    }

    debetYhteensa = this._currencyService.roundHalfUp(debetYhteensa, 2)
    kreditYhteensa = this._currencyService.roundHalfUp(kreditYhteensa, 2)

    // console.log('Luodaan', debetYhteensa, kreditYhteensa)
    if (debetYhteensa !== kreditYhteensa && !this.onkoKirjausLukittu(kirjaus)) {
      // console.log('Lisätään', debetYhteensa, kreditYhteensa)
      const uusiKirjausrivi: Kirjausrivi = {
        av: this._lemonatorFirebase.firestoreCreateId(),
        a: null,
        d: null,
        k: null,
        t: null,
      }
      const erotus = this._currencyService.roundHalfUp(debetYhteensa - kreditYhteensa, 2)
      if (erotus > 0) {
        // debet on suurempi, lisää kreditiin
        uusiKirjausrivi.k = erotus
      } else if (erotus < 0) {
        // debet on pienempi, lisää debettiin
        uusiKirjausrivi.d = Math.abs(erotus)
      }
      debetYhteensa += uusiKirjausrivi.d ? uusiKirjausrivi.d : 0
      kreditYhteensa += uusiKirjausrivi.k ? uusiKirjausrivi.k : 0

      const naytettavaRivi: NaytettavaKirjausrivi = this.luoNaytettavaKirjausriviKirjausrivista(uusiKirjausrivi)

      this.paivitaNaytettavanRivinLukitustiedot(kirjaus, naytettavaRivi)

      if (!kirjaus.rivit) {
        kirjaus.rivit = []
      }
      kirjaus.rivit.push(uusiKirjausrivi)
      kirjauksenRivit.push(naytettavaRivi)
    }

    // const tapahtumanSumma = tapahtuma.creditDebitCode === 'CRDT' ? Number(tapahtuma.summa) : 0 - Number(tapahtuma.summa)
    const k: NaytettavaKirjaus = {
      kirjaus: kirjaus,
      tapahtuma: null,
      // naytettavatLiitetytKuitit: naytettavatKuitit,
      naytettavatKirjausrivit: kirjauksenRivit,
      tilitapahtumanPvm: this._dateService.muotoileNumberPaiva(kirjaus.p, 'fi'),
      tilitapahtumanSumma: this._currencyService.formatoiRaha(kirjaus.kirjauksenSumma, kirjaus.kirjauksenValuuttaTilitapahtumasta ?? 'EUR', 'fi'),
      debetyhteensa: this._currencyService.formatoiRahaIlmanValuuttaSymbolia(debetYhteensa, 'fi'),
      kredityhteensa: this._currencyService.formatoiRahaIlmanValuuttaSymbolia(kreditYhteensa, 'fi'),
      kirjauksenVirhe: null,
      tallennetaan: false,
      tallennustiedot: this.annaKirjauksenTallennustiedot(kirjaus),
      nykyisenVersionTimestamp: kirjaus.kirjausTallennettu,
      edellisiaVersioita: !!kirjaus.versioita,
      seuraaviaVersioita: false,
      seuraavaOnNykyinen: false,
      latauksenAikainenTila: null,
      tallentamattomiaMuutoksia: false,
      lukittu: this.onkoKirjausLukittu(kirjaus),
      kirjauksessaYhteisomyyntiVatKentta: this.kirjauksessaYhteisomyyntiVatKentta(kirjaus),
    }

    k.kirjausKonversioTiedot = this.annaKirjauksenKonversioTiedot(kirjaus)

    k.latauksenAikainenTila = this.kopioiNaytettavaKirjausIlmanKuvaCachea(k)

    return k
  }

  private annaKirjauksenKonversioTiedot(kirjaus: Kirjaus) {
    if (!kirjaus.valuuttakonversio?.kurssi?.rate) {
      return null
    }

    const kurssi = kirjaus.valuuttakonversio.kurssi.rate.toFixed(4)

    let aika = '?'
    if (kirjaus.valuuttakonversio.kurssi.ratedAt) {
      const kurssinAikaleima = this._dateService.numberTimestampToLocalDateTime(kirjaus.valuuttakonversio.kurssi.ratedAt)
      aika = this._dateService.muotoilePaivaJaAikaPaikallinen(kurssinAikaleima, 'fi')
    }

    const asTilitapahtumaConversion = kirjaus.valuuttakonversio as ValuuttakonversionTiedotTilitapahtumassa
    if (asTilitapahtumaConversion.alkuperainenSaldo && asTilitapahtumaConversion.alkuperainenSumma) {
      const alkuperainenSumma = this._currencyService.formatoiDesimaaliLisaaValilyontiTuhanteen(asTilitapahtumaConversion.alkuperainenSumma, 2, 2, 'fi')
      return `Tilitapahtuma: ${alkuperainenSumma} ${kirjaus.valuuttakonversio.lahdevaluutta} -> ${kirjaus.valuuttakonversio.kohdevaluutta} kurssilla ${kurssi} (${aika})`
    } else {
      return `Lasku: ${kirjaus.valuuttakonversio.lahdevaluutta} -> ${kirjaus.valuuttakonversio.kohdevaluutta} kurssilla ${kurssi} (${aika})`
    }
  }

  private luoNaytettavaKirjausriviKirjausrivista(rivi: Kirjausrivi) {
    const maaritys = this._kaikkiAlvMaarityksetMap.get(rivi.a)
    const tili = this._kaikkiTilitMap.get(rivi.t) ?? null
    const naytettavaRivi: NaytettavaKirjausrivi = {
      kirjausrivi: rivi,
      alv: maaritys ? maaritys.lyhenne : '',
      // NOTE! Needs the parenthesis to work properly!
      alvlukittu: this._asiakkaanAlvtLukossa || tili?.alvTyyppi === KirjanpitotilinAlvTyyppi.EI_ALV_KASITTELYA,
      debet: this._currencyService.formatoiRahaIlmanValuuttaSymbolia(rivi.d, 'fi'),
      kredit: this._currencyService.formatoiRahaIlmanValuuttaSymbolia(rivi.k, 'fi'),
      kommentti: rivi.s || '',
      tilinimi: tili ? this._tilikarttaJaettuService.annaKirjanpitotilinNimi(tili, 'fi') : '',
      tilinumero: tili ? tili.numero : '',
      lukittu: false,
      debetlukittu: false,
      kreditlukittu: false,
      alvvirhe: false,
      debetvirhe: false,
      kreditvirhe: false,
      tilivirhe: false,
      knTabIndexPoistettu: false,
      tunniste: null,
    }

    this.asetaProjektiNaytettavaanRiviin(rivi, naytettavaRivi)

    return naytettavaRivi
  }

  private asetaProjektiNaytettavaanRiviin(rivi: Kirjausrivi, naytettavaRivi: NaytettavaKirjausrivi) {
    if (rivi.pr) {
      const projekti: NaytettavaKirjanpidonProjekti = this._kirjanpidonProjektitMap.get(rivi.pr)
      if (projekti) {
        naytettavaRivi.projektiNayta = true
        naytettavaRivi.projektiNimi = projekti.projekti.nimi
        naytettavaRivi.projektiVariLuokka = 'a' + rivi.pr
        return
      }
    }
    if (this._kirjanpidonProjektitAktiivisia) {
      naytettavaRivi.projektiNayta = true
      delete naytettavaRivi.projektiNimi
      naytettavaRivi.projektiVariLuokka = 'kr-projekti-dot-empty'
    } else {
      delete naytettavaRivi.projektiNayta
      delete naytettavaRivi.projektiNimi
      delete naytettavaRivi.projektiVariLuokka
    }
  }

  /**
   * NOTE! IF YOU UPDATE THIS, UPDATE KirjanpitoJaettuService.onkoKirjausOk method too!
   * NOTE! THIS IS INTENTIONALLY KEPT FORMATTED AS CLOSE AS THE ONE IN KirjanpitoJaettuService!
   */
  private paivitaNaytettavanKirjauksenValidointi(naytettavaKirjaus: NaytettavaKirjaus): boolean {
    naytettavaKirjaus.kirjauksenVirhe = null

    const kirjaus = naytettavaKirjaus.kirjaus

    let palautettava = true

    // If no kirjaus or no rows, no go
    if (!kirjaus || !kirjaus.rivit || kirjaus.rivit.length < 1) {
      naytettavaKirjaus.kirjauksenVirhe = 'Kirjauksessa ei ole yhtään validia riviä.'
      palautettava = false
    } else {
      const kirjausOnJaksotus = kirjaus.jaksotus?.jaksotus === kirjaus.avain
      const kirjausOnJaksotuksenVastakirjaus = kirjaus.jaksotus?.jaksotuksenVastakirjaus === kirjaus.avain

      // let selvitettavatCount = 0
      for (let i = 0; i < kirjaus.rivit.length; i++) {
        const rivi = kirjaus.rivit[i]
        const naytettavaRivi = naytettavaKirjaus.naytettavatKirjausrivit[i]

        // Tili tarvitaan aina
        naytettavaRivi.tilivirhe = !rivi.t

        // Kreditistä ja debitistä tarvitaan vain toinen
        if (this._kirjanpitoJaettuService.arvoPuuttuu(rivi.d) && this._kirjanpitoJaettuService.arvoPuuttuu(rivi.k)) {
          naytettavaRivi.debetvirhe = this._kirjanpitoJaettuService.arvoOnVirheellinen(rivi.d)
          naytettavaRivi.kreditvirhe = this._kirjanpitoJaettuService.arvoOnVirheellinen(rivi.k)
        } else if (this._kirjanpitoJaettuService.arvoPuuttuu(rivi.d)) {
          naytettavaRivi.debetvirhe = false
          naytettavaRivi.kreditvirhe = this._kirjanpitoJaettuService.arvoOnVirheellinen(rivi.k)
        } else if (this._kirjanpitoJaettuService.arvoPuuttuu(rivi.k)) {
          naytettavaRivi.debetvirhe = this._kirjanpitoJaettuService.arvoOnVirheellinen(rivi.d)
          naytettavaRivi.kreditvirhe = false
        } else {
          naytettavaRivi.debetvirhe = true
          naytettavaRivi.kreditvirhe = true
        }

        // if (this._selvitettavatOstotTilitMap.has(naytettavaRivi.kirjausrivi.t)) {
        //   selvitettavatCount++
        //   if (!this._onkoHolviAsiakas) {
        //     if (!this._vahintaanYhdellaKayttajallaOlevatMaksutavatSet.has(naytettavaKirjaus.kirjaus.maksutavanTunniste)) {
        //       naytettavaKirjaus.kirjauksenVirhe = 'Kirjauksen vienti on merkitty selvitettäväksi, mutta maksutapa ei ole näkyvissä yhdelläkään käyttäjällä. Tästä syystä yksikään asiakkaan käyttäjistä ei näe selvitettävät pyyntöä Lemonaidissa. Käytä tiliä 1778 tai lisää maksutapa jollekin käyttäjälle.'
        //       palautettava = false
        //     }
        //   }
        // }

        // ALV kenttä tarvitaan, mikäli rivin tilin alv-tyyppi on myynti tai osto.
        const tili = this._kaikkiTilitMap.get(rivi.t) || null
        if (
          !kirjausOnJaksotus &&
          !kirjausOnJaksotuksenVastakirjaus &&
          tili &&
          !this._asiakkaanAlvtLukossa &&
          (tili.alvTyyppi === KirjanpitotilinAlvTyyppi.MYYNTI ||
            tili.alvTyyppi === KirjanpitotilinAlvTyyppi.ETAMYYNTI ||
            tili.alvTyyppi === KirjanpitotilinAlvTyyppi.ETAMYYNTI_EI_REKISTEROITYNYT ||
            tili.alvTyyppi === KirjanpitotilinAlvTyyppi.OSTO)
        ) {
          naytettavaRivi.alvvirhe = !rivi.a
        } else {
          naytettavaRivi.alvvirhe = false
        }

        // Päivitä palautettava kokonaisvirheindikaattori
        if (naytettavaRivi.tilivirhe || naytettavaRivi.debetvirhe || naytettavaRivi.kreditvirhe || naytettavaRivi.alvvirhe) {
          palautettava = false
        }
      }

      // if (selvitettavatCount > 1) {
      //   palautettava = false
      //   naytettavaKirjaus.kirjauksenVirhe = 'Voit käyttää 1777 vientiä vain kerran yhdessä kirjauksessa. Viennistä tehdään selvityskysely asiakkaalle. Jaa useammat selvitettävät asiat omiksi kirjauksikseen tai käytä 1778 tiliä.'
      // }
    }

    const summat = this._kirjanpitoJaettuService.annaKirjauksenSummat(naytettavaKirjaus?.kirjaus)
    if (summat.debet !== summat.kredit) {
      naytettavaKirjaus.kirjauksenVirhe = (naytettavaKirjaus.kirjauksenVirhe ? naytettavaKirjaus.kirjauksenVirhe + ' ' : '') + 'Kirjaus erottaa.'
      palautettava = false
    }

    if (summat.debet < 0.0) {
      naytettavaKirjaus.kirjauksenVirhe = (naytettavaKirjaus.kirjauksenVirhe ? naytettavaKirjaus.kirjauksenVirhe + ' ' : '') + 'Kirjauksen summa ei voi olla negatiivinen.'
      palautettava = false
    }

    return palautettava
  }

  private annaKirjauksenTallennustiedot(kirjaus: Kirjaus): string | null {
    let tiedot = ''
    if (kirjaus.kirjauksenLuoja) {
      const nimitiedot = this._kirjanpitajienNimitiedotMap.get(kirjaus.kirjauksenLuoja)
      tiedot += nimitiedot ? nimitiedot.etunimi + ' ' + nimitiedot.sukunimi : null
    }
    if (kirjaus.kirjausLuotu) {
      const date = this._dateService.timestampToDate(kirjaus.kirjausTallennettu ? kirjaus.kirjausTallennettu : kirjaus.kirjausLuotu)
      tiedot += ' ' + this._dateService.muotoilePaivaJaAikaDate(date, 'fi')
    }
    return tiedot.trim() || null
  }

  private onkoNaytettavaKirjausMuuttunut(kirjaus: NaytettavaKirjaus) {
    return !this.onkoNaytettavaKirjausMuuttumaton(kirjaus)
  }

  private merkkijonojenArvoOnSama(eka: string, toka: string) {
    const ekaArvo = eka ? eka.trim() : ''
    const tokaArvo = toka ? toka.trim() : ''
    return ekaArvo === tokaArvo
  }

  private onkoNaytettavaKirjausMuuttumaton(kirjaus: NaytettavaKirjaus): boolean {
    // Jos poistetaan, on muuttunut
    if (kirjaus.poistetaan) {
      return false
    }

    // Jos päivämäärä on muuttunut, on muuttunut
    if (kirjaus.uusiPaivamaara) {
      return false
    }

    if (kirjaus.uusiVat) {
      return false
    }

    if (kirjaus.uusiMaksutapa) {
      return false
    }

    if (kirjaus.uusiViitenumero) {
      return false
    }

    // Tarkista rivit
    const rivit1 = kirjaus.latauksenAikainenTila.naytettavatKirjausrivit
    const rivit2 = kirjaus.naytettavatKirjausrivit

    const maxRivit = Math.max(rivit1.length, rivit2.length)
    for (let i = 0; i < maxRivit; i++) {
      const rivi1 = rivit1.length > i ? rivit1[i] : null
      const rivi2 = rivit2.length > i ? rivit2[i] : null
      // const rivi2Edellinen = i > 0 && rivit2.length > i - 1 ? rivit2[i - 1] : null
      //   , rivi2Edellinen?.kirjausrivi
      if (rivi1 && !rivi2) {
        return false
      } else if (!rivi1 && rivi2 && !this.onkoRiviTyhja(rivi2.kirjausrivi)) {
        return false
      } else if (
        rivi1 &&
        rivi2 &&
        (!this.merkkijonojenArvoOnSama(rivi1.debet, rivi2.debet) ||
          !this.merkkijonojenArvoOnSama(rivi1.kredit, rivi2.kredit) ||
          !this.merkkijonojenArvoOnSama(rivi1.tilinumero, rivi2.tilinumero) ||
          !this.merkkijonojenArvoOnSama(rivi1.alv, rivi2.alv) ||
          !this.merkkijonojenArvoOnSama(rivi1.kommentti, rivi2.kommentti) ||
          (rivi1.kirjausrivi.pr || null) !== (rivi2.kirjausrivi.pr || null))
      ) {
        // console.log(rivi1.debet, '===', rivi2.debet, rivi1.kredit, '===', rivi2.kredit)
        return false
      }
    }

    // Tarkista koko kirjauksen kommentti
    // TODO: IMPLEMENT!!

    return true
  }

  // Kopiointi ei onnistu, jos kuvat ovat mukana.
  private kopioiNaytettavaKirjausIlmanKuvaCachea(kirjaus: NaytettavaKirjaus): NaytettavaKirjaus {
    // const kuvat = kirjaus.naytettavatLiitetytKuitit
    // delete kirjaus.naytettavatLiitetytKuitit
    const tallennustila = this._kopipoijaPalvelu.cloneObjectDeep(kirjaus)
    // kirjaus.naytettavatLiitetytKuitit = kuvat
    return tallennustila
  }

  private async _annaPoistokirjauksienLuontiasetukset(
    kirjaus: NaytettavaKirjaus,
    poistotilienMuutostiedot: PoistotilienMuutostiedot,
  ): Promise<PoistokirjauksienLuontiasetukset | 'ei-poistoja' | 'peruutettu'> {
    const automaattisenPoistonTilinKirjausRivit = kirjaus.kirjaus.rivit.filter(rivi => this._kaikkiTilitMap.get(rivi.t)?.poistotiedot)
    const uniikitAutomaattisenPoistonTilit = [...new Set(automaattisenPoistonTilinKirjausRivit.map(tili => tili.t))]

    if (uniikitAutomaattisenPoistonTilit.length > 1) {
      console.error('Virhetilanne, useampi poistotili samassa kirjauksessa!')
      const dialogData: InfoDialogData = {
        header: 'Kuukausittaiset poistokirjaukset',
        text: 'Kuukausittaisia poistokirjauksia ei voida luoda, sillä kirjauksessa on useampi automaattisen poiston tili.',
      }
      this._dialog.open(InfoDialog, { data: dialogData })
      return 'peruutettu'
    }

    if (automaattisenPoistonTilinKirjausRivit.length) {
      const poistettavaTili = automaattisenPoistonTilinKirjausRivit[0].t
      const automaattisenPoistonTili = this._kaikkiTilitMap.get(poistettavaTili)
      const poistotiedot = automaattisenPoistonTili.poistotiedot

      // Vientejä voi olla useita poistettavalle tilille, lasketaan kokonaissumma
      const summa = automaattisenPoistonTilinKirjausRivit.reduce((sum, rivi) => sum + (rivi.d || -rivi.k), 0)
      const poistettavaMaara = Math.abs(summa)

      // Määritetään, onko poistettava tili k/d
      const onkoPoistettavaTiliRiviKredit = summa < 0 ? true : false

      // Avataan poistot dialogi, jossa voidaan luoda automaattiset poistot
      const poistotiliLisataan = poistotilienMuutostiedot.tyyppi === 'kirjaukseen-lisataan-poistotili'
      const poistotiliVaihtuu =
        poistotilienMuutostiedot.tyyppi === 'poistotilillista-kirjausta-muokataan' && poistotilienMuutostiedot.edellinenPoistotili !== poistotilienMuutostiedot.nykyinenPoistotili
      const onAlkuperainenPoistokirjaus = this._kirjanpitoJaettuService.onkoAlkuperainenAutomaattinenPoistokirjaus(kirjaus.kirjaus)
      const voiLuodaAutomaattisetPoistokirjaukset =
        kirjaus.kirjaus.tunniste !== 'automaattipoisto_vuosipoisto' && // Vuosipoistoja ei voi muokata
        (!kirjaus.kirjaus.tunniste || poistotiliLisataan || poistotiliVaihtuu || onAlkuperainenPoistokirjaus) &&
        poistettavaMaara // Pitää olla poistettavaa, jotta poistodialogi voidaan näyttää ja poistoja voidaan tehdä

      if (!voiLuodaAutomaattisetPoistokirjaukset) {
        return 'ei-poistoja'
      }

      const dialogData: KirjausPoistotDialogData = {
        naytettavaKirjaus: kirjaus,
        automaattisenPoistonTili: automaattisenPoistonTili,
        poistettavaMaara: poistettavaMaara,
        asiakas: this._asiakas,
      }
      return firstValueFrom(this._dialog.open(KirjausPoistotDialog, { data: dialogData }).beforeClosed()).then((result: KirjausPoistotDialogResult) => {
        if (result) {
          if (result.luoPoistokirjaukset) {
            return {
              ...result,
              ...poistotiedot,
              poistettavaTili,
              poistettavaMaara,
              onkoPoistettavaTiliRiviKredit,
            }
          } else {
            return 'ei-poistoja'
          }
        } else {
          // Dialogi suljettu Peruuta / ruksilla
          return 'peruutettu'
        }
      })
    }
  }

  private async _tallennaKirjaus(kirjaus: NaytettavaKirjaus): Promise<any> {
    if (this.onkoNaytettavaKirjausMuuttumaton(kirjaus) && kirjaus.kirjaus.kirjanpitajaHyvaksynyt) {
      kirjaus.tallentamattomiaMuutoksia = false
      // console.log('ON muuttumaton')
      return Promise.resolve()
    }

    const poistotilienMuutostiedot = this._kirjanpitoJaettuService.annaPoistotilienMuutostiedot(kirjaus.kirjaus, kirjaus.latauksenAikainenTila.kirjaus, this._kaikkiTilitMap)
    const poistokirjauksienLuontiasetukset = await this._annaPoistokirjauksienLuontiasetukset(kirjaus, poistotilienMuutostiedot)
    if (poistokirjauksienLuontiasetukset === 'peruutettu') {
      return Promise.resolve()
    }

    const aikaisempiTila = kirjaus.latauksenAikainenTila
    const tallennustila = this.kopioiNaytettavaKirjausIlmanKuvaCachea(kirjaus)

    try {
      kirjaus.latauksenAikainenTila = tallennustila
      kirjaus.tallentamattomiaMuutoksia = false
      const tallennettavaKirjaus = tallennustila.kirjaus

      // NOTE! BELOW ONE MUST USE tallennustila.xxx for these deleted properties
      delete kirjaus.uusiPaivamaara
      delete kirjaus.uusiMaksutapa
      delete kirjaus.uusiViitenumero
      delete kirjaus.uusiVat

      const asiakasPromise = firstValueFrom(this._asiakasService.nykyinenAsiakasAvainObservable)
      const tiliHierarkiaPromise = firstValueFrom(this._tilikarttaService.nykyisenAsiakkaanTilikartanTilihierarkiaObservable)

      const [asiakas, tiliHierarkia] = await Promise.all([asiakasPromise, tiliHierarkiaPromise])

      if (!asiakas || !tiliHierarkia?.length) {
        return
      }

      const olikoKirjauksessaEnnenSahkoisenTiliotteenTileja = this._kirjanpitoJaettuService.onkoKirjauksessaSahkoisenTiliotteenTilejaHierarkia(aikaisempiTila.kirjaus, tiliHierarkia)
      const onkoKirjauksessaNytSahkoisenTiliotteenTileja = this._kirjanpitoJaettuService.onkoKirjauksessaSahkoisenTiliotteenTilejaHierarkia(tallennettavaKirjaus, tiliHierarkia)
      const pyynto: KirjauksenTallennuspyyntoUusi = {
        asiakasAvain: asiakas.avain,
        kirjaus: tallennettavaKirjaus,
        liitetyt: null,
      }
      if (tallennustila.uusiPaivamaara) {
        tallennettavaKirjaus.p = tallennustila.uusiPaivamaara
      }
      if (tallennustila.uusiMaksutapa) {
        tallennettavaKirjaus.maksutavanTunniste = tallennustila.uusiMaksutapa
      }
      if (tallennustila.uusiViitenumero) {
        pyynto.uusiViitenumero = tallennustila.uusiViitenumero
      }
      if (tallennustila.uusiVat) {
        tallennettavaKirjaus.vat = tallennustila.uusiVat
      }
      if (!olikoKirjauksessaEnnenSahkoisenTiliotteenTileja && !onkoKirjauksessaNytSahkoisenTiliotteenTileja) {
        pyynto.skipAccountBalanceCheck = true
      }
      if (typeof poistokirjauksienLuontiasetukset === 'object') {
        pyynto.poistokirjauksienLuontiasetukset = poistokirjauksienLuontiasetukset
      }
      if (poistotilienMuutostiedot) {
        pyynto.poistotilienMuutostiedot = poistotilienMuutostiedot
      }

      await this._lemonatorFirebase.functionsCall<KirjauksenTallennuspyyntoUusi, KirjauksenTallennusvastaus>('kirjanpitoKirjauksetTallennaIlmanTositteidenPaivittamista', pyynto, {
        timeout: 540 * 1000,
      })
      delete tallennustila.uusiPaivamaara
      delete tallennustila.uusiMaksutapa
      delete tallennustila.uusiViitenumero
    } catch (error) {
      this._errorHandler.handleError(error)

      // TODO: snackbar?
      kirjaus.kirjauksenVirhe = 'Kirjauksen tallentaminen epäonnistui. Ole hyvä ja yritä uudelleen.'
      kirjaus.latauksenAikainenTila = aikaisempiTila

      // Return deleted properties if the accountant retries.
      kirjaus.uusiPaivamaara = tallennustila.uusiPaivamaara
      kirjaus.uusiMaksutapa = tallennustila.uusiMaksutapa
      kirjaus.uusiViitenumero = tallennustila.uusiViitenumero
      kirjaus.uusiVat = tallennustila.uusiVat
    } finally {
      kirjaus.tallennetaan = false
    }
  }

  private onkoNaytettavariviAlvrivi(naytettavaKirjausrivi: NaytettavaKirjausrivi): boolean {
    return !!(naytettavaKirjausrivi && naytettavaKirjausrivi.kirjausrivi && naytettavaKirjausrivi.kirjausrivi.t && this._kirjanpitoJaettuService.onkoAlvTilinumero(naytettavaKirjausrivi.kirjausrivi.t))
  }

  private poistaAlvRivit(arvoavain: string, naytettavaRivi: NaytettavaKirjausrivi, naytettavaKirjaus: NaytettavaKirjaus) {
    const index = naytettavaKirjaus.naytettavatKirjausrivit.indexOf(naytettavaRivi)
    const seuraavaRiviOnAlv = naytettavaKirjaus.naytettavatKirjausrivit.length > index && this.onkoNaytettavariviAlvrivi(naytettavaKirjaus.naytettavatKirjausrivit[index + 1])
    const sitaSeuraavaRiviOnAlv =
      seuraavaRiviOnAlv && naytettavaKirjaus.naytettavatKirjausrivit.length > index + 1 && this.onkoNaytettavariviAlvrivi(naytettavaKirjaus.naytettavatKirjausrivit[index + 2])
    let kerattyDebit = 0
    let kerattyKredit = 0
    if (seuraavaRiviOnAlv && sitaSeuraavaRiviOnAlv) {
      // ALV-rivi poistui
      const poistetutRivit = naytettavaKirjaus.kirjaus.rivit.splice(index + 2, 1)
      // kerattyDebit += poistetutRivit[0].debet
      // kerattyKredit += poistetutRivit[0].kredit
      naytettavaKirjaus.naytettavatKirjausrivit.splice(index + 2, 1)
    }
    if (seuraavaRiviOnAlv) {
      // ALV-rivi poistui
      const poistetutRivit = naytettavaKirjaus.kirjaus.rivit.splice(index + 1, 1)
      if (!sitaSeuraavaRiviOnAlv) {
        kerattyDebit += poistetutRivit[0].d
        kerattyKredit += poistetutRivit[0].k
      }
      naytettavaKirjaus.naytettavatKirjausrivit.splice(index + 1, 1)
    }
    // console.log('Poista alvrivit', this._asiakkaanAlvtLukossa)
    naytettavaRivi.alv = ''
    naytettavaRivi.alvlukittu = this._asiakkaanAlvtLukossa
    naytettavaRivi.alvvirhe = false
    naytettavaRivi.kirjausrivi.a = null
    naytettavaRivi.kirjausrivi.d = this._currencyService.roundHalfUp(naytettavaRivi.kirjausrivi.d + kerattyDebit, 2)
    naytettavaRivi.kirjausrivi.k = this._currencyService.roundHalfUp(naytettavaRivi.kirjausrivi.k + kerattyKredit, 2)

    naytettavaRivi.kirjausrivi.d = naytettavaRivi.kirjausrivi.d === 0 ? null : naytettavaRivi.kirjausrivi.d
    naytettavaRivi.kirjausrivi.k = naytettavaRivi.kirjausrivi.k === 0 ? null : naytettavaRivi.kirjausrivi.k

    naytettavaRivi.debet = this._currencyService.formatoiDesimaaliSailytaNollat(naytettavaRivi.kirjausrivi.d, 2, 'fi')
    naytettavaRivi.kredit = this._currencyService.formatoiDesimaaliSailytaNollat(naytettavaRivi.kirjausrivi.k, 2, 'fi')
    this.paivitaRivienLookupMapAvaimet(arvoavain, naytettavaKirjaus)
    this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)
    this.paivitaKirjauksessaYhteisomyyntiVatKentta(naytettavaKirjaus)
  }

  private paivitaKirjausrivinAlvRiviSiirraNegatiiviset(naytettavaRivi: NaytettavaKirjausrivi, naytettavaKirjaus: NaytettavaKirjaus, vanhastaSummasta: boolean, arvoavain: string) {
    const index = naytettavaKirjaus.naytettavatKirjausrivit.indexOf(naytettavaRivi)
    const seuraavaRiviOnAlv = naytettavaKirjaus.naytettavatKirjausrivit.length > index && this.onkoNaytettavariviAlvrivi(naytettavaKirjaus.naytettavatKirjausrivit[index + 1])
    const sitaSeuraavaRiviOnAlv =
      seuraavaRiviOnAlv && naytettavaKirjaus.naytettavatKirjausrivit.length > index + 1 && this.onkoNaytettavariviAlvrivi(naytettavaKirjaus.naytettavatKirjausrivit[index + 2])

    if (seuraavaRiviOnAlv) {
      const ekaAlvRivi = naytettavaKirjaus.naytettavatKirjausrivit[index + 1]
      if (ekaAlvRivi.kirjausrivi.d && ekaAlvRivi.kirjausrivi.d < 0.01) {
        ekaAlvRivi.kirjausrivi.k = this._currencyService.roundHalfUp(Math.abs(ekaAlvRivi.kirjausrivi.d), 2)
        ekaAlvRivi.kirjausrivi.d = null
        ekaAlvRivi.debet = ''
        ekaAlvRivi.kredit = this._currencyService.formatoiDesimaaliSailytaNollat(ekaAlvRivi.kirjausrivi.k, 2, 'fi')
        this.paivitaNaytettavanRivinLukitustiedot(naytettavaKirjaus.kirjaus, ekaAlvRivi)
      } else if (ekaAlvRivi.kirjausrivi.k && ekaAlvRivi.kirjausrivi.k < 0.01) {
        ekaAlvRivi.kirjausrivi.d = this._currencyService.roundHalfUp(Math.abs(ekaAlvRivi.kirjausrivi.k), 2)
        ekaAlvRivi.kirjausrivi.k = null
        ekaAlvRivi.debet = this._currencyService.formatoiDesimaaliSailytaNollat(ekaAlvRivi.kirjausrivi.d, 2, 'fi')
        ekaAlvRivi.kredit = ''
        this.paivitaNaytettavanRivinLukitustiedot(naytettavaKirjaus.kirjaus, ekaAlvRivi)
      }
    }

    if (sitaSeuraavaRiviOnAlv) {
      const tokaAlvRivi = naytettavaKirjaus.naytettavatKirjausrivit[index + 2]
      if (tokaAlvRivi.kirjausrivi.d && tokaAlvRivi.kirjausrivi.d < 0.01) {
        tokaAlvRivi.kirjausrivi.k = this._currencyService.roundHalfUp(Math.abs(tokaAlvRivi.kirjausrivi.d), 2)
        tokaAlvRivi.kirjausrivi.d = null
        tokaAlvRivi.debet = ''
        tokaAlvRivi.kredit = this._currencyService.formatoiDesimaaliSailytaNollat(tokaAlvRivi.kirjausrivi.k, 2, 'fi')
        this.paivitaNaytettavanRivinLukitustiedot(naytettavaKirjaus.kirjaus, tokaAlvRivi)
      } else if (tokaAlvRivi.kirjausrivi.k && tokaAlvRivi.kirjausrivi.k < 0.01) {
        tokaAlvRivi.kirjausrivi.d = this._currencyService.roundHalfUp(Math.abs(tokaAlvRivi.kirjausrivi.k), 2)
        tokaAlvRivi.kirjausrivi.k = null
        tokaAlvRivi.debet = this._currencyService.formatoiDesimaaliSailytaNollat(tokaAlvRivi.kirjausrivi.d, 2, 'fi')
        tokaAlvRivi.kredit = ''
        this.paivitaNaytettavanRivinLukitustiedot(naytettavaKirjaus.kirjaus, tokaAlvRivi)
      }
    }
  }

  private paivitaKirjausrivinAlvRivi(naytettavaRivi: NaytettavaKirjausrivi, naytettavaKirjaus: NaytettavaKirjaus, vanhastaSummasta: boolean, arvoavain: string) {
    const index = naytettavaKirjaus.naytettavatKirjausrivit.indexOf(naytettavaRivi)
    const seuraavaRiviOnAlv = naytettavaKirjaus.naytettavatKirjausrivit.length > index && this.onkoNaytettavariviAlvrivi(naytettavaKirjaus.naytettavatKirjausrivit[index + 1])
    const sitaSeuraavaRiviOnAlv =
      seuraavaRiviOnAlv && naytettavaKirjaus.naytettavatKirjausrivit.length > index + 1 && this.onkoNaytettavariviAlvrivi(naytettavaKirjaus.naytettavatKirjausrivit[index + 2])

    const alvMaaritys = this._kaikkiAlvMaarityksetMap.get(naytettavaRivi.kirjausrivi.a) || null
    const tili = alvMaaritys ? alvMaaritys.kirjaustili : null
    const alvTili = this._kaikkiValittavissaOlevatTilitMap.get(tili)
    const alvTiliOnOk = alvTili && alvMaaritys

    if (alvTiliOnOk) {
      // ALV-asetukset ovat kunnossa laskentaa varten.

      // jos prosentti on 0, poistetaan kaikki laskentarivit.
      if (alvMaaritys.prosentti === 0) {
        if (sitaSeuraavaRiviOnAlv && seuraavaRiviOnAlv) {
          naytettavaKirjaus.kirjaus.rivit.splice(index + 2, 1)
          naytettavaKirjaus.naytettavatKirjausrivit.splice(index + 2, 1)
        }
        if (seuraavaRiviOnAlv) {
          naytettavaKirjaus.kirjaus.rivit.splice(index + 1, 1)
          naytettavaKirjaus.naytettavatKirjausrivit.splice(index + 1, 1)
        }
      } else {
        // Prosentti ei ollut nolla, jatketaan laskentaa
        let ekaAlvRivi: NaytettavaKirjausrivi = null
        if (seuraavaRiviOnAlv) {
          // Päivitä ALV-rivi
          // Jos ALV-rivin numero pitäisi muuttua
          ekaAlvRivi = naytettavaKirjaus.naytettavatKirjausrivit[index + 1]
          ekaAlvRivi.kirjausrivi.a = alvMaaritys.tunniste
          ekaAlvRivi.alv = alvMaaritys.lyhenne
          ekaAlvRivi.kirjausrivi.t = alvTili.numero
          ekaAlvRivi.tilinimi = this._tilikarttaJaettuService.annaKirjanpitotilinNimi(alvTili, 'fi')
          ekaAlvRivi.tilinumero = alvTili.numero
          this.laskeAlvRiviJaSummatUudelleen(naytettavaRivi, ekaAlvRivi, vanhastaSummasta, alvMaaritys.kaannetty)
        } else {
          // ALV-tili puuttuu, lisää uusi
          const alvKirjausrivi: Kirjausrivi = {
            av: this._lemonatorFirebase.firestoreCreateId(),
            a: alvMaaritys.tunniste,
            d: null,
            k: null,
            t: alvTili.numero,
          }
          ekaAlvRivi = this.luoNaytettavaKirjausriviKirjausrivista(alvKirjausrivi)

          naytettavaKirjaus.kirjaus.rivit.splice(index + 1, 0, alvKirjausrivi)
          naytettavaKirjaus.naytettavatKirjausrivit.splice(index + 1, 0, ekaAlvRivi)

          this.laskeAlvRiviJaSummatUudelleen(naytettavaRivi, ekaAlvRivi, vanhastaSummasta, alvMaaritys.kaannetty)
          this.paivitaNaytettavanRivinLukitustiedot(naytettavaKirjaus.kirjaus, ekaAlvRivi)
        }

        if (alvMaaritys.kaannetty) {
          const kaannettyAlvTili = this._kaikkiTilitMap.get('2939')
          if (sitaSeuraavaRiviOnAlv) {
            // Päivitä ALV-rivi
            // Jos ALV-rivin numero pitäisi muuttua
            const alvNaytettavaRivi = naytettavaKirjaus.naytettavatKirjausrivit[index + 2]
            alvNaytettavaRivi.kirjausrivi.a = alvMaaritys.tunniste
            alvNaytettavaRivi.alv = alvMaaritys.lyhenne
            alvNaytettavaRivi.kirjausrivi.t = kaannettyAlvTili.numero
            alvNaytettavaRivi.tilinimi = this._tilikarttaJaettuService.annaKirjanpitotilinNimi(kaannettyAlvTili, 'fi')
            alvNaytettavaRivi.tilinumero = kaannettyAlvTili.numero
            this.laskeKaanteinenAlvRiviUudelleen(naytettavaRivi, ekaAlvRivi, alvNaytettavaRivi)
          } else {
            // ALV-tili puuttuu, lisää uusi
            const alvKirjausrivi: Kirjausrivi = {
              av: this._lemonatorFirebase.firestoreCreateId(),
              a: alvMaaritys.tunniste,
              d: null,
              k: null,
              t: kaannettyAlvTili.numero,
            }
            const alvNaytettavaRivi: NaytettavaKirjausrivi = this.luoNaytettavaKirjausriviKirjausrivista(alvKirjausrivi)

            naytettavaKirjaus.kirjaus.rivit.splice(index + 2, 0, alvKirjausrivi)
            naytettavaKirjaus.naytettavatKirjausrivit.splice(index + 2, 0, alvNaytettavaRivi)

            this.laskeKaanteinenAlvRiviUudelleen(naytettavaRivi, ekaAlvRivi, alvNaytettavaRivi)
            this.paivitaNaytettavanRivinLukitustiedot(naytettavaKirjaus.kirjaus, alvNaytettavaRivi)
          }
        } else if (seuraavaRiviOnAlv && sitaSeuraavaRiviOnAlv) {
          // console.log('HEP4.1', naytettavaKirjaus.naytettavatKirjausrivit.length)
          naytettavaKirjaus.kirjaus.rivit.splice(index + 2, 1)
          naytettavaKirjaus.naytettavatKirjausrivit.splice(index + 2, 1)
          // console.log('HEP4.2', naytettavaKirjaus.naytettavatKirjausrivit.length)
        }
      }
    } else {
      // ALV-asetukset eivät olleet OK, poistetaan rivit.
      if (sitaSeuraavaRiviOnAlv && seuraavaRiviOnAlv) {
        naytettavaKirjaus.kirjaus.rivit.splice(index + 2, 1)
        naytettavaKirjaus.naytettavatKirjausrivit.splice(index + 2, 1)
      }
      if (seuraavaRiviOnAlv) {
        naytettavaKirjaus.kirjaus.rivit.splice(index + 1, 1)
        naytettavaKirjaus.naytettavatKirjausrivit.splice(index + 1, 1)
      }
    }

    this.paivitaRivienLookupMapAvaimet(arvoavain, naytettavaKirjaus)
    this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)
    this.paivitaKirjauksessaYhteisomyyntiVatKentta(naytettavaKirjaus)
  }

  private asetaKirjausrivinKommentti(kirjausrivi: Kirjausrivi, kommentti: string | null) {
    if (kommentti && kommentti.trim()) {
      kirjausrivi.s = kommentti.trim()
    } else {
      delete kirjausrivi.s
    }
  }

  private laskeKaanteinenAlvRiviUudelleen(naytettavaRivi: NaytettavaKirjausrivi, ekaAlvRivi: NaytettavaKirjausrivi, tokaAlvRivi: NaytettavaKirjausrivi) {
    this.asetaKirjausrivinKommentti(ekaAlvRivi.kirjausrivi, naytettavaRivi.kirjausrivi.s)
    this.asetaKirjausrivinKommentti(tokaAlvRivi.kirjausrivi, naytettavaRivi.kirjausrivi.s)
    tokaAlvRivi.kommentti = naytettavaRivi.kommentti
    tokaAlvRivi.kommentti = naytettavaRivi.kommentti

    if (ekaAlvRivi.kirjausrivi.d || ekaAlvRivi.kirjausrivi.d === 0) {
      tokaAlvRivi.kirjausrivi.k = ekaAlvRivi.kirjausrivi.d
      tokaAlvRivi.kredit = this._currencyService.formatoiDesimaaliSailytaNollat(tokaAlvRivi.kirjausrivi.k, 2, 'fi')
      tokaAlvRivi.debet = ''
      tokaAlvRivi.kirjausrivi.d = null
    } else {
      tokaAlvRivi.kirjausrivi.k = null
      tokaAlvRivi.kredit = ''
    }

    if (ekaAlvRivi.kirjausrivi.k || ekaAlvRivi.kirjausrivi.k === 0) {
      tokaAlvRivi.kirjausrivi.d = ekaAlvRivi.kirjausrivi.k
      tokaAlvRivi.debet = this._currencyService.formatoiDesimaaliSailytaNollat(tokaAlvRivi.kirjausrivi.d, 2, 'fi')
      tokaAlvRivi.kredit = ''
      tokaAlvRivi.kirjausrivi.k = null
    } else {
      tokaAlvRivi.kirjausrivi.d = null
      tokaAlvRivi.debet = ''
    }
  }

  private laskeAlvRiviJaSummatUudelleen(naytettavaRivi: NaytettavaKirjausrivi, alvNaytettavaRivi: NaytettavaKirjausrivi, vanhastaSummasta: boolean, kaannetty: boolean) {
    this.asetaKirjausrivinKommentti(alvNaytettavaRivi.kirjausrivi, naytettavaRivi.kirjausrivi.s)
    alvNaytettavaRivi.kommentti = naytettavaRivi.kommentti

    // console.log('ALV laskenta', vanhastaSummasta, kaannetty)
    // Uusi summa
    if (naytettavaRivi.kirjausrivi.d || naytettavaRivi.kirjausrivi.d === 0) {
      const summasta = vanhastaSummasta ? naytettavaRivi.kirjausrivi.d + alvNaytettavaRivi.kirjausrivi.d : naytettavaRivi.kirjausrivi.d
      const alvMaaritys = this._kaikkiAlvMaarityksetMap.get(naytettavaRivi.kirjausrivi.a)
      const raakaveronOsuus = this.annaRaakaveronOsuus(kaannetty, summasta, alvMaaritys.prosentti)
      // console.log('summasta', summasta, vanhastaSummasta, kaannetty, 'raakaveronOsuus', raakaveronOsuus, 'alvPros', naytettavaRivi.kirjausrivi.alv.prosentti)
      const veronOsuus = this._currencyService.roundHalfUp(raakaveronOsuus, 2)
      alvNaytettavaRivi.kirjausrivi.d = veronOsuus
      alvNaytettavaRivi.debet = this._currencyService.formatoiDesimaaliSailytaNollat(alvNaytettavaRivi.kirjausrivi.d, 2, 'fi')
      if (kaannetty) {
        naytettavaRivi.kirjausrivi.d = summasta
      } else {
        naytettavaRivi.kirjausrivi.d = summasta - veronOsuus
      }
      naytettavaRivi.debet = this._currencyService.formatoiDesimaaliSailytaNollat(naytettavaRivi.kirjausrivi.d, 2, 'fi')
    } else {
      alvNaytettavaRivi.kirjausrivi.d = null
      alvNaytettavaRivi.debet = ''
    }

    if (naytettavaRivi.kirjausrivi.k || naytettavaRivi.kirjausrivi.k === 0) {
      const summasta = vanhastaSummasta ? naytettavaRivi.kirjausrivi.k + alvNaytettavaRivi.kirjausrivi.k : naytettavaRivi.kirjausrivi.k
      const alvMaaritys = this._kaikkiAlvMaarityksetMap.get(naytettavaRivi.kirjausrivi.a)
      const raakaveronOsuus = this.annaRaakaveronOsuus(kaannetty, summasta, alvMaaritys.prosentti)
      // console.log('summasta', summasta, vanhastaSummasta, kaannetty, 'raakaveronOsuus', raakaveronOsuus, 'alvPros', naytettavaRivi.kirjausrivi.alv.prosentti)
      const veronOsuus = this._currencyService.roundHalfUp(raakaveronOsuus, 2)
      alvNaytettavaRivi.kirjausrivi.k = veronOsuus
      alvNaytettavaRivi.kredit = this._currencyService.formatoiDesimaaliSailytaNollat(alvNaytettavaRivi.kirjausrivi.k, 2, 'fi')
      if (kaannetty) {
        naytettavaRivi.kirjausrivi.k = summasta
      } else {
        naytettavaRivi.kirjausrivi.k = summasta - veronOsuus
      }
      naytettavaRivi.kredit = this._currencyService.formatoiDesimaaliSailytaNollat(naytettavaRivi.kirjausrivi.k, 2, 'fi')
    } else {
      alvNaytettavaRivi.kirjausrivi.k = null
      alvNaytettavaRivi.kredit = ''
    }
  }

  private annaRaakaveronOsuus(kaannetty: boolean, summasta: number, alvProsentti: number): number {
    if (alvProsentti === 0) {
      return 0
    }
    if (alvProsentti === 100) {
      return summasta
    }
    if (kaannetty) {
      return this._currencyService.annaAlvMaaraAlvittomastaHinnasta(summasta, alvProsentti)
    }
    return this._currencyService.annaAlvMaaraAlvillisestaHinnasta(summasta, alvProsentti)
  }

  private onkoTiliKuititonTili(tili: string): boolean {
    const numero = tili ? tili : 'asfdsfrgsfbhjkioi'
    return this._selvitettavatOstotTilitMap.has(numero) || this._selvitettavatMyynnitTilitMap.has(numero)
  }

  private _kaikkiAutocompleteKommentitEn: string[] = [
    'Please attach a receipt/invoice for this transaction',
    'Please add the names of participants',
    'Unfortunately, the image of the receipt is too blurry. Please add a new image with better quality.',
    'Please also attach the original invoice',
    'Please add your online bank receipt as proof of payment',
  ]

  private _kaikkiAutocompleteKommentitFi: string[] = [
    'Lisääthän tähän tapahtumaan kuitin/laskun',
    'Lisääthän tähän vielä läsnäolijoiden nimet',
    'Tositteen kuva on valitettavasti liian epäselvä, saatko lisättyä uuden paremman kuvan',
    'Lisääthän tähän lisäksi alkuperäisen laskun',
    'Lisääthän tähän vielä verkkopankin kuitin tositteeksi maksusta',
    // 'Tosite puuttuu',
    // 'Tarvitaan läsnäolijoiden nimet',
    // 'Tosite on liian epäselvä'
  ]

  // this._suodatetutKommentitSubject.next([])

  /**
   *
   * @param suspect
   * @param naytettavaKirjaus
   * @returns The amount as number IF it is parsable (contains now odd characters/letters), null if the suspect is empty (undefined, null or empty string), undefined if the suspect is NOT parsable.
   */
  private annaNumeerinenArvo(suspect: string, naytettavaKirjaus: NaytettavaKirjaus): number {
    if (suspect === null || suspect === undefined || suspect.trim() === '') {
      return null
    }
    const arvo = this.annaErotusTaiKaavanArvo(suspect, naytettavaKirjaus)
    if (arvo || arvo === 0) {
      return this._currencyService.roundHalfUp(arvo, 2)
    }
    return undefined
  }

  private _skipQuickToggleSpaceTilienHakuboksista(asHtmlElement: HTMLElement): boolean {
    if (asHtmlElement.classList.contains('kni')) {
      const asInput = asHtmlElement as HTMLInputElement
      if (asInput.value) {
        return !this._currencyService.onkoMerkkijonoKokonaisluku(asInput.value.trim())
      }
    }
    return false
  }

  @HostListener('document:keydown.space', ['$event'])
  hoidaEsikatselu(event: Event) {
    const asHtmlElement = event.target as HTMLElement
    if (
      !asHtmlElement ||
      asHtmlElement.classList.contains('skip-space-quick-toggle') ||
      asHtmlElement.classList.contains('kkoi') ||
      asHtmlElement.classList.contains('email-lisaa-vastaanottaja') ||
      asHtmlElement.classList.contains('email-aihe') ||
      asHtmlElement.classList.contains('skip-space-toggle-quick') ||
      asHtmlElement.classList.contains('mat-mdc-input-element') ||
      asHtmlElement.nodeName === 'TEXTAREA' ||
      this._skipQuickToggleSpaceTilienHakuboksista(asHtmlElement)
    ) {
      return
    }
    if (this.valittuvalilehti === 'projektit' && asHtmlElement.classList.contains('mat-mdc-input-element')) {
      return
    }
    event.stopPropagation()
    event.preventDefault()
    if (this.valittuvalilehti === 'tositteet') {
      // if (this._edellinenValilehti) {
      //   this._selectTabInternal(this._edellinenValilehti)
      // }
      this._selectTabInternal('raportit-uusi')
    } else {
      this._selectTabInternal('tositteet')
    }
  }

  @HostListener('input', ['$event'])
  arvoaMuutettiin(event: Event) {
    // console.log('test 1')
    this._internalArvoaMuutettiin(event.target as HTMLInputElement)
  }

  private _internalArvoaMuutettiin(targetElement: HTMLInputElement) {
    // console.log('test 2')
    // console.time('kirjauksen kasittely')
    if (targetElement.classList.contains('kni')) {
      // console.log('targetElement 1', targetElement)
      // console.log('value 2', targetElement.value)
      this._tilinumeroMuuttui(targetElement, targetElement.value)
    } else if (targetElement.classList.contains('kdi')) {
      const arvoavain = this.etsiArvoavain(targetElement)
      const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)

      if (naytettavaKirjaus) {
        const arvo = this.annaNumeerinenArvo(targetElement.value, naytettavaKirjaus)
        if (arvo || arvo === 0 || arvo === null) {
          naytettavaKirjaus.kirjauksenVirhe = null
          const rivi = this._riviMap.get(arvoavain)
          rivi.kreditlukittu = targetElement.value === undefined || targetElement.value === null || targetElement.value === '' ? false : true
          if (rivi.kreditlukittu) {
            rivi.kreditvirhe = false
          }
          rivi.kirjausrivi.d = arvo
          rivi.debet = this._currencyService.formatoiDesimaaliSailytaNollat(rivi.kirjausrivi.d, 2, 'fi')
          if (rivi.kirjausrivi.a) {
            this.paivitaKirjausrivinAlvRivi(rivi, naytettavaKirjaus, false, arvoavain)
          }
          this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)
          naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
        }
      }
    } else if (targetElement.classList.contains('kki')) {
      const arvoavain = this.etsiArvoavain(targetElement)
      const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)

      if (naytettavaKirjaus) {
        const arvo = this.annaNumeerinenArvo(targetElement.value, naytettavaKirjaus)
        if (arvo || arvo === 0 || arvo === null) {
          naytettavaKirjaus.kirjauksenVirhe = null
          const rivi = this._riviMap.get(arvoavain)
          rivi.debetlukittu = targetElement.value === undefined || targetElement.value === null || targetElement.value === '' ? false : true
          if (rivi.debetlukittu) {
            rivi.debetvirhe = false
          }
          rivi.kirjausrivi.k = arvo
          rivi.kredit = this._currencyService.formatoiDesimaaliSailytaNollat(rivi.kirjausrivi.k, 2, 'fi')
          if (rivi.kirjausrivi.a) {
            this.paivitaKirjausrivinAlvRivi(rivi, naytettavaKirjaus, false, arvoavain)
          }
          this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)
          naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
        }
      }
    } else if (targetElement.classList.contains('kai')) {
      this._alvMuuttui(targetElement, targetElement.value)
    } else if (targetElement.classList.contains('kkoi')) {
      this._kommenttiMuuttui(targetElement, targetElement.value)
    }
    // console.timeEnd('kirjauksen kasittely')
  }

  private _tilinumeroMuuttui(targetElement: HTMLInputElement, value: string) {
    // console.log('targetElement', targetElement)
    // console.log('value', value)
    // console.log('targetElement.parentElement', targetElement.parentElement)
    // console.log('targetElement.parentElement.parentElement', targetElement.parentElement.parentElement)
    // console.log('targetElement.parentElement.parentElement.dataset', targetElement.parentElement.parentElement.dataset)

    const arvoavain = this.etsiArvoavain(targetElement)
    const rivi = this._riviMap.get(arvoavain)
    const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
    if (naytettavaKirjaus) {
      naytettavaKirjaus.kirjauksenVirhe = null
      this.poistaAlvRivit(arvoavain, rivi, naytettavaKirjaus)

      const vanhaTili = rivi.kirjausrivi.t
      if (value) {
        // console.log('Got value ' + targetElement.value)
        const trimmed = value.trim()
        const tili = this._kaikkiValittavissaOlevatTilitMap.get(trimmed) || null
        if (
          tili &&
          tili.numero &&
          (!this._kirjanpitoJaettuService.onkoAlvTilinumero(tili.numero) || this._allKirjauksetAndAccountsCanBeEdited.value || tili.numero === '2946') // TODO: SPECIAL CASE! IF WE EVER IMPLEMENT AUTOMAATTITYHJENNYS -> PLEASE DO REMOVE THIS! THERE ARE OTHER PLACES, SEARH FOR THE NUMBER!!
        ) {
          rivi.kirjausrivi.t = tili.numero
        } else {
          rivi.kirjausrivi.t = null
        }

        const t = this._kaikkiTilitMap.get(rivi.kirjausrivi.t)
        if (t) {
          // console.log('Tili valittu')
          rivi.tilinimi = this._tilikarttaJaettuService.annaKirjanpitotilinNimi(t, 'fi')
          rivi.tilinumero = t.numero
          // NOTE! Needs the parenthesis to work properly!
          rivi.alvlukittu = this._asiakkaanAlvtLukossa || t.alvTyyppi === KirjanpitotilinAlvTyyppi.EI_ALV_KASITTELYA
          if (t.oletusAlvKasittely) {
            let oletusAlv = t.oletusAlvKasittely
            if (naytettavaKirjaus?.kirjaus?.p) {
              oletusAlv = OstoAlvt.flip14PercentageTo135AndViceVersaBasedOnDate(oletusAlv, naytettavaKirjaus.kirjaus.p)
              oletusAlv = MyyntiAlvt.flip14PercentageTo135AndViceVersaBasedOnDate(oletusAlv, naytettavaKirjaus.kirjaus.p)
            }
            rivi.alv = rivi.alvlukittu ? '' : oletusAlv.lyhenne
          }
          if (this.onkoTiliKuititonTili(rivi.kirjausrivi.t)) {
            if (!rivi.kommentti) {
              const kommentit = this._asiakas.laskunKieli === 'en' ? this._kaikkiAutocompleteKommentitEn : this._kaikkiAutocompleteKommentitFi
              rivi.kommentti = kommentit[0]
              this.asetaKirjausrivinKommentti(rivi.kirjausrivi, kommentit[0])
            }
            // this._suodatetutKommentitSubject.next(this._kaikkiAutocompleteKommentit)
          }
        } else {
          // console.log('Tilivalinta poistettu')
          rivi.tilinimi = ''
          rivi.tilinumero = ''
          rivi.alvlukittu = this._asiakkaanAlvtLukossa
          // this._suodatetutKommentitSubject.next([])
        }

        this.tilinumeroSubject.next(trimmed)
      } else {
        rivi.kirjausrivi.t = null
        rivi.tilinimi = ''
        rivi.tilinumero = ''
        rivi.alvlukittu = this._asiakkaanAlvtLukossa
        this.tilinumeroSubject.next(null)
        // this._suodatetutKommentitSubject.next([])
      }

      if (this.onkoTiliKuititonTili(vanhaTili) && !this.onkoTiliKuititonTili(rivi.kirjausrivi.t)) {
        this.poistaAutocompleteKommentit(rivi, naytettavaKirjaus)
      }

      naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
    }
  }

  private _alvMuuttui(targetElement: HTMLInputElement, value: string) {
    const arvoavain = this.etsiArvoavain(targetElement)
    const rivi = this._riviMap.get(arvoavain)
    const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
    if (naytettavaKirjaus) {
      naytettavaKirjaus.kirjauksenVirhe = null
      if (value) {
        const t = this._kaikkiTilitMap.get(rivi.kirjausrivi.t) || null
        const alvTyyppi = t?.alvTyyppi || null
        const alku = alvTyyppi === KirjanpitotilinAlvTyyppi.MYYNTI ? 'm' : alvTyyppi === KirjanpitotilinAlvTyyppi.OSTO ? 'o' : null
        const trimmed = value.trim().toLowerCase()
        // console.log('Got value ' + trimmed, this._kaikkiAlvtLyhenteenMukaanMap.get(trimmed))
        const alv = this._kaikkiAlvtLyhenteenMukaanMap.get(trimmed) || this._kaikkiAlvtLyhenteenMukaanMap.get(alku + trimmed) || null
        if (alv) {
          this.poistaAlvRivit(arvoavain, rivi, naytettavaKirjaus)
          rivi.kirjausrivi.a = alv.tunniste
          rivi.alv = alv.lyhenne
          this.paivitaKirjausrivinAlvRivi(rivi, naytettavaKirjaus, true, arvoavain)
          this.alvSubject.next(alv.lyhenne)
        } else {
          rivi.kirjausrivi.a = null
          rivi.alv = ''
          this.poistaAlvRivit(arvoavain, rivi, naytettavaKirjaus)
          this.alvSubject.next(trimmed)
        }
      } else {
        // console.log('Tyhjennetään alv.')
        rivi.kirjausrivi.a = null
        rivi.alv = ''
        this.alvSubject.next(null)
      }
      this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)
      naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
    }
  }

  private _kommenttiMuuttui(targetElement: HTMLInputElement, value: string) {
    const arvoavain = this.etsiArvoavain(targetElement)

    const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
    if (naytettavaKirjaus) {
      naytettavaKirjaus.kirjauksenVirhe = null
      const rivi = this._riviMap.get(arvoavain)

      const trimmed = value?.trim()?.toLowerCase() || ''
      this.kommenttiSubject.next(trimmed)

      this.asetaKirjausrivinKommentti(rivi.kirjausrivi, value ?? null)
      rivi.kommentti = value ?? null

      // Päivitä ALV-rivin kommentit
      const index = naytettavaKirjaus.naytettavatKirjausrivit.indexOf(rivi)
      const seuraavaRiviOnAlv = naytettavaKirjaus.naytettavatKirjausrivit.length > index && this.onkoNaytettavariviAlvrivi(naytettavaKirjaus.naytettavatKirjausrivit[index + 1])
      const sitaSeuraavaRiviOnAlv =
        seuraavaRiviOnAlv && naytettavaKirjaus.naytettavatKirjausrivit.length > index + 1 && this.onkoNaytettavariviAlvrivi(naytettavaKirjaus.naytettavatKirjausrivit[index + 2])
      if (seuraavaRiviOnAlv) {
        const alvNaytettavaRivi = naytettavaKirjaus.naytettavatKirjausrivit[index + 1]
        alvNaytettavaRivi.kommentti = rivi.kommentti
        this.asetaKirjausrivinKommentti(alvNaytettavaRivi.kirjausrivi, rivi.kommentti)
      }
      if (sitaSeuraavaRiviOnAlv) {
        const alvNaytettavaRivi = naytettavaKirjaus.naytettavatKirjausrivit[index + 2]
        alvNaytettavaRivi.kommentti = rivi.kommentti
        this.asetaKirjausrivinKommentti(alvNaytettavaRivi.kirjausrivi, rivi.kommentti)
      }

      // Päivitä tyhjien rivien kommentit
      for (let i = index; i < naytettavaKirjaus.naytettavatKirjausrivit.length; i++) {
        const jaljempiRivi = naytettavaKirjaus.naytettavatKirjausrivit[i]
        if (!jaljempiRivi.kirjausrivi.t) {
          jaljempiRivi.kommentti = rivi.kommentti
          this.asetaKirjausrivinKommentti(jaljempiRivi.kirjausrivi, rivi.kommentti)
        }
      }
      this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)
      naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
    }
  }

  private poistaAutocompleteKommentit(rivi: NaytettavaKirjausrivi, kirjaus: NaytettavaKirjaus) {
    let found = false
    for (const r of kirjaus.naytettavatKirjausrivit) {
      if (found) {
        if (this._kaikkiAutocompleteKommentitFi.findIndex(a => a === (r.kommentti || '').trim()) > -1 || this._kaikkiAutocompleteKommentitEn.findIndex(a => a === (r.kommentti || '').trim()) > -1) {
          r.kommentti = ''
          delete r.kirjausrivi.s
        }
      } else if (r === rivi) {
        found = true
        if (this._kaikkiAutocompleteKommentitFi.findIndex(a => a === (r.kommentti || '').trim()) > -1 || this._kaikkiAutocompleteKommentitEn.findIndex(a => a === (r.kommentti || '').trim()) > -1) {
          r.kommentti = ''
          delete r.kirjausrivi.s
        }
      }
    }
  }

  private asetaErotusNaytettavaanRiviin(kirjaus: Kirjaus, rivi: NaytettavaKirjausrivi, summat: { debet: number; kredit: number }) {
    rivi.kirjausrivi.k = null
    rivi.kirjausrivi.d = null

    // console.log(summat)
    const erotus = summat.debet - summat.kredit
    // console.log(erotus)
    if (erotus > 0) {
      // debet on suurempi, lisää kreditiin
      // console.log('Lisättiin kredit')
      rivi.kirjausrivi.k = erotus
    } else if (erotus < 0) {
      // debet on pienempi, lisää debettiin
      rivi.kirjausrivi.d = Math.abs(erotus)
      // console.log('Lisättiin debet')
    }

    rivi.debet = rivi.kirjausrivi.d ? this._currencyService.formatoiRahaIlmanValuuttaSymbolia(rivi.kirjausrivi.d, 'fi') : ''
    rivi.kredit = rivi.kirjausrivi.k ? this._currencyService.formatoiRahaIlmanValuuttaSymbolia(rivi.kirjausrivi.k, 'fi') : ''

    this.paivitaNaytettavanRivinLukitustiedot(kirjaus, rivi)
  }

  private paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus: NaytettavaKirjaus) {
    const vikaRivi = naytettavaKirjaus.naytettavatKirjausrivit.length > 0 ? naytettavaKirjaus.naytettavatKirjausrivit[naytettavaKirjaus.naytettavatKirjausrivit.length - 1] : null
    if (!this.onkoNaytettavariviAlvrivi(vikaRivi) && !vikaRivi.kirjausrivi.t) {
      vikaRivi.kirjausrivi.k = null
      vikaRivi.kirjausrivi.d = null
      const summatIlmanVikaaRivia = this._kirjanpitoJaettuService.annaKirjauksenSummat(naytettavaKirjaus?.kirjaus)
      // if (summatIlmanVikaaRivia.debet !== summatIlmanVikaaRivia.kredit) {
      this.asetaErotusNaytettavaanRiviin(naytettavaKirjaus.kirjaus, vikaRivi, summatIlmanVikaaRivia)
      // }
    }

    const summat = this._kirjanpitoJaettuService.annaKirjauksenSummat(naytettavaKirjaus?.kirjaus)
    naytettavaKirjaus.debetyhteensa = this._currencyService.formatoiRahaIlmanValuuttaSymbolia(summat.debet, 'fi')
    naytettavaKirjaus.kredityhteensa = this._currencyService.formatoiRahaIlmanValuuttaSymbolia(summat.kredit, 'fi')
  }

  @HostListener('focusin', ['$event'])
  muokkaaSoluaEvent(event: FocusEvent) {
    const targetElement = event.target as HTMLElement

    this.muokkaaSolua(targetElement)
  }

  async muokkaaSolua(targetElement: HTMLElement) {
    // this._ngZone.runOutsideAngular(async () => {
    // const relatedElement = event.relatedTarget as HTMLElement
    // console.log('focus set to', targetElement, 'from', relatedElement)

    if (targetElement.classList.contains('kn')) {
      // console.log(targetElement.parentElement.dataset.arvoavain, this._riviMap)
      const arvoavain = this.etsiArvoavain(targetElement)
      const rivi = this._riviMap.get(arvoavain)
      if (rivi && !rivi.lukittu) {
        rivi.knTabIndexPoistettu = true
        const value = rivi.kirjausrivi.t ? rivi.kirjausrivi.t : ''
        this.focusInput(this._tnroInput.nativeElement, targetElement, value, arvoavain)
        this.asetaViimeisinTiedossaOlevaFokus(arvoavain, 'kn')
      }
    } else if (targetElement.classList.contains('knc')) {
      const arvoavain = this.etsiArvoavain(targetElement)
      const rivi = this._riviMap.get(arvoavain)
      if (rivi && !rivi.lukittu) {
        rivi.knTabIndexPoistettu = true
        const value = rivi.kirjausrivi.t ? rivi.kirjausrivi.t : ''
        this.focusInput(this._tnroInput.nativeElement, targetElement.querySelector('.kn'), value, arvoavain)
        this.asetaViimeisinTiedossaOlevaFokus(arvoavain, 'kn')
      }
    } else if (targetElement.classList.contains('kd')) {
      const arvoavain = this.etsiArvoavain(targetElement)
      const rivi = this._riviMap.get(arvoavain)
      if (rivi && !rivi.lukittu && !rivi.debetlukittu) {
        const value = this._currencyService.formatoiDesimaaliSailytaNollat(rivi.kirjausrivi.d, 2, 'fi')
        this.focusInput(this._debetInput.nativeElement, targetElement, value, arvoavain)
        this.asetaViimeisinTiedossaOlevaFokus(arvoavain, 'kd')
      }
    } else if (targetElement.classList.contains('kk')) {
      const arvoavain = this.etsiArvoavain(targetElement)
      const rivi = this._riviMap.get(arvoavain)
      if (rivi && !rivi.lukittu && !rivi.kreditlukittu) {
        const value = this._currencyService.formatoiDesimaaliSailytaNollat(rivi.kirjausrivi.k, 2, 'fi')
        this.focusInput(this._kreditInput.nativeElement, targetElement, value, arvoavain)
        this.asetaViimeisinTiedossaOlevaFokus(arvoavain, 'kk')
      }
    } else if (targetElement.classList.contains('ka')) {
      const arvoavain = this.etsiArvoavain(targetElement)
      const rivi = this._riviMap.get(arvoavain)
      if (rivi && !rivi.lukittu && !rivi.alvlukittu) {
        const t = this._kaikkiTilitMap.get(rivi.kirjausrivi.t)
        if (t) {
          if (t.numero === '3360') {
            // OSS Alle 10k
            this._kaikkiValittavissaOlevatAlvt.next(MyyntiAlvt.suomi)
          } else if (t.numero === '3361' || t.numero === '3362') {
            // OSS rekisteröytynyt
            const alvt = await this._alvService.annaAlvTyypinAlvt(t.alvTyyppi)
            this._kaikkiValittavissaOlevatAlvt.next(alvt)
          } else if (t.alvTyyppi === KirjanpitotilinAlvTyyppi.MYYNTI) {
            this._kaikkiValittavissaOlevatAlvt.next(MyyntiAlvt.kaikki)
          } else if (t.alvTyyppi === KirjanpitotilinAlvTyyppi.OSTO) {
            this._kaikkiValittavissaOlevatAlvt.next(OstoAlvt.kaikki)
          } else if (t.alvTyyppi === KirjanpitotilinAlvTyyppi.ETAMYYNTI_EI_REKISTEROITYNYT) {
            // OSS Alle 10k
            this._kaikkiValittavissaOlevatAlvt.next(MyyntiAlvt.suomi)
          } else if (t.alvTyyppi === KirjanpitotilinAlvTyyppi.ETAMYYNTI) {
            // OSS rekisteröytynyt
            const alvt = await this._alvService.annaAlvTyypinAlvt(t.alvTyyppi)
            this._kaikkiValittavissaOlevatAlvt.next(alvt)
          } else {
            this._kaikkiValittavissaOlevatAlvt.next([])
          }

          if (
            (t.alvTyyppi === KirjanpitotilinAlvTyyppi.OSTO || t.alvTyyppi === KirjanpitotilinAlvTyyppi.MYYNTI || t.alvTyyppi === KirjanpitotilinAlvTyyppi.ETAMYYNTI_EI_REKISTEROITYNYT) &&
            !rivi.kirjausrivi.a // only set default is there is none yet
          ) {
            let oletusAlv = this._kaikkiAlvtTunnisteenMukaanMap.get(t.oletusAlvKasittely?.tunniste)
            if (oletusAlv) {
              const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
              if (naytettavaKirjaus?.kirjaus?.p) {
                oletusAlv = OstoAlvt.flip14PercentageTo135AndViceVersaBasedOnDate(oletusAlv, naytettavaKirjaus.kirjaus.p)
                oletusAlv = MyyntiAlvt.flip14PercentageTo135AndViceVersaBasedOnDate(oletusAlv, naytettavaKirjaus.kirjaus.p)
              }
              rivi.kirjausrivi.a = oletusAlv.tunniste
              rivi.alv = oletusAlv.lyhenne
              this.paivitaKirjausrivinAlvRivi(rivi, naytettavaKirjaus, true, arvoavain)
              this.alvSubject.next(null)
            }
          }
          //  else if (t.alvTyyppi === KirjanpitotilinAlvTyyppi.ETAMYYNTI) {

          //   const oletusAlv = this._kaikkiAlvtTunnisteenMukaanMap.get(t.oletusAlvKasittely?.tunniste)
          //   if (oletusAlv && !rivi.kirjausrivi.a) {
          //     rivi.kirjausrivi.a = oletusAlv.tunniste
          //     rivi.alv = oletusAlv.lyhenne
          //     const kirjaus = this.annaNaytettavaKirjaus(arvoavain)
          //     this.paivitaKirjausrivinAlvRivi(rivi, kirjaus, true, arvoavain)
          //     this.alvSubject.next(null)
          //   }
          // }
        }

        const alv = this._kaikkiAlvtTunnisteenMukaanMap.get(rivi.kirjausrivi.a)
        const value = alv?.lyhenne || ''
        this.focusInput(this._alvInput.nativeElement, targetElement, value, arvoavain)
        this.asetaViimeisinTiedossaOlevaFokus(arvoavain, 'ka')
      } else {
        this._kaikkiValittavissaOlevatAlvt.next([])
      }
    } else if (targetElement.classList.contains('kko')) {
      const arvoavain = this.etsiArvoavain(targetElement)
      const rivi = this._riviMap.get(arvoavain)
      if (rivi && !rivi.lukittu) {
        this.focusInput(this._kommenttiInput.nativeElement, targetElement, rivi.kommentti, arvoavain)
        this.asetaViimeisinTiedossaOlevaFokus(arvoavain, 'kko')
        this.kommenttiSubject.next(rivi.kommentti)
        if (rivi.kirjausrivi && this.onkoTiliKuititonTili(rivi.kirjausrivi.t)) {
          const kommentit = this._asiakas.laskunKieli === 'en' ? this._kaikkiAutocompleteKommentitEn : this._kaikkiAutocompleteKommentitFi
          this._suodatetutKommentitSubject.next(kommentit)
          setTimeout(() => {
            this._kommenttiAutocompleteTrigger.openPanel()
          }, 25)
        } else {
          this._suodatetutKommentitSubject.next([])
        }
      }
    }
    // })
  }

  private asetaViimeisinTiedossaOlevaFokus(arvoavain: string, tekstiboksi: TekstiboksinTunnus) {
    this.lastKnownFocus = { arvoavain: arvoavain, tekstiboksi: tekstiboksi }
  }

  private palautaViimeisinTiedossaOlevaFokus() {
    if (this.lastKnownFocus && this.lastKnownFocus.arvoavain && this.lastKnownFocus.tekstiboksi) {
      const naytettavaKirjaus = this.annaNaytettavaKirjaus(this.lastKnownFocus.arvoavain)
      if (naytettavaKirjaus && naytettavaKirjaus === this._valittuNaytettavaKirjausSubject.value) {
        const element = document.querySelector('[data-arvoavain="' + this.lastKnownFocus.arvoavain + '"] .' + this.lastKnownFocus.tekstiboksi) as HTMLElement
        if (element) {
          // console.log('klikkaa', element)
          this.muokkaaSolua(element)
        }
      }
    }
  }

  // private findPreviousSibblingElementWithClass(element: HTMLElement, markerClass: string) {
  //   if (element.classList.contains(markerClass)) {
  //     return element
  //   }
  //   this.findPreviousSibblingElementWithClass(element.previousElementSibling as HTMLElement, markerClass)
  // }

  private _closeKommenttiAuto() {
    if (this._kommenttiAutocomplete?.isOpen) {
      this._kommenttiAutocompleteTrigger?.closePanel()
    }
    if (this._suodatetutKommentitSubject.value?.length > 0) {
      this._suodatetutKommentitSubject.next([])
    }
    if (this.kommenttiSubject.value !== null) {
      this.kommenttiSubject.next(null)
    }
  }

  private _closeAlvAuto() {
    if (this._alvAutocomplete?.isOpen) {
      this._alvAutocompleteTrigger?.closePanel()
    }
    if (this._suodatetutAlvtSubject.value?.length > 0) {
      this._suodatetutAlvtSubject?.next([])
    }
    if (this.alvSubject.value !== null) {
      this.alvSubject.next(null)
    }
  }

  private _closeTiliAuto() {
    if (this._tiliAutocomplete?.isOpen) {
      this._tiliAutocompleteTrigger?.closePanel()
    }
    if (this.tilinumeroSubject.value !== null) {
      this.tilinumeroSubject.next(null)
    }
  }

  private focusInput(input: HTMLInputElement, targetElement: HTMLElement, value: string, arvoavain: string) {
    // input.style.width = '100%'
    // input.style.left = '0'

    if (input === this._tnroInput.nativeElement) {
      // this._closeTiliAuto()
      this._closeAlvAuto()
      this._closeKommenttiAuto()
    } else if (input === this._kreditInput.nativeElement || input === this._debetInput.nativeElement) {
      this._closeTiliAuto()
      this._closeAlvAuto()
      this._closeKommenttiAuto()
    } else if (input === this._alvInput.nativeElement) {
      this._closeTiliAuto()
      // this._closeAlvAuto()
      this._closeKommenttiAuto()
    } else if (input === this._kommenttiInput.nativeElement) {
      this._closeTiliAuto()
      this._closeAlvAuto()
      // this._closeKommenttiAuto()
    }

    // targetElement.style.position = 'relative'
    const kirjausElement = this.etsiKirjausElement(targetElement)
    if (kirjausElement) {
      kirjausElement.classList.add('active')
    }
    targetElement.parentElement.insertBefore(input, targetElement)
    targetElement.classList.remove('v')
    targetElement.style.display = 'none'
    input.style.display = 'block'
    input.classList.remove('v')

    input.focus()
    input.value = value
    input.select()

    this.vaihdaValittuKirjausArvoavaimella(arvoavain, false)
  }

  @HostListener('focusout', ['$event'])
  lopetaSolunMuokkaus(event: FocusEvent) {
    // console.log('lopetaSolunMuokkaus', (event.target as HTMLInputElement)?.value, event.target)
    // this._ngZone.runOutsideAngular(() => {
    // const relatedElement = event.relatedTarget as HTMLElement
    // console.log('focus lost from', event.target, 'focus set to', relatedElement)

    if (event.target === this._tnroInput.nativeElement) {
      this.unfocusInput(this._tnroInput.nativeElement)
      const arvoavain = this.etsiArvoavain(this._tnroInput.nativeElement)
      const rivi = this._riviMap.get(arvoavain)
      if (rivi) {
        rivi.knTabIndexPoistettu = false
      }
    } else if (event.target === this._debetInput.nativeElement) {
      this.unfocusInput(this._debetInput.nativeElement)
    } else if (event.target === this._kreditInput.nativeElement) {
      this.unfocusInput(this._kreditInput.nativeElement)
    } else if (event.target === this._alvInput.nativeElement) {
      this.unfocusInput(this._alvInput.nativeElement)
    } else if (event.target === this._kommenttiInput.nativeElement) {
      this.unfocusInput(this._kommenttiInput.nativeElement)
    }
  }

  private unfocusInput(input: HTMLInputElement) {
    const div = input.nextElementSibling as HTMLElement
    div.style.display = 'block'
    const kirjausElement = this.etsiKirjausElement(div)
    if (kirjausElement) {
      kirjausElement.classList.remove('active')
    }
    input.style.display = 'none'
  }

  @HostListener('document:keydown.shift.delete', ['$event'])
  async poistaRivi(event: Event) {
    const element = event.target as HTMLElement
    const kirjausElement = this.etsiKirjausElement(element)
    if (kirjausElement) {
      const arvoavain = this.etsiArvoavain(element)
      if (arvoavain) {
        const rivi = this._riviMap.get(arvoavain)
        const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
        if (!rivi.lukittu && this.annaMuokattavissaOlevienRivienMaara(naytettavaKirjaus) > 1) {
          this.poistaAlvRivit(arvoavain, rivi, naytettavaKirjaus)

          const index = naytettavaKirjaus.naytettavatKirjausrivit.indexOf(rivi)
          naytettavaKirjaus.kirjaus.rivit.splice(index, 1)
          naytettavaKirjaus.naytettavatKirjausrivit.splice(index, 1)

          // Update the lookup map
          this.paivitaRivienLookupMapAvaimet(arvoavain, naytettavaKirjaus)

          this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)
          this.paivitaKirjauksessaYhteisomyyntiVatKentta(naytettavaKirjaus)
          naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
          this.preventEvent(event)

          this._closeTiliAuto()
          this._closeAlvAuto()
          this._closeKommenttiAuto()

          await this.sleep(100)
          const alku = this.annaArvoavainIlmanIndeksia(arvoavain)
          const el = document.querySelector('div[data-arvoavain="' + alku + '0"]') as HTMLElement
          if (el) {
            await this._aktivoiKirjausJaKohdistaFokusViimeiseenTiliboksiin(el.parentElement, true)
          }
        }
      }
    }
  }

  private annaMuokattavissaOlevienRivienMaara(naytettavaKirjaus: NaytettavaKirjaus): number {
    let maara = 0
    for (const rivi of naytettavaKirjaus.naytettavatKirjausrivit) {
      if (!rivi.lukittu && !this.onkoNaytettavariviAlvrivi(rivi)) {
        maara++
      }
    }
    return maara
  }

  @HostListener('document:keydown.arrowdown', ['$event'])
  async siirraKohdistusSeuraavaanKirjaukseen(event: Event) {
    const element = event.target as HTMLElement
    if (this._kommenttiAutocomplete.isOpen || this._tiliAutocomplete.isOpen || this._alvAutocomplete.isOpen) {
      return
    }
    const kirjausElement = this.etsiKirjausElement(element)
    if (kirjausElement) {
      const arvoavain = this.etsiArvoavain(element)
      const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
      const validointiOk = this.poistaViimeinenRiviJosTyhjaJaValidointiOnOk(naytettavaKirjaus)
      if (!validointiOk) {
        return
      }
      this._tallennaKirjaus(naytettavaKirjaus)

      const nextKirjaus = this.etsiSeuraavaKirjaus(kirjausElement)
      if (nextKirjaus) {
        await this._aktivoiKirjausJaKohdistaFokusViimeiseenTiliboksiin(nextKirjaus, true)
      } else {
        const lisaaKirjausNappi = this.etsiLisaaNappi(kirjausElement)
        if (lisaaKirjausNappi) {
          lisaaKirjausNappi.focus()
        } else {
          console.log('TODO: THIS WAS LAST KIRJAUS, MOVE FOCUS TO NEXT BUTTON!')
        }
      }
    }
  }

  @HostListener('document:keydown.arrowup', ['$event'])
  async siirraKohdistusEdelliseenKirjaukseen(event: Event) {
    const element = event.target as HTMLElement
    if (this._kommenttiAutocomplete.isOpen || this._tiliAutocomplete.isOpen || this._alvAutocomplete.isOpen) {
      return
    }
    const kirjausElement = this.etsiKirjausElement(element)
    if (kirjausElement) {
      const arvoavain = this.etsiArvoavain(element)
      const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
      const validointiOk = this.poistaViimeinenRiviJosTyhjaJaValidointiOnOk(naytettavaKirjaus)
      if (!validointiOk) {
        return
      }
      const previousKirjaus = this.etsiEdellinenKirjaus(kirjausElement)
      if (previousKirjaus) {
        await this._aktivoiKirjausJaKohdistaFokusViimeiseenTiliboksiin(previousKirjaus, true)
      }
    }
  }

  private async _aktivoiKirjausJaKohdistaFokusViimeiseenTiliboksiin(kirjausElement: HTMLElement, scrollaa: boolean) {
    const allKns = kirjausElement.querySelectorAll('.kn')
    const reversed = Array.from(allKns).reverse() as HTMLElement[]

    /** Fix buggy behaviour in comment autocomplete panel (Note! check ._isOpen instead of .isOpen, since the public state might be wrongly set to false) */
    if (this._kommenttiAutocomplete._isOpen) {
      this._kommenttiAutocompleteTrigger.closePanel()
    }

    const kirjausavain = kirjausElement.dataset.kirjausavain
    const valittuKirjaus = this._kirjausMap.get(kirjausavain)
    if (this._tilikausiLukossa || (valittuKirjaus?.kirjaus && this.onkoKirjausLukittu(valittuKirjaus.kirjaus))) {
      await this.vaihdaValittuKirjausKirjausavaimella(kirjausavain, scrollaa)
      return
    }

    for (const kn of reversed) {
      const focusableFromKirjaus = this.getNextFocusableElementFromThisKirjaus(kn, false)
      if (focusableFromKirjaus) {
        const arvoavain = this.etsiArvoavain(focusableFromKirjaus)
        await this.vaihdaValittuKirjausArvoavaimella(arvoavain, scrollaa).then(() => {
          // setTimeout(() => {
          focusableFromKirjaus.focus()
          // }, 25)
        })
        return
      }
    }

    const lastElementFromKirjaus = allKns && allKns.length > 0 ? (allKns[allKns.length - 1] as HTMLElement) : null
    this.addRowToCurrentKirjaus(lastElementFromKirjaus)
    // setTimeout(() => {
    const nextFocusable = this.getNextFocusableElementFromThisKirjaus(lastElementFromKirjaus, false)
    if (nextFocusable) {
      const nextArvoavain = this.etsiArvoavain(nextFocusable)
      await this.vaihdaValittuKirjausArvoavaimella(nextArvoavain, scrollaa).then(() => {
        // setTimeout(() => {
        nextFocusable.focus()
        // }, 25)
      })
    }
    // }, 0)
  }

  @HostListener('click', ['$event'])
  async klikatutEventit(event: MouseEvent) {
    const element = event.target as HTMLElement
    // console.log(element)
    const kirjausElement = this.etsiKirjausElement(element)
    if (element.classList.contains('selectable-text')) {
      if (kirjausElement) {
        const kirjausavain = kirjausElement.dataset.kirjausavain
        await this.vaihdaValittuKirjausKirjausavaimella(kirjausavain, false)
      }
      this.preventEvent(event)
    } else if (element.classList.contains('aiempi-versio')) {
      // const firstElementFromKirjaus = kirjausElement.querySelector('.kn') as HTMLElement
      // const arvoavain = this.etsiArvoavain(firstElementFromKirjaus)
      // const naytettavaKirjaus = await this.vaihdaValittuKirjausArvoavaimella(arvoavain, false)
      // const versio = await this._annaKirjauksenEdellisetVersiot(naytettavaKirjaus)
      // const edellinenKirjaus = versio && versio.edellinen ? versio.edellinen : null
      // const sitaEdellinenKirjaus = versio && versio.sitaEdellinen ? versio.sitaEdellinen : null
      // if (edellinenKirjaus) {
      //   const seuraaviaVersioitaEnnenPaivitysta = naytettavaKirjaus.seuraaviaVersioita
      //   this.paivitaNaytettavaKirjausKirjauksesta(naytettavaKirjaus, edellinenKirjaus)
      //   this.paivitaRivienLookupMapAvaimet(arvoavain, naytettavaKirjaus)
      //   naytettavaKirjaus.nykyisenVersionTimestamp = edellinenKirjaus.kirjausTallennettu
      //   naytettavaKirjaus.edellisiaVersioita = !!sitaEdellinenKirjaus
      //   console.log('naytettavaKirjaus.seuraaviaVersioita', seuraaviaVersioitaEnnenPaivitysta)
      //   naytettavaKirjaus.seuraavaOnNykyinen = !seuraaviaVersioitaEnnenPaivitysta
      //   naytettavaKirjaus.seuraaviaVersioita = true
      //   console.log('naytettavaKirjaus.edellisiaVersioita', naytettavaKirjaus.edellisiaVersioita, 'naytettavaKirjaus.seuraavaOnNykyinen', naytettavaKirjaus.seuraavaOnNykyinen, 'naytettavaKirjaus.seuraaviaVersioita', naytettavaKirjaus.seuraaviaVersioita)
      //   for (const rivi of naytettavaKirjaus.naytettavatKirjausrivit) {
      //     rivi.lukittu = true
      //   }
      //   this._valittuNaytettavaKirjausSubject.next(naytettavaKirjaus)
      // }
      // console.log('aiempi-versio', naytettavaKirjaus.kirjaus.avain)
    } else if (element.classList.contains('uudempi-versio')) {
      // const firstElementFromKirjaus = kirjausElement.querySelector('.kn') as HTMLElement
      // const arvoavain = this.etsiArvoavain(firstElementFromKirjaus)
      // const naytettavaKirjaus = await this.vaihdaValittuKirjausArvoavaimella(arvoavain, true)
      // if (naytettavaKirjaus.seuraavaOnNykyinen) {
      //   const [kirjaus, tiedot] = await firstValueFrom(combineLatest([this.annaObservableNykyiseenVersioon(naytettavaKirjaus.kirjaus.avain), this.valittuKuukausiJaLataustiedotJaRuutuObservable]))
      //   this.paivitaNaytettavaKirjausKirjauksesta(naytettavaKirjaus, kirjaus)
      //   this.paivitaRivienLookupMapAvaimet(arvoavain, naytettavaKirjaus)
      //   naytettavaKirjaus.nykyisenVersionTimestamp = kirjaus.kirjausTallennettu
      //   naytettavaKirjaus.edellisiaVersioita = true
      //   naytettavaKirjaus.seuraaviaVersioita = false
      //   naytettavaKirjaus.seuraavaOnNykyinen = false
      //   const maksutapa = this._kirjauksetMaksutavoittainSubject.value.mjk.find(m => m.maksutapa.tunniste + '' === naytettavaKirjaus.kirjaus.maksutavanTunniste + '')
      //   let riviIndex = 0
      //   for (const rivi of naytettavaKirjaus.naytettavatKirjausrivit) {
      //     if (!rivi.lukittu) {
      //       rivi.lukittu = this._onkoRiviLukittuMaksutavanTakia(riviIndex, rivi, maksutapa.maksutapa, tiedot.kuukausi)
      //     }
      //     riviIndex++
      //   }
      //   this._valittuNaytettavaKirjausSubject.next(naytettavaKirjaus)
      // } else if (naytettavaKirjaus.seuraaviaVersioita) {
      //   const versio = await firstValueFrom(this.annaObservableSeuraavaanVersioon(naytettavaKirjaus))
      //   const seuraavaKirjaus = versio && versio.seuraava ? versio.seuraava : null
      //   const sitaSeuraavaKirjaus = versio && versio.sitaSeuraava ? versio.sitaSeuraava : null
      //   const sitaSitaSeuraavaKirjaus = versio && versio.sitaSitaSeuraava ? versio.sitaSitaSeuraava : null
      //   if (seuraavaKirjaus) {
      //     this.paivitaNaytettavaKirjausKirjauksesta(naytettavaKirjaus, seuraavaKirjaus)
      //     this.paivitaRivienLookupMapAvaimet(arvoavain, naytettavaKirjaus)
      //     naytettavaKirjaus.nykyisenVersionTimestamp = seuraavaKirjaus.kirjausTallennettu
      //     naytettavaKirjaus.edellisiaVersioita = true
      //     naytettavaKirjaus.seuraaviaVersioita = !!sitaSeuraavaKirjaus
      //     naytettavaKirjaus.seuraavaOnNykyinen = !sitaSitaSeuraavaKirjaus
      //     for (const rivi of naytettavaKirjaus.naytettavatKirjausrivit) {
      //       rivi.lukittu = true
      //     }
      //     this._valittuNaytettavaKirjausSubject.next(naytettavaKirjaus)
      //   }
      // }
      // console.log('uudempi-versio', naytettavaKirjaus.kirjaus.avain)
      // } else if (element.classList.contains('klp')) {
      //   const kirjausAvain = kirjausElement.dataset.kirjausavain
      //   const valittuKirjaus = this._kirjausMap.get(kirjausAvain)
      //   if (valittuKirjaus) {
      //     this.poistaKirjaus(valittuKirjaus)
      //   }
    } else if (element.classList.contains('tpvm')) {
      const kirjausAvain = kirjausElement.dataset.kirjausavain
      const valittuKirjaus = this._kirjausMap.get(kirjausAvain)

      if (valittuKirjaus) {
        const data: KirjausMuutaPaivamaaraDialogData = {
          naytettavaKirjaus: valittuKirjaus,
          asiakas: this._asiakas,
        }
        const pvmDialogResult = await firstValueFrom(
          this._dialog.open<KirjausMuutaPaivamaaraDialog, KirjausMuutaPaivamaaraDialogData, boolean>(KirjausMuutaPaivamaaraDialog, { data: data }).beforeClosed(),
        )
        if (pvmDialogResult) {
          valittuKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(valittuKirjaus)
          this._valittuNaytettavaKirjausSubject.next(valittuKirjaus)
          if (valittuKirjaus.kirjaus.t === KirjauksenTyyppi.AUTOMAATTIKIRJAUS_VAIN_PVM_MUOKATTAVISSA) {
            await this._tallennaKirjaus(valittuKirjaus)
          }
        }
      }
    } else if (kirjausElement) {
      const kirjausavain = kirjausElement.dataset.kirjausavain
      const naytettavaKirjaus = await this.vaihdaValittuKirjausKirjausavaimella(kirjausavain, false)
      if (
        !this.onkoKirjausLukittu(naytettavaKirjaus.kirjaus) &&
        !element.classList.contains('knc') &&
        !element.classList.contains('kn') &&
        !element.classList.contains('knr') &&
        !element.classList.contains('kd') &&
        !element.classList.contains('kk') &&
        !element.classList.contains('ka') &&
        !element.classList.contains('kko') &&
        !element.classList.contains('kni') &&
        !element.classList.contains('kdi') &&
        !element.classList.contains('kki') &&
        !element.classList.contains('kai') &&
        !element.classList.contains('kkoi') &&
        !element.classList.contains('kr') &&
        !element.classList.contains('kr-projekti-dot')
      ) {
        await this._aktivoiKirjausJaKohdistaFokusViimeiseenTiliboksiin(kirjausElement, false)
      }
    }

    // Skip close if we clicked the kortti itself
    // that opens the esikatselu or the esikatselu window.
    if (!element.closest('.kirjaamaton-kortti') && !element.closest('.app-kirjanpito-tosite-esikatselu')) {
      this._kirjanpitoImageHandlerService.lopetaEsikatselu()
    }

    if (element.classList.contains('avaa-debug')) {
      const show = await firstValueFrom(this.naytaTestiObservable)
      if (show) {
        const firstElementFromKirjaus = kirjausElement.querySelector('.kn') as HTMLElement
        const arvoavain = this.etsiArvoavain(firstElementFromKirjaus)
        const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
        if (naytettavaKirjaus) {
          const data: KirjausDiagnoseHelpDialogData = {
            naytettavaKirjaus: naytettavaKirjaus,
          }
          this._dialog.open(KirjausDiagnoseHelpDialog, { data: data })
        }
      }
    }
  }

  avaaKonversioInfoDialog(naytettavaKirjaus: NaytettavaKirjaus) {
    if (naytettavaKirjaus?.kirjaus?.valuuttakonversio) {
      const konversioTiedot = naytettavaKirjaus.kirjaus.valuuttakonversio

      let aika = '?'
      if (naytettavaKirjaus.kirjaus.valuuttakonversio.kurssi?.ratedAt) {
        const kurssinAikaleima = this._dateService.numberTimestampToLocalDateTime(naytettavaKirjaus.kirjaus.valuuttakonversio.kurssi.ratedAt)
        aika = this._dateService.muotoilePaivaJaAikaPaikallinen(kurssinAikaleima, 'fi')
      }

      let summat = ''
      const asTilitapahtumaConversion = naytettavaKirjaus.kirjaus.valuuttakonversio as ValuuttakonversionTiedotTilitapahtumassa
      if (asTilitapahtumaConversion.alkuperainenSaldo && asTilitapahtumaConversion.alkuperainenSumma) {
        summat = `<p><strong>Alkuperäinen summa:</strong> ${this._currencyService.formatoiDesimaaliLisaaValilyontiTuhanteen(asTilitapahtumaConversion.alkuperainenSumma, 2, 2, 'fi')} ${asTilitapahtumaConversion.lahdevaluutta}</p>
                  <p><strong>Alkuperäinen saldo:</strong> ${this._currencyService.formatoiDesimaaliLisaaValilyontiTuhanteen(asTilitapahtumaConversion.alkuperainenSaldo, 2, 2, 'fi')} ${asTilitapahtumaConversion.lahdevaluutta}</p>`
      }

      const data: InfoDialogData = {
        header: 'Valuuttakonversion tiedot',
        text: `<p>Valuuttakonversio tehtiin ${asTilitapahtumaConversion.alkuperainenSumma ? 'tilitapahtumalle' : 'laskulle'}</p>
          <p><strong>Lemonator haki kurssitiedot:</strong> ${this._dateService.muotoilePaivaJaAikaDate(this._dateService.timestampToDate(konversioTiedot.hakuaikaleima), 'fi')}</p>
          <p><strong>Kurssi ${konversioTiedot.lahdevaluutta} -> ${konversioTiedot.kohdevaluutta}:</strong> ${konversioTiedot.kurssi.rate}</p>
          <p><strong>Kurssin aikaleima:</strong> ${aika}</p>
          ${summat}`,
      }
      this._dialog.open<InfoDialog, InfoDialogData>(InfoDialog, { data: data })
    }
  }

  async avaaVatMuutosDialog(naytettavaKirjaus: NaytettavaKirjaus) {
    if (naytettavaKirjaus) {
      const data: KirjausMuutaVatDialogData = {
        naytettavaKirjaus: naytettavaKirjaus,
        asiakas: this._asiakas,
      }
      const vatDialogTulos = await firstValueFrom(this._dialog.open<KirjausMuutaVatDialog, KirjausMuutaVatDialogData, boolean>(KirjausMuutaVatDialog, { data: data }).beforeClosed())
      if (vatDialogTulos) {
        this._ladataanService.aloitaLataaminen()
        naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
        this._valittuNaytettavaKirjausSubject.next(naytettavaKirjaus)
        await this._tallennaKirjaus(naytettavaKirjaus)
        this._ladataanService.lopetaLataaminen()
      }
    }
  }

  poistaKirjaus(naytettavaKirjaus: NaytettavaKirjaus) {
    const data: KirjausPoistaDialogData = {
      naytettavaKirjaus: naytettavaKirjaus,
    }
    const dialog = this._dialog.open<KirjausPoistaDialog, KirjausPoistaDialogData, KirjausPoistaDialogResult>(KirjausPoistaDialog, { data: data })
    firstValueFrom(dialog.beforeClosed()).then(result => {
      if (result?.poistoPromise) {
        naytettavaKirjaus.poistetaan = true
        naytettavaKirjaus.tallentamattomiaMuutoksia = false
        naytettavaKirjaus.tallennetaan = true
        this._valittuNaytettavaKirjausSubject.next(naytettavaKirjaus)
        result.poistoPromise
          .then(resp => {
            if (!resp || resp.e) {
              throw new Error('Poisto epäonnistui! ' + (resp?.e || 'No response'))
            }

            this._valittuNaytettavaKirjausSubject.next(null)
          })
          .catch(err => {
            naytettavaKirjaus.tallennetaan = false
            naytettavaKirjaus.tallentamattomiaMuutoksia = true
            naytettavaKirjaus.kirjauksenVirhe = 'Tallentamisen aikana tapahtui virhe. Ole hyvä ja yritä uudelleen.'
            this._errorHandler.handleError(err)
          })
      }
    })
  }

  async peruutaPoistaKirjaus(naytettavaKirjaus: NaytettavaKirjaus) {
    naytettavaKirjaus.kirjaus.kirjausnumero = null
    naytettavaKirjaus.kirjaus.poistettu = false
    naytettavaKirjaus.poistetaan = true
    await this._tallennaKirjaus(naytettavaKirjaus)
    naytettavaKirjaus.poistetaan = false
  }

  siirraKirjaus(naytettavaKirjaus: NaytettavaKirjaus, isYberSuper: boolean) {
    if (naytettavaKirjaus.kirjaus.t === KirjauksenTyyppi.AUTOMAATTIKIRJAUS_VAIN_PVM_MUOKATTAVISSA) {
      const dialogData: KirjausMuutaPaivamaaraDialogData = {
        naytettavaKirjaus: naytettavaKirjaus,
        asiakas: this._asiakas,
      }
      firstValueFrom(this._dialog.open(KirjausMuutaPaivamaaraDialog, { data: dialogData }).beforeClosed()).then(async result => {
        if (result) {
          const uusiPaivamaara = naytettavaKirjaus.uusiPaivamaara
          naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
          this._valittuNaytettavaKirjausSubject.next(naytettavaKirjaus)
          this._tallennaKirjaus(naytettavaKirjaus).then(async () => {
            if (uusiPaivamaara) {
              const tiedot = await firstValueFrom(this.valittuKuukausiJaLataustiedotJaRuutuObservable)
              const uusiPvmLocal = this._dateService.numberToLocalDate(uusiPaivamaara)
              await this._vaihdaKuukausiJosTarvitsee(uusiPvmLocal.year, uusiPvmLocal.month, naytettavaKirjaus.kirjaus.avain, null, null, tiedot.kuukausi)
            }
          })
        }
      })
      return
    }

    const data: KirjausSiirraDialogData = {
      naytettavaKirjaus: naytettavaKirjaus,
      maksutavat: Array.from(this._kaikkiMaksutavatMap.values()),
      asiakas: this._asiakas,
      isYberSuper: isYberSuper,
    }

    firstValueFrom(this._dialog.open(KirjausSiirraDialog, { data: data }).beforeClosed()).then(async result => {
      if (result) {
        const uusiMaksutapa = naytettavaKirjaus.uusiMaksutapa
        const uusiPaivamaara = naytettavaKirjaus.uusiPaivamaara

        naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
        this._valittuNaytettavaKirjausSubject.next(naytettavaKirjaus)
        this._tallennaKirjaus(naytettavaKirjaus).then(async () => {
          if (uusiPaivamaara && uusiMaksutapa) {
            const uusiPvmLocal = this._dateService.numberToLocalDate(uusiPaivamaara)
            const tiedot = await firstValueFrom(this.valittuKuukausiJaLataustiedotJaRuutuObservable)
            await this._vaihdaKuukausiJosTarvitsee(uusiPvmLocal.year, uusiPvmLocal.month, naytettavaKirjaus.kirjaus.avain, null, uusiMaksutapa, tiedot.kuukausi)
            // await this.sleep(500)
            // await this.vaihdaMaksutapaJosTarvitseeJaKohdistaKirjaukseen(naytettavaKirjaus.kirjaus.avain, uusiMaksutapa)
          } else if (uusiPaivamaara) {
            const uusiPvmLocal = this._dateService.numberToLocalDate(uusiPaivamaara)
            const tiedot = await firstValueFrom(this.valittuKuukausiJaLataustiedotJaRuutuObservable)
            await this._vaihdaKuukausiJosTarvitsee(uusiPvmLocal.year, uusiPvmLocal.month, naytettavaKirjaus.kirjaus.avain, null, null, tiedot.kuukausi)
          } else if (uusiMaksutapa) {
            await this.sleep(500)
            await this.vaihdaMaksutapaJosTarvitseeJaKohdistaKirjaukseen(naytettavaKirjaus.kirjaus.avain, uusiMaksutapa)
          }
        })
      }
    })
  }

  muokkaaViitenumeroa(naytettavaKirjaus: NaytettavaKirjaus) {
    const data: KirjausMuokkaaViitenumeroaDialogData = {
      naytettavaKirjaus: naytettavaKirjaus,
      asiakas: this._asiakas,
    }

    firstValueFrom(this._dialog.open(KirjausMuokkaaViitenumeroaDialog, { data: data }).beforeClosed()).then(async result => {
      if (result) {
        this._valittuNaytettavaKirjausSubject.next(naytettavaKirjaus)
        return this._tallennaKirjaus(naytettavaKirjaus)
      }
    })
  }

  jaksotaKirjaus(naytettavaKirjaus: NaytettavaKirjaus) {
    this.paivitaNaytettavanKirjauksenValidointi(naytettavaKirjaus)

    const data: KirjausJaksotaDialogData = {
      naytettavaKirjaus: naytettavaKirjaus,
      maksutavat: Array.from(this._kaikkiMaksutavatMap.values()),
      asiakas: this._asiakas,
    }

    this._dialog.open<KirjausJaksotaDialog, KirjausJaksotaDialogData, { jaksotus: Kirjaus; vasta: Kirjaus; alkuperainen: Kirjaus }>(KirjausJaksotaDialog, { data: data })

    // .beforeClosed().pipe(
    //   take(1)
    // ).subscribe(async data => {
    //   if (data?.jaksotus && data?.vasta) {

    //   }
    // })
  }

  kopioiKirjaus(naytettavaKirjaus: NaytettavaKirjaus) {
    const data: KirjausKopioiDialogData = {
      naytettavaKirjaus: naytettavaKirjaus,
      maksutavat: Array.from(this._kaikkiMaksutavatMap.values()),
      asiakas: this._asiakas,
    }

    const dialog = this._dialog.open<KirjausKopioiDialog, KirjausKopioiDialogData, Kirjaus>(KirjausKopioiDialog, { data: data })
    firstValueFrom(dialog.beforeClosed()).then(async uusiKirjaus => {
      if (uusiKirjaus) {
        this._ladataanService.aloitaLataaminen()

        const asiakas = await firstValueFrom(this._asiakasService.nykyinenAsiakasAvainObservable)

        const liitettyjenTiedostojenSivutUri = this._kirjanpitoUriService.annaKirjaukseenLiitettyjenTiedostojenUri(asiakas.avain, naytettavaKirjaus.kirjaus.avain)
        const liitettyjenTiedostojenSivutDoc = this._lemonatorFirebase.firestoreDoc<KirjaukseenLiitettyjenTiedostojenSivut>(liitettyjenTiedostojenSivutUri)
        const liitettyjenTiedostojenSivut = await liitettyjenTiedostojenSivutDoc.get()

        const pyynto: KirjauksenTallennuspyyntoUusi = {
          asiakasAvain: asiakas.avain,
          kirjaus: uusiKirjaus,
          liitetyt: liitettyjenTiedostojenSivut,
        }

        try {
          const resp = await this._lemonatorFirebase.functionsCall<KirjauksenTallennuspyyntoUusi, KirjauksenTallennusvastaus>('kirjanpitoKirjauksetKopioiKirjaus', pyynto)

          if (!resp || resp.e) {
            throw new Error('Kirjauksen kopiointi epäonnistui! ' + (resp?.e || 'No response'))
          }
        } catch (err) {
          naytettavaKirjaus.kirjauksenVirhe = 'Kopion tallentamisen aikana tapahtui virhe. Ole hyvä ja yritä uudelleen.'
          this._errorHandler.handleError(err)
        } finally {
          this._ladataanService.lopetaLataaminen()
        }
      }
    })
  }

  teeSuoriteperusteinen(naytettavaKirjaus: NaytettavaKirjaus) {
    const data: KirjausMuutaSuoriteperusteiseksiDialogData = {
      naytettavaKirjaus: naytettavaKirjaus,
      maksutavat: Array.from(this._kaikkiMaksutavatMap.values()),
      asiakas: this._asiakas,
    }

    const dialog = this._dialog.open<KirjausMuutaSuoriteperusteiseksiDialog, KirjausMuutaSuoriteperusteiseksiDialogData, KirjausMuutaSuoriteperusteiseksiDialogReturnValue>(
      KirjausMuutaSuoriteperusteiseksiDialog,
      { data: data },
    )
    firstValueFrom(dialog.beforeClosed()).then(async returnValue => {
      if (returnValue?.muutettavaKirjaus && returnValue?.ostolaskuKirjauksenPaivamaara) {
        this._ladataanService.aloitaLataaminen()

        const asiakas = await firstValueFrom(this._asiakasService.nykyinenAsiakasAvainObservable)

        const liitettyjenTiedostojenSivutUri = this._kirjanpitoUriService.annaKirjaukseenLiitettyjenTiedostojenUri(asiakas.avain, returnValue.muutettavaKirjaus.avain)
        const liitettyjenTiedostojenSivutDoc = this._lemonatorFirebase.firestoreDoc<KirjaukseenLiitettyjenTiedostojenSivut>(liitettyjenTiedostojenSivutUri)
        const liitettyjenTiedostojenSivut = await liitettyjenTiedostojenSivutDoc.get()

        const pyynto: MuutaKirjausSuoriteperusteiseksiPyynto = {
          asiakasAvain: asiakas.avain,
          kirjaus: returnValue.muutettavaKirjaus,
          liitetyt: liitettyjenTiedostojenSivut,
          uudenKirjauksenPaivamaara: returnValue.ostolaskuKirjauksenPaivamaara,
        }

        return this._lemonatorFirebase
          .functionsCall<MuutaKirjausSuoriteperusteiseksiPyynto, KirjauksenTallennusvastaus>('kirjanpitoKirjauksetMuutaKirjausSuoriteperusteiseksi', pyynto, { timeout: 540 * 1000 })
          .finally(() => {
            this._ladataanService.lopetaLataaminen()
          })
      }
    })

    this.paivitaNaytettavanKirjauksenValidointi(naytettavaKirjaus)
    naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
  }

  teeVastakirjaus(naytettavaKirjaus: NaytettavaKirjaus) {
    if (!naytettavaKirjaus?.naytettavatKirjausrivit) {
      return
    }
    for (const naytettavaRivi of naytettavaKirjaus.naytettavatKirjausrivit) {
      if (naytettavaRivi.kirjausrivi.d !== undefined || naytettavaRivi.kirjausrivi.d !== null || naytettavaRivi.kirjausrivi.k !== undefined || naytettavaRivi.kirjausrivi.k !== null) {
        const debet = naytettavaRivi.kirjausrivi.d
        const kredit = naytettavaRivi.kirjausrivi.k

        naytettavaRivi.kirjausrivi.k = debet ?? null
        naytettavaRivi.kreditlukittu = !naytettavaRivi.kreditlukittu

        naytettavaRivi.debetlukittu = !naytettavaRivi.debetlukittu
        naytettavaRivi.kirjausrivi.d = kredit ?? null

        naytettavaRivi.debet = kredit ? this._currencyService.formatoiDesimaaliSailytaNollat(kredit, 2, 'fi') : ''
        naytettavaRivi.kredit = debet ? this._currencyService.formatoiDesimaaliSailytaNollat(debet, 2, 'fi') : ''
      }
    }

    this.paivitaNaytettavanKirjauksenValidointi(naytettavaKirjaus)
    naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
  }

  toggleMuokkaaMitaVain() {
    if (this._allKirjauksetAndAccountsCanBeEdited.value) {
      this._allKirjauksetAndAccountsCanBeEdited.next(false)
      this._useValidationBeforeSaveSubject.next(true)
    } else {
      this._allKirjauksetAndAccountsCanBeEdited.next(true)
      this._useValidationBeforeSaveSubject.next(false)
    }
    this._setupValittavatTilit()
  }

  onkoKirjausLukittu(kirjaus: Kirjaus): boolean {
    return true // Tilintarkastajat: lukitaan kirjaukset aina ettei voi muokata
    // if (this._allKirjauksetAndAccountsCanBeEdited.value) {
    //   return false
    // }
    // return kirjaus.lukittu || this._onkoAutomaattikirjaus(kirjaus)
  }

  private _onkoAutomaattikirjaus(kirjaus: Kirjaus): boolean {
    return kirjaus.t === KirjauksenTyyppi.AUTOMAATTIKIRJAUS_EI_MUOKATTAVISSA || kirjaus.t === KirjauksenTyyppi.AUTOMAATTIKIRJAUS_VAIN_PVM_MUOKATTAVISSA
  }

  private annaObservableNykyiseenVersioon(kirjauksenAvain: string): Observable<Kirjaus> {
    return this._asiakasService.nykyinenAsiakasAvainObservable.pipe(
      switchMap(asiakas => {
        if (asiakas) {
          const kirjausUri = this._kirjanpitoUriService.annaKirjauksenUri(asiakas.avain, kirjauksenAvain)
          return this._lemonatorFirebase.firestoreDoc<Kirjaus>(kirjausUri).listen()
        }
        return EMPTY
      }),
    )
  }

  private annaObservableSeuraavaanVersioon(naytettavaKirjaus: NaytettavaKirjaus): Observable<{ seuraava: Kirjaus; sitaSeuraava: Kirjaus; sitaSitaSeuraava: Kirjaus }> {
    return this._asiakasService.nykyinenAsiakasAvainObservable.pipe(
      switchMap(asiakas => {
        if (asiakas) {
          const uri = this._kirjanpitoUriService.annaKirjauksenHistoriaCollectionUri(asiakas.avain, naytettavaKirjaus.kirjaus.avain)
          console.log('Haetaan seuraava', uri)
          return this._lemonatorFirebase
            .firestoreCollection<Kirjaus>(uri)
            .where('kirjausTallennettu', '>', naytettavaKirjaus.nykyisenVersionTimestamp)
            .orderBy('kirjausTallennettu', 'asc')
            .limit(3)
            .listen()
            .pipe(
              map(kirjaukset => {
                if (kirjaukset.length === 3) {
                  // console.log('Löytyi 1: ', querySnapshot.docs[0].id)
                  // console.log('Löytyi 2: ', querySnapshot.docs[1].id)
                  // console.log('Löytyi 3: ', querySnapshot.docs[2].id)
                  return { seuraava: kirjaukset[0], sitaSeuraava: kirjaukset[1], sitaSitaSeuraava: kirjaukset[2] }
                } else if (kirjaukset.length === 2) {
                  // console.log('Löytyi 1: ', querySnapshot.docs[0].id)
                  // console.log('Löytyi 2: ', querySnapshot.docs[1].id)
                  return { seuraava: kirjaukset[0], sitaSeuraava: kirjaukset[1], sitaSitaSeuraava: null }
                } else if (kirjaukset.length === 1) {
                  // console.log('Löytyi 1: ', querySnapshot.docs[0].id)
                  return { seuraava: kirjaukset[0], sitaSeuraava: null, sitaSitaSeuraava: null }
                }
                // console.log('Ei löydy mitään')
                return { seuraava: null, sitaSeuraava: null, sitaSitaSeuraava: null }
              }),
            )
        }
        return observableOf<{ seuraava: Kirjaus; sitaSeuraava: Kirjaus; sitaSitaSeuraava: Kirjaus }>({ seuraava: null, sitaSeuraava: null, sitaSitaSeuraava: null })
      }),
    )
  }

  private async _annaKirjauksenEdellisetVersiot(naytettavaKirjaus: NaytettavaKirjaus): Promise<{ edellinen: Kirjaus; sitaEdellinen: Kirjaus }> {
    const asiakas = await firstValueFrom(this._asiakasService.nykyinenAsiakasAvainObservable)

    if (!asiakas) {
      return { edellinen: null, sitaEdellinen: null }
    }

    const uri = this._kirjanpitoUriService.annaKirjauksenHistoriaCollectionUri(asiakas.avain, naytettavaKirjaus.kirjaus.avain)
    // console.log('Haetaan edellinen', uri)
    return this._lemonatorFirebase
      .firestoreCollection<Kirjaus>(uri)
      .where('kirjausTallennettu', '<', naytettavaKirjaus.nykyisenVersionTimestamp)
      .orderBy('kirjausTallennettu', 'desc')
      .limit(2)
      .get()
      .then(kirjaukset => {
        if (kirjaukset.length === 2) {
          // console.log('Löytyi 1: ', querySnapshot.docs[0].id)
          // console.log('Löytyi 2: ', querySnapshot.docs[1].id)
          return { edellinen: kirjaukset[0], sitaEdellinen: kirjaukset[1] }
        } else if (kirjaukset.length === 1) {
          // console.log('Löytyi 1: ', querySnapshot.docs[0].id)
          return { edellinen: kirjaukset[0], sitaEdellinen: null }
        }
        // console.log('Ei löydy mitään')
        return { edellinen: null, sitaEdellinen: null }
      })
  }

  private preventEvent(event: Event) {
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
  }

  @HostListener('document:keydown.shift.enter', ['$event'])
  lisaaRiviValitunRivinJalkeen(event: Event) {
    if (this.handlingIflight) {
      return
    }

    this.handlingIflight = true

    // console.log('ENTER SHIFT')
    const element = event.target as HTMLElement
    const kirjausElement = this.etsiKirjausElement(element)
    const arvoavain = this.etsiArvoavain(element)
    // console.log(kirjausElement, arvoavain)
    if (kirjausElement && arvoavain) {
      const rivi = this._riviMap.get(arvoavain)
      const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)

      let index = naytettavaKirjaus.naytettavatKirjausrivit.indexOf(rivi)
      const seuraavaRiviOnAlv = naytettavaKirjaus.naytettavatKirjausrivit.length > index && this.onkoNaytettavariviAlvrivi(naytettavaKirjaus.naytettavatKirjausrivit[index + 1])
      const sitaSeuraavaRiviOnAlv = naytettavaKirjaus.naytettavatKirjausrivit.length > index + 1 && this.onkoNaytettavariviAlvrivi(naytettavaKirjaus.naytettavatKirjausrivit[index + 2])

      if (seuraavaRiviOnAlv) {
        index++
        if (sitaSeuraavaRiviOnAlv) {
          index++
        }
      }

      index++

      if (!this._riviVoidaanLisata(naytettavaKirjaus, rivi)) {
        return
      }

      const uusiArvoavain = this.addRowToCurrentKirjaus(element, index)

      this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)

      naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)
      this.preventEvent(event)

      setTimeout(() => {
        // console.log('div[data-arvoavain="' + uusiArvoavain + '"] .knc')
        const el = document.querySelector('div[data-arvoavain="' + uusiArvoavain + '"] .knc') as HTMLElement
        if (el) {
          el.focus()
        }
      }, 250)
    }

    this._closeTiliAuto()
    this._closeAlvAuto()
    this._closeKommenttiAuto()

    this.handlingIflight = false
  }

  private handlingIflight: boolean = false
  @HostListener('document:keydown.enter', ['$event'])
  @HostListener('document:keydown.tab', ['$event'])
  async siirraKohdistusSeuraavaan(event: Event) {
    if (
      // this._kommenttiAutocomplete.isOpen ||
      // this._tiliAutocomplete.isOpen ||
      this._alvAutocomplete.isOpen ||
      this.handlingIflight
    ) {
      return
    }

    this.handlingIflight = true

    // console.log('ENTER')
    const element = event.target as HTMLElement
    const isTab = (event as KeyboardEvent).key === 'Tab'
    if (element.classList.contains('kni')) {
      this.preventEvent(event)

      const arvoavain = this.etsiArvoavain(element)
      const rivi = this._riviMap.get(arvoavain)

      const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
      const riviElement = this.etsiRiviElement(element)
      // If is empty AND on last row, then delete the last line and move to next kirjaus!
      if (
        (!riviElement.nextElementSibling || !this.getNextFocusableElementFromThisKirjaus(riviElement.nextElementSibling.firstElementChild as HTMLElement, isTab)) &&
        // , naytettavaKirjaus.kirjaus.rivit.length > 1 ? naytettavaKirjaus.kirjaus.rivit[naytettavaKirjaus.kirjaus.rivit.length - 2] : null
        this.onkoRiviTyhja(naytettavaKirjaus.kirjaus.rivit[naytettavaKirjaus.kirjaus.rivit.length - 1])
      ) {
        const validointiOk = this.poistaViimeinenRiviJosTyhjaJaValidointiOnOk(naytettavaKirjaus)
        if (!validointiOk) {
          this.handlingIflight = false
          return
        }
        this._tallennaKirjaus(naytettavaKirjaus)
        const kirjausElement = this.etsiKirjausElement(element)
        const nextKirjaus = this.etsiSeuraavaKirjaus(kirjausElement)
        if (nextKirjaus) {
          await this._aktivoiKirjausJaKohdistaFokusViimeiseenTiliboksiin(nextKirjaus, true)
        } else if (this.paginator && this.paginator.hasNextPage()) {
          this.valittuSivuSubject.value.sivu++
          this.valittuSivuSubject.value.aktivoiEnsimmainen = true
          this.valittuSivuSubject.next(this.valittuSivuSubject.value)
        } else {
          const lisaaKirjausNappi = this.etsiLisaaNappi(kirjausElement)
          if (lisaaKirjausNappi) {
            lisaaKirjausNappi.focus()
          } else {
            console.log('TODO: THIS WAS LAST KIRJAUS, MOVE FOCUS TO NEXT BUTTON!')
          }
        }
      } else {
        // Validoi tili
        rivi.tilivirhe = !rivi.kirjausrivi.t
        if (rivi.tilivirhe) {
          element.classList.add('v')
          this.handlingIflight = false
          return
        }

        // console.log('Haetaan elementillä ', element)
        const el = this.etsiYksiEnnenRiviElementtia(element)
        const nextFocusableElementInThisKirjaus = this.getNextFocusableElementFromThisKirjaus(el.nextElementSibling as HTMLElement, isTab)
        // console.log('Löytyi ', nextFocusableElementInThisKirjaus)
        if (nextFocusableElementInThisKirjaus) {
          nextFocusableElementInThisKirjaus.focus()
        }
      }

      this.handlingIflight = false
    } else if (element.classList.contains('kai')) {
      this.preventEvent(event)
      const arvoavain = this.etsiArvoavain(element)
      const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
      const rivi = this._riviMap.get(arvoavain)
      rivi.alvvirhe = !rivi.kirjausrivi.a
      if (rivi.alvvirhe) {
        element.classList.add('v')
        this.handlingIflight = false
        return
      }
      const el = this.etsiYksiEnnenRiviElementtia(element)
      const nexFocusableElementInThisKirjaus = this.getNextFocusableElementFromThisKirjaus(el.nextElementSibling as HTMLElement, isTab)
      if (nexFocusableElementInThisKirjaus) {
        nexFocusableElementInThisKirjaus.focus()
        this.handlingIflight = false
      } else if (this._riviVoidaanLisata(naytettavaKirjaus, rivi)) {
        this.addRowToCurrentKirjaus(element)
        setTimeout(() => {
          const normalized = this.etsiYksiEnnenRiviElementtia(element)
          const el2 = this.getNextFocusableElementFromThisKirjaus(normalized.parentElement.nextElementSibling.firstElementChild as HTMLElement, isTab)
          if (el2) {
            el2.focus()
          }
          this.handlingIflight = false
        }, 0)
      }
    } else if (element.classList.contains('kkoi')) {
      this.preventEvent(event)
      const arvoavain = this.etsiArvoavain(element)
      const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
      const rivi = this._riviMap.get(arvoavain)
      const thisRow = this.etsiRiviElement(element)
      const nextRow = thisRow.nextElementSibling
      const nexFocusableElementInThisKirjaus = this.getNextFocusableElementFromThisKirjaus(nextRow.firstElementChild as HTMLElement, isTab)
      if (nexFocusableElementInThisKirjaus) {
        nexFocusableElementInThisKirjaus.focus()
        this.handlingIflight = false
      } else if (this._riviVoidaanLisata(naytettavaKirjaus, rivi)) {
        this.addRowToCurrentKirjaus(element)
        setTimeout(() => {
          const el = this.getNextFocusableElementFromThisKirjaus(element.parentElement.nextElementSibling.firstElementChild as HTMLElement, isTab)
          if (el) {
            el.focus()
          }
          this.handlingIflight = false
        }, 0)
      }
    } else if (element.classList.contains('kki')) {
      this.preventEvent(event)
      const arvoavain = this.etsiArvoavain(element)
      const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
      const naytettavaRivi = this._riviMap.get(arvoavain)
      naytettavaRivi.kreditvirhe = naytettavaRivi.kirjausrivi.k === undefined || naytettavaRivi.kirjausrivi.k === null || naytettavaRivi.kirjausrivi.k === 0
      if (naytettavaRivi.kreditvirhe) {
        element.classList.add('v')
        this.handlingIflight = false
        return
      }
      if (naytettavaRivi.kirjausrivi.k && naytettavaRivi.kirjausrivi.k < 0.0) {
        naytettavaRivi.kirjausrivi.d = this._currencyService.roundHalfUp(Math.abs(naytettavaRivi.kirjausrivi.k), 2)
        naytettavaRivi.kirjausrivi.k = null
        naytettavaRivi.debet = this._currencyService.formatoiDesimaaliSailytaNollat(naytettavaRivi.kirjausrivi.d, 2, 'fi')
        naytettavaRivi.kredit = ''
        this.paivitaNaytettavanRivinLukitustiedot(naytettavaKirjaus.kirjaus, naytettavaRivi)

        this.paivitaKirjausrivinAlvRiviSiirraNegatiiviset(naytettavaRivi, naytettavaKirjaus, true, arvoavain)
        this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)
      }
      const nexFocusableElementInThisKirjaus = this.getNextFocusableElementFromThisKirjaus(element, isTab)
      if (nexFocusableElementInThisKirjaus) {
        nexFocusableElementInThisKirjaus.focus()
        this.handlingIflight = false
      } else if (this._riviVoidaanLisata(naytettavaKirjaus, naytettavaRivi)) {
        this.addRowToCurrentKirjaus(element)
        setTimeout(() => {
          const el = this.getNextFocusableElementFromThisKirjaus(element.parentElement.nextElementSibling.firstElementChild as HTMLElement, isTab)
          if (el) {
            el.focus()
          }
          this.handlingIflight = false
        }, 0)
      }
    } else if (element.classList.contains('kdi')) {
      this.preventEvent(event)
      const arvoavain = this.etsiArvoavain(element)
      const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
      const naytettavaRivi = this._riviMap.get(arvoavain)
      if (naytettavaRivi.kirjausrivi.d && naytettavaRivi.kirjausrivi.d < 0.0) {
        naytettavaRivi.kirjausrivi.k = this._currencyService.roundHalfUp(Math.abs(naytettavaRivi.kirjausrivi.d), 2)
        naytettavaRivi.kirjausrivi.d = null
        naytettavaRivi.debet = ''
        naytettavaRivi.kredit = this._currencyService.formatoiDesimaaliSailytaNollat(naytettavaRivi.kirjausrivi.k, 2, 'fi')
        this.paivitaNaytettavanRivinLukitustiedot(naytettavaKirjaus.kirjaus, naytettavaRivi)
        this.paivitaKirjausrivinAlvRiviSiirraNegatiiviset(naytettavaRivi, naytettavaKirjaus, true, arvoavain)
        this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)
      }
      const nexFocusableElementInThisKirjaus = this.getNextFocusableElementFromThisKirjaus(element, isTab)
      if (nexFocusableElementInThisKirjaus) {
        nexFocusableElementInThisKirjaus.focus()
        this.handlingIflight = false
      } else if (this._riviVoidaanLisata(naytettavaKirjaus, naytettavaRivi)) {
        this.addRowToCurrentKirjaus(element)
        setTimeout(() => {
          const el = this.getNextFocusableElementFromThisKirjaus(element.parentElement.nextElementSibling.firstElementChild as HTMLElement, isTab)
          if (el) {
            el.focus()
          }
          this.handlingIflight = false
        }, 10)
      }
    } else {
      this.handlingIflight = false
    }

    this._closeTiliAuto()
    this._closeAlvAuto()
    this._closeKommenttiAuto()
  }

  private _riviVoidaanLisata(kirjaus: NaytettavaKirjaus, rivi: NaytettavaKirjausrivi): boolean {
    return !this._tilikausiLukossa && !kirjaus.lukittu
  }

  private addRowToCurrentKirjaus(element: HTMLElement, index?: number): string {
    let arvoavain = this.etsiArvoavain(element)
    if (!element && this._valittuMaksutapaSubject.value && this._valittuNaytettavaKirjausSubject.value) {
      arvoavain = this._valittuMaksutapaSubject.value.tunniste + '_' + this._valittuNaytettavaKirjausSubject.value.kirjaus.avain + '_0'
    }
    const naytettavaKirjaus = this.annaNaytettavaKirjaus(arvoavain)
    if (!naytettavaKirjaus) {
      return null
    }
    const summat = this._kirjanpitoJaettuService.annaKirjauksenSummat(naytettavaKirjaus.kirjaus)

    let edellisenKommentti = ''
    if (naytettavaKirjaus.naytettavatKirjausrivit.length > 0) {
      if (index > 0) {
        edellisenKommentti = naytettavaKirjaus.naytettavatKirjausrivit[index - 1].kommentti
      } else if (index === undefined || index === null) {
        edellisenKommentti = naytettavaKirjaus.naytettavatKirjausrivit[naytettavaKirjaus.naytettavatKirjausrivit.length - 1].kommentti
      }
    }
    edellisenKommentti = edellisenKommentti ? edellisenKommentti.trim() : ''

    const uusiKirjausrivi: Kirjausrivi = {
      av: this._lemonatorFirebase.firestoreCreateId(),
      a: null,
      d: null,
      k: null,
      t: null,
    }

    this.asetaKirjausrivinKommentti(uusiKirjausrivi, edellisenKommentti)

    const uusiNaytettavaKirjausrivi: NaytettavaKirjausrivi = {
      alv: '',
      alvlukittu: this._asiakkaanAlvtLukossa,
      debet: uusiKirjausrivi.d ? this._currencyService.formatoiRahaIlmanValuuttaSymbolia(uusiKirjausrivi.d, 'fi') : '',
      debetlukittu: false,
      kirjausrivi: uusiKirjausrivi,
      kommentti: edellisenKommentti,
      kredit: uusiKirjausrivi.k ? this._currencyService.formatoiRahaIlmanValuuttaSymbolia(uusiKirjausrivi.k, 'fi') : '',
      kreditlukittu: false,
      lukittu: false,
      tilinimi: '',
      tilinumero: '',
      alvvirhe: false,
      debetvirhe: false,
      kreditvirhe: false,
      tilivirhe: false,
      knTabIndexPoistettu: false,
      tunniste: null,
    }

    this.asetaErotusNaytettavaanRiviin(naytettavaKirjaus.kirjaus, uusiNaytettavaKirjausrivi, summat)
    this.asetaProjektiNaytettavaanRiviin(uusiKirjausrivi, uusiNaytettavaKirjausrivi)

    if (index > -1) {
      naytettavaKirjaus.kirjaus.rivit.splice(index, 0, uusiKirjausrivi)
      naytettavaKirjaus.naytettavatKirjausrivit.splice(index, 0, uusiNaytettavaKirjausrivi)
    } else {
      naytettavaKirjaus.kirjaus.rivit.push(uusiKirjausrivi)
      naytettavaKirjaus.naytettavatKirjausrivit.push(uusiNaytettavaKirjausrivi)
    }

    // Update the lookup map
    this.paivitaRivienLookupMapAvaimet(arvoavain, naytettavaKirjaus)

    this.paivitaNaytettavanKirjauksenSummat(naytettavaKirjaus)
    this.paivitaKirjauksessaYhteisomyyntiVatKentta(naytettavaKirjaus)
    naytettavaKirjaus.tallentamattomiaMuutoksia = this.onkoNaytettavaKirjausMuuttunut(naytettavaKirjaus)

    const alku = this.annaArvoavainIlmanIndeksia(arvoavain)
    return alku + (index === 0 || index > 0 ? index : naytettavaKirjaus.naytettavatKirjausrivit.length - 1)
  }

  /**
   * Jos '2_adfs_3', palauttaa '2_adfs_'
   * @param arvoavain
   */
  private annaArvoavainIlmanIndeksia(arvoavain: string): string {
    return arvoavain.substring(0, arvoavain.lastIndexOf('_') + 1)
  }

  /**
   * Jos '2_adfs_3', palauttaa 'adfs'
   * @param arvoavain
   */
  private annaKirjausAvainArvoavaimella(arvoavain: string): string {
    return arvoavain.substring(arvoavain.indexOf('_') + 1, arvoavain.lastIndexOf('_'))
  }

  private paivitaRivienLookupMapAvaimet(arvoavain: string, naytettavaKirjaus: NaytettavaKirjaus) {
    // Update the lookup map
    let i = 0
    const alku = this.annaArvoavainIlmanIndeksia(arvoavain)
    for (const r of naytettavaKirjaus.naytettavatKirjausrivit) {
      r.tunniste = alku + i
      this._riviMap.set(r.tunniste, r)
      i++
    }
  }

  private getNextFocusableElementFromThisKirjaus(el: HTMLElement, isTab: boolean): HTMLElement | null {
    // console.log('getNextFocusableElementFromThisKirjaus', el)
    const element = this.etsiYksiEnnenRiviElementtia(el)
    if (!element) {
      return null
    }
    // console.log('getNextFocusableElementFromThisKirjaus', element)
    if (
      element.style.display !== 'none' &&
      element.hasAttribute('tabindex') &&
      !element.classList.contains('kai') &&
      !element.classList.contains('kkoi') &&
      !element.classList.contains('kr-projekti-dot') &&
      (!element.classList.contains('kko') || isTab)
    ) {
      // Focusable element
      return element
    } else if (element.nextElementSibling) {
      // Has next sibbling, let's try that
      return this.getNextFocusableElementFromThisKirjaus(element.nextElementSibling as HTMLElement, isTab)
    } else {
      // let's try next row
      const nextRow = element.parentElement.nextElementSibling
      if (nextRow && nextRow.classList.contains('kr') && nextRow.firstElementChild) {
        return this.getNextFocusableElementFromThisKirjaus(nextRow.firstElementChild as HTMLElement, isTab)
      }
    }
    return null
  }

  // tiputettu(event: CdkDragDrop<NaytettavaKirjaus, NaytettavaKuitti>) {
  //   const naytettavaKuitti: NaytettavaKuitti = event.item.data
  //   const kirjaus = event.container.data

  //   if (!kirjaus.naytettavatLiitetytKuitit) {
  //     kirjaus.naytettavatLiitetytKuitit = []
  //   }

  //   kirjaus.naytettavatLiitetytKuitit.push(naytettavaKuitti)
  // }

  // /** HUOM!! TÄTÄ KUTSUTAAN IHAN SAATANASTI! */
  // voikoTiputtaa: (drag: CdkDrag, drop: CdkDropList) => boolean = (drag: CdkDrag, drop: CdkDropList<Kirjaus>): boolean => {
  //   // console.log(drag.data)
  //   if (drop.data.) {

  //   }
  //   return true
  // }

  // private etsiArvoavainLapsista(element: HTMLElement): string | null {
  //   if (element.dataset.arvoavain) {
  //     return element.dataset.arvoavain
  //   }
  //   const firstRow = element.querySelector('.kr') as HTMLElement
  //   if (firstRow && firstRow.dataset.arvoavain) {
  //     return firstRow.dataset.arvoavain
  //   }
  //   return null
  // }

  private etsiArvoavain(element: HTMLElement): string | null {
    if (!element) {
      return null
    }
    if (element.dataset.arvoavain) {
      return element.dataset.arvoavain
    }
    if (element.parentElement && element.parentElement.dataset.arvoavain) {
      return element.parentElement.dataset.arvoavain
    }
    if (element.parentElement && element.parentElement.parentElement && element.parentElement.parentElement.dataset.arvoavain) {
      return element.parentElement.parentElement.dataset.arvoavain
    }
    if (element.parentElement && element.parentElement.parentElement && element.parentElement.parentElement.parentElement && element.parentElement.parentElement.parentElement.dataset.arvoavain) {
      return element.parentElement.parentElement.parentElement.dataset.arvoavain
    }
    return null
  }

  private etsiYksiEnnenRiviElementtia(element: HTMLElement): HTMLElement | null {
    if (!element) {
      return null
    }
    if (element.parentElement && element.parentElement.classList.contains('kr')) {
      return element
    }
    if (element.parentElement && element.parentElement.parentElement && element.parentElement.parentElement.classList.contains('kr')) {
      return element.parentElement
    }
    if (
      element.parentElement &&
      element.parentElement.parentElement &&
      element.parentElement.parentElement.parentElement &&
      element.parentElement.parentElement.parentElement.classList.contains('kr')
    ) {
      return element.parentElement.parentElement
    }
    return null
  }

  private etsiRiviElement(element: HTMLElement): HTMLElement | null {
    if (!element) {
      return null
    }
    if (element.classList.contains('kr')) {
      return element
    }
    if (element.parentElement && element.parentElement.classList.contains('kr')) {
      return element.parentElement
    }
    if (element.parentElement && element.parentElement.parentElement && element.parentElement.parentElement.classList.contains('kr')) {
      return element.parentElement.parentElement
    }
    if (
      element.parentElement &&
      element.parentElement.parentElement &&
      element.parentElement.parentElement.parentElement &&
      element.parentElement.parentElement.parentElement.classList.contains('kr')
    ) {
      return element.parentElement.parentElement.parentElement
    }
    return null
  }

  private etsiEdellinenKirjaus(element: HTMLElement): HTMLElement | null {
    let suspect = element.previousElementSibling
    while (suspect) {
      if (suspect.classList.contains('kl')) {
        return suspect as HTMLElement
      }
      suspect = suspect.previousElementSibling
    }
    return null
  }

  private etsiSeuraavaKirjaus(element: HTMLElement): HTMLElement | null {
    let suspect = element.nextElementSibling
    while (suspect) {
      if (suspect.classList.contains('kl')) {
        return suspect as HTMLElement
      }
      suspect = suspect.nextElementSibling
    }
    return null
  }

  private etsiLisaaNappi(element: HTMLElement): HTMLElement | null {
    let suspect = element.nextElementSibling
    while (suspect) {
      if (suspect.classList.contains('lisaa-kirjaus-button')) {
        const inner = suspect.querySelector('button')
        return inner ? (inner as HTMLElement) : (suspect as HTMLElement)
      }
      const button = suspect.querySelector('button.lisaa-kirjaus-button')
      if (button) {
        return button as HTMLElement
      }
      suspect = suspect.nextElementSibling
    }
    return null
  }

  private etsiKirjausElement(element: HTMLElement): HTMLElement | null {
    if (!element) {
      return null
    }
    if (element.classList.contains('kl')) {
      return element
    }
    if (element.parentElement && element.parentElement.classList.contains('kl')) {
      return element.parentElement
    }
    if (element.parentElement && element.parentElement.parentElement && element.parentElement.parentElement.classList.contains('kl')) {
      return element.parentElement.parentElement
    }
    if (
      element.parentElement &&
      element.parentElement.parentElement &&
      element.parentElement.parentElement.parentElement &&
      element.parentElement.parentElement.parentElement.classList.contains('kl')
    ) {
      return element.parentElement.parentElement.parentElement
    }
    if (
      element.parentElement &&
      element.parentElement.parentElement &&
      element.parentElement.parentElement.parentElement &&
      element.parentElement.parentElement.parentElement.parentElement &&
      element.parentElement.parentElement.parentElement.parentElement.classList.contains('kl')
    ) {
      return element.parentElement.parentElement.parentElement.parentElement
    }
    return null
  }

  private annaNaytettavaKirjaus(arvoavain: string): NaytettavaKirjaus {
    const kirjausavain = this.annaKirjausAvainArvoavaimella(arvoavain)
    // console.log('ETSI AVAIMELLA', kirjausavain)
    return this._kirjausMap.get(kirjausavain)
  }

  poistaViimeinenRiviJosTyhjaJaValidointiOnOk(naytettavaKirjaus: NaytettavaKirjaus): boolean {
    const poistetut = this.poistaViimeinenRiviJosTyhja(naytettavaKirjaus)
    if (!this._useValidationBeforeSaveSubject.value) {
      return true
    }
    const ok = this.paivitaNaytettavanKirjauksenValidointi(naytettavaKirjaus)
    if (!ok && poistetut) {
      naytettavaKirjaus.naytettavatKirjausrivit.push(poistetut.poistettuNaytettava)
      naytettavaKirjaus.kirjaus.rivit.push(poistetut.poistettuRivi)
      this.paivitaKirjauksessaYhteisomyyntiVatKentta(naytettavaKirjaus)
    }
    return ok
  }

  private poistaViimeinenRiviJosTyhja(naytettavaKirjaus: NaytettavaKirjaus): { poistettuNaytettava: NaytettavaKirjausrivi; poistettuRivi: Kirjausrivi } | null {
    if (naytettavaKirjaus?.kirjaus?.rivit?.length > 0) {
      const viimeinen = naytettavaKirjaus.kirjaus.rivit[naytettavaKirjaus.kirjaus.rivit.length - 1]
      // const edellinen = naytettavaKirjaus.kirjaus.rivit.length > 1 ? naytettavaKirjaus.kirjaus.rivit[naytettavaKirjaus.kirjaus.rivit.length - 2] : null
      if (this.onkoRiviTyhja(viimeinen)) {
        return { poistettuNaytettava: naytettavaKirjaus.naytettavatKirjausrivit.pop(), poistettuRivi: naytettavaKirjaus.kirjaus.rivit.pop() }
      }
    }
    return null
  }

  // private onkoNaytettavaRiviTyhja(rivi: NaytettavaKirjausrivi): boolean {
  //   return !(rivi.alv || rivi.debet || rivi.kommentti || rivi.kredit || rivi.tilinimi || rivi.tilinumero)
  // }

  // , edellinen: Kirjausrivi
  private onkoRiviTyhja(rivi: Kirjausrivi): boolean {
    // const kommenttiOnAsetettu = rivi.kommentti && (!edellinen || edellinen.kommentti !== rivi.kommentti)
    // console.log('ONKO KOMMENTTI ASETETTU?', kommenttiOnAsetettu)
    const riviOnTyhja = !(rivi.t || rivi.a || rivi.d || rivi.k) // || kommenttiOnAsetettu
    // console.log('RIVI ON TYHJÄ?', riviOnTyhja)
    return riviOnTyhja
  }

  private vaihdaViimeinenKirjausValituksi(kohdista: 'debet' | 'kredit' | 'tili') {
    const allElements = document.querySelectorAll('.kl')
    // console.log(allElements)
    const lastElement = allElements && allElements.length > 0 ? allElements[allElements.length - 1] : null
    // console.log(lastElement)
    const knElement = lastElement ? (lastElement.querySelector('.kn') as HTMLElement) : null
    // console.log(knElement)
    const arvoavain = knElement ? this.etsiArvoavain(knElement) : null
    // console.log(arvoavain)
    if (arvoavain) {
      this.vaihdaValittuKirjausArvoavaimella(arvoavain, true)
      if (kohdista === 'kredit') {
        const kk = document.querySelector('div.kr[data-arvoavain="' + arvoavain + '"] .kk') as HTMLElement
        if (kk) {
          setTimeout(() => {
            // console.log('click', kd)
            const rivi = this._riviMap.get(arvoavain)
            if (!rivi.lukittu && !rivi.kreditlukittu) {
              const value = this._currencyService.formatoiDesimaaliSailytaNollat(rivi.kirjausrivi.k, 2, 'fi')
              this.focusInput(this._kreditInput.nativeElement, kk, value, arvoavain)
            }
          }, 250)
        }
      } else if (kohdista === 'tili') {
        const kk = document.querySelector('div.kr[data-arvoavain="' + arvoavain + '"] .kn') as HTMLElement
        if (kk) {
          setTimeout(() => {
            // console.log('click', kd)
            const rivi = this._riviMap.get(arvoavain)
            if (!rivi.lukittu && !rivi.kreditlukittu) {
              const value = rivi.kirjausrivi.t ? rivi.kirjausrivi.t : ''
              this.focusInput(this._tnroInput.nativeElement, kk, value, arvoavain)
            }
          }, 250)
        }
      } else if (kohdista === 'debet') {
        const kd = document.querySelector('div.kr[data-arvoavain="' + arvoavain + '"] .kd') as HTMLElement
        if (kd) {
          setTimeout(() => {
            // console.log('click', kd)
            const rivi = this._riviMap.get(arvoavain)
            if (!rivi.lukittu && !rivi.debetlukittu) {
              const value = this._currencyService.formatoiDesimaaliSailytaNollat(rivi.kirjausrivi.d, 2, 'fi')
              this.focusInput(this._debetInput.nativeElement, kd, value, arvoavain)
            }
          }, 250)
        }
      }
    }
  }

  private _searchMap(kirjausMap: Map<string, NaytettavaKirjaus>, kirjausnumero: string): NaytettavaKirjaus | null {
    for (const value of kirjausMap.values()) {
      if (value.kirjaus.kirjausnumero === kirjausnumero) {
        return value
      }
    }
    return null
  }

  async vaihdaValittuKirjaus(kirjaus: NaytettavaKirjaus, scrollaa: boolean): Promise<NaytettavaKirjaus> {
    console.error('vaihdaValittuKirjaus', kirjaus.kirjaus.avain, scrollaa)
    await this._vaihdaKirjauksenSivuTarvittaessa(kirjaus.kirjaus.kirjausnumero, kirjaus.kirjaus.maksutavanTunniste)
    return this.vaihdaValittuKirjausKirjausavaimella(kirjaus.kirjaus.avain, scrollaa)
  }

  private vaihdaValittuKirjausKirjausnumerolla(kirjausnumero: string, scrollaa: boolean): Promise<NaytettavaKirjaus> {
    console.log('vaihdaValittuKirjausKirjausnumerolla', kirjausnumero, scrollaa)

    const valittuKirjaus = this._searchMap(this._kirjausMap, kirjausnumero)
    if (valittuKirjaus === this._valittuNaytettavaKirjausSubject.value) {
      console.log('On jo valittu numerolla')
      return Promise.resolve(valittuKirjaus)
    }

    const vaihdettiinElementtiin = this.vaihdaValitunKirjauksenCssLuokatKirjausavaimella(valittuKirjaus?.kirjaus.avain)
    const valittuNaytettavaKirjaus: NaytettavaKirjaus = vaihdettiinElementtiin ? valittuKirjaus : null
    // if (valittuNaytettavaKirjaus) {
    // console.log('Valittiin kirjaus', valittuNaytettavaKirjaus.kirjaus.avain, valittuNaytettavaKirjaus.kirjaus)
    // console.log('Valittiin näytettävä kirjaus', valittuNaytettavaKirjaus.kirjaus.avain, valittuNaytettavaKirjaus)
    // }
    this._valittuNaytettavaKirjausSubject.next(valittuNaytettavaKirjaus)
    if (scrollaa && vaihdettiinElementtiin) {
      console.log('Scrollataan!')
      return this.scrollaaKirjausNakyviin(vaihdettiinElementtiin).then(async () => {
        console.log('Valmis')
        await this.tarkistaOnkoValittuKirjausNakyvissa()
        return valittuKirjaus
      })
    }
    return Promise.resolve(valittuKirjaus)
  }

  private vaihdaValittuKirjausKirjausavaimella(kirjausavain: string, scrollaa: boolean): Promise<NaytettavaKirjaus> {
    const valittuKirjaus = this._kirjausMap.get(kirjausavain)
    if (valittuKirjaus === this._valittuNaytettavaKirjausSubject.value) {
      console.log('On jo valittu avaimella')
      return Promise.resolve(valittuKirjaus)
    }

    const vaihdettiinElementtiin = this.vaihdaValitunKirjauksenCssLuokatKirjausavaimella(kirjausavain)
    const valittuNaytettavaKirjaus: NaytettavaKirjaus = vaihdettiinElementtiin ? valittuKirjaus : null
    // if (valittuNaytettavaKirjaus) {
    //   console.log('Valittiin kirjaus', valittuNaytettavaKirjaus.kirjaus.avain, valittuNaytettavaKirjaus.kirjaus)
    // console.log('Valittiin näytettävä kirjaus', valittuNaytettavaKirjaus.kirjaus.avain, valittuNaytettavaKirjaus)
    // }
    this._valittuNaytettavaKirjausSubject.next(valittuNaytettavaKirjaus)
    if (scrollaa && vaihdettiinElementtiin) {
      console.log('Scrollataan!')
      return this.scrollaaKirjausNakyviin(vaihdettiinElementtiin).then(async () => {
        console.log('Valmis')
        await this.tarkistaOnkoValittuKirjausNakyvissa()
        return valittuKirjaus
      })
    }
    return Promise.resolve(valittuKirjaus)
  }

  private vaihdaValittuKirjausArvoavaimella(arvoavain: string, scrollaa: boolean): Promise<NaytettavaKirjaus> {
    // return this._ngZone.runOutsideAngular<Promise<NaytettavaKirjaus>>(() => {
    // console.log('AVAIN', arvoavain)

    const valittuKirjaus = this.annaNaytettavaKirjaus(arvoavain)
    if (valittuKirjaus === this._valittuNaytettavaKirjausSubject.value) {
      // console.log('On jo valittu')
      return Promise.resolve(valittuKirjaus)
    }

    const uusiElementti = this.vaihdaValitunKirjauksenCssLuokat(arvoavain)
    const valittuNaytettavaKirjaus: NaytettavaKirjaus = uusiElementti ? valittuKirjaus : null
    // if (valittuNaytettavaKirjaus) {
    // console.log('Valittiin kirjaus', valittuNaytettavaKirjaus.kirjaus.avain, valittuNaytettavaKirjaus.kirjaus)
    // console.log('Valittiin näytettävä kirjaus', valittuNaytettavaKirjaus.kirjaus.avain, valittuNaytettavaKirjaus)
    // }
    this._valittuNaytettavaKirjausSubject.next(valittuNaytettavaKirjaus)
    if (scrollaa && uusiElementti) {
      console.log('Scrollataan!')
      return this.scrollaaKirjausNakyviin(uusiElementti.parentElement.parentElement).then(async () => {
        console.log('Valmis')
        await this.tarkistaOnkoValittuKirjausNakyvissa()
        return valittuKirjaus
      })
    }
    return Promise.resolve(valittuKirjaus)
    // })
  }

  private scrollaaKirjausNakyviin(kirjausElementti: HTMLElement): Promise<void> {
    return this.sleep(100)
      .then(() => {
        return this.sleepRequestAnimationFrame()
      })
      .then(() => {
        const boundRect = kirjausElementti.getBoundingClientRect()
        const scrollaaAlas = boundRect.top > window.innerHeight / 2
        if (scrollaaAlas) {
          // console.log('Scrollaa alas')
          const move = boundRect.top - window.innerHeight / 2

          // SCROLLAA VAIN NÄKYVIIN
          const yCoordinate = Math.max(window.pageYOffset + move, 0)
          const xCoordinate = window.pageXOffset
          // const header = document.querySelector('.k-sticky-header')
          // const yOffset = header ? (0 - (header.getBoundingClientRect().height + 10)) : -200
          if (yCoordinate !== window.pageYOffset) {
            console.log('SCROLL ALAS', yCoordinate, window.pageYOffset)
            window.scrollTo({
              behavior: 'auto',
              left: xCoordinate,
              top: yCoordinate,
            })
            return this.scrollingHasStopped()
          }
        } else {
          // const header = document.querySelector('.k-sticky-header')
          // const bottomOfHeaders = header ? header.getBoundingClientRect().bottom : 200
          const scrollaa = boundRect.top < window.innerHeight / 2
          if (scrollaa) {
            // console.log('Scrollaa ylös', boundRect.top, bottomOfHeaders)
            const move = window.innerHeight / 2 - boundRect.top
            // SCROLLAA VAIN NÄKYVIIN
            const yCoordinate = Math.max(window.pageYOffset - move, 0)
            const xCoordinate = window.pageXOffset
            if (yCoordinate !== window.pageYOffset) {
              // console.log('SCROLL YLÖS', yCoordinate, window.pageYOffset)
              window.scrollTo({
                behavior: 'auto',
                left: xCoordinate,
                top: yCoordinate,
              })
              // console.log('Aloitetaan Scrollaaminen')
              return this.scrollingHasStopped()
            }
          }
        }

        // else if (suunta === 'ylos') {
        //   const header = document.querySelector('.k-sticky-header')
        //   const bottomOfHeaders = header ? header.getBoundingClientRect().bottom : 200
        //   const scrollaa = boundRect.top > bottomOfHeaders
        //   if (scrollaa) {
        //     const move = boundRect.top - bottomOfHeaders

        //     // SCROLLAA VAIN NÄKYVIIN
        //     const yCoordinate = window.pageYOffset + move + 20
        //     const xCoordinate = window.pageXOffset
        //     // const header = document.querySelector('.k-sticky-header')
        //     // const yOffset = header ? (0 - (header.getBoundingClientRect().height + 10)) : -200
        //     window.scrollTo({
        //       behavior: 'auto',
        //       left: xCoordinate,
        //       top: yCoordinate
        //     })
        //     // console.log('Aloitetaan Scrollaaminen')
        //     return this.scrollingHasStopped()
        //   }
        // }

        return Promise.resolve()
      })
  }

  /**
   * Run a callback function after scrolling has stopped
   * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Function} callback The function to run after scrolling
   */
  private scrollingHasStopped(): Promise<void> {
    return new Promise((resolve, reject) => {
      // Setup variable for timeout identifier. Needed to cancel the timeout.
      let isScrolling

      const scrollEventListenerFunction: EventListenerOrEventListenerObject = event => {
        // Clear our timeout throughout the scroll
        window.clearTimeout(isScrolling)
        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(() => {
          window.removeEventListener('scroll', scrollEventListenerFunction) // Detach event listener
          // console.log('Scrolling stopped.')
          resolve() // Run the callback
        }, 66)
      }

      // Set the initial function. This is called if the function is called while no scrolling occurs
      isScrolling = setTimeout(() => {
        window.removeEventListener('scroll', scrollEventListenerFunction) // Detach event listener
        // console.log('Scrolling stopped.')
        resolve() // Run the callback
      }, 66)

      // Listen for scroll events
      window.addEventListener('scroll', scrollEventListenerFunction, false)
    })
  }

  private sleep(millis: number): Promise<void> {
    return new Promise<void>(resolve => {
      setTimeout(resolve, millis)
    })
  }

  private sleepRequestAnimationFrame(): Promise<void> {
    return new Promise<void>(resolve => {
      window.requestAnimationFrame(() => {
        resolve()
      })
    })
  }

  private poistaNykyisenValitunKirjauksenCssLuokat() {
    if (this._valittuNaytettavaKirjausSubject.value) {
      const oldElement = document.querySelector('div.kl[data-kirjausavain="' + this._valittuNaytettavaKirjausSubject.value.kirjaus.avain + '"]')
      if (oldElement) {
        oldElement.classList.remove('valittu')
      }
    }
  }

  private vaihdaValitunKirjauksenCssLuokatKirjausavaimella(kirjausavain: string): HTMLElement | null {
    this.poistaNykyisenValitunKirjauksenCssLuokat()
    const newElement = document.querySelector('div.kl[data-kirjausavain="' + kirjausavain + '"]')
    if (newElement) {
      newElement.classList.add('valittu')
      return newElement as HTMLElement
    }
    return null
  }

  private vaihdaValitunKirjauksenCssLuokat(uusiArvoavain: string): HTMLElement | null {
    this.poistaNykyisenValitunKirjauksenCssLuokat()
    const newElement = document.querySelector('div.kr[data-arvoavain="' + uusiArvoavain + '"]')
    if (newElement) {
      newElement.parentElement.parentElement.classList.add('valittu')
      return newElement as HTMLElement
    }
    return null
  }

  async kuukausiruutuValittiin(ruutu: KuukausiruudunTiedot) {
    // console.log('RUUTU', ruutu)
    if (ruutu?.k && this._valittuKuukausiruutuSubject.value?.k !== ruutu.k) {
      const localPvm = this._dateService.numberToLocalMonth(ruutu.k)
      // console.log('RUUTU 2', localPvm)
      const nytValittuKuukausi = await firstValueFrom(this._valittuKuukausiSubject)
      await this._vaihdaKuukausiJosTarvitsee(localPvm.year, localPvm.month, null, null, null, nytValittuKuukausi)
      // console.log('RUUTU 3')
      // NOTE! THE ORDER MUST BE THIS: FIRST CHANGE THE MONTH, THEN RUUTU!
      this._valittuKuukausiruutuSubject.next(ruutu)
    }
  }

  ngOnInit() {
    this._kirjanpitoNavigationService.resetNavigation()
    this._kirjanpitoNavigationService.currentMainTabObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(val => {
      if (val) {
        this._selectTabInternal(val)
      }
    })

    // Set up values loaded before this view loads
    const values = this._route.snapshot.data as { data: KirjanpitoComponentData }
    this._kaikkiAlvMaarityksetMap = values.data.alvMap
    this._kaikkiMaksutavatMap = values.data.maksutavatMap
    this._asiakas = values.data.asiakas
    this._kaikkiTilitMap = new Map()
    this._kirjanpitajienNimitiedotMap = values.data.kirjanpitajienNimitiedotMap

    // Set up alvt
    this._kaikkiValittavissaOlevatAlvt.next(Array.from(this._kaikkiAlvMaarityksetMap.values()))
    for (const alv of this._kaikkiAlvMaarityksetMap.values()) {
      this._kaikkiAlvtTunnisteenMukaanMap.set(alv.tunniste.toLowerCase(), alv)
      this._kaikkiAlvtLyhenteenMukaanMap.set(alv.lyhenne.toLowerCase(), alv)
    }

    try {
      this._kirjausSelectedBroadcastChannel = new BroadcastChannel(this._asiakas.avain + '-kirjaus-selected')
      this._kirjausSelectedBroadcastChannel.addEventListener('message', async (event: MessageEvent<BroadcastChannelKlikattuRaportointikirjausPayload>) => {
        const data = event.data
        if (data.kirjauksenAvain && data.maksutavanTunniste && data.kirjauksenKuukausi) {
          await this._raportointiKirjausValittiin(data.kirjauksenAvain, null, data.kirjauksenKuukausi, data.maksutavanTunniste)
        }
      })
      this._kirjausnumeroBroadcastChannel = new BroadcastChannel(this._asiakas.avain + '-kirjausnumero-selected')
      this._kirjausnumeroBroadcastChannel.addEventListener('message', async (event: MessageEvent<KlikattuKirjaus>) => {
        const data = event.data
        if (data.kirjausnumero) {
          await this.raporttikirjaustaKlikatiinUusi(data)
        }
      })
    } catch (err) {
      console.error('Failed to initialize BroadcastChannel', err)
    }

    // Set up tilit
    this._setupValittavatTilit()

    // Set up params
    const paramMap = this._route.snapshot.paramMap
    const vuosi = paramMap.get('vuosi')
    const kuukausi = paramMap.get('kuukausi')
    const valilehti = (paramMap.get('valilehti') as ValilehdenTunnus) || this.valittuvalilehti || 'tositteet'

    if (vuosi && kuukausi && !isNaN(Number(vuosi)) && !isNaN(Number(kuukausi))) {
      const kk: LocalMonth = { year: Number(vuosi), month: Number(kuukausi) }
      // console.log('Set', kk)
      const numberKk = this._dateService.localMonthToNumber(kk)
      this._ensilataustiedotSubject.value.set(numberKk, { isInitialLoadForMonth: true, preselectedMaksutapaTunniste: null, preselectedKirjausnumero: null, preselectedKirjausAvain: null })
      this._ensilataustiedotSubject.next(this._ensilataustiedotSubject.value)
      this._valittuKuukausiSubject.next(kk)
    } else {
      const nyt = this._dateService.dateToLocalDate(new Date())
      const edellinenKuukausi = this._dateService.lisaaKuukausiaLocalMonth(nyt, -1)
      const numberKk = this._dateService.localMonthToNumber(edellinenKuukausi)
      this._ensilataustiedotSubject.value.set(numberKk, { isInitialLoadForMonth: true, preselectedMaksutapaTunniste: null, preselectedKirjausnumero: null, preselectedKirjausAvain: null })
      this._ensilataustiedotSubject.next(this._ensilataustiedotSubject.value)
      this._valittuKuukausiSubject.next(edellinenKuukausi)
      const asiakasAvain = paramMap.get('asiakasAvain')
      this._location.replaceState('/asiakkaat/' + asiakasAvain + '/tilintarkastus/' + edellinenKuukausi.year + '/' + edellinenKuukausi.month + '/' + this.valittuvalilehti)
    }

    this.nykyinenAsiakasObservable = this._asiakasService.nykyinenAsiakasObservable
    // this.tiedostojenValimuistinTilaObservable = this._kirjanpitoImageService.tiedostojenValimuistinTilaObservable.pipe(
    //   map(data => {
    //     if (data) {
    //       // data.kuukausi.year + '/' + data.kuukausi.month + ': ' +
    //       return data.done + '/' + data.total
    //     }
    //     return null
    //   })
    // )

    this.laskuasetuksetObservable = this._asiakasService.nykyisenAsiakkaanLaskuasetuksetObservable

    this.esikatseltavatTositteetObservable = combineLatest([this._kirjanpitoImageHandlerService.esikatseltavaTositeObservable, this._asiakasService.nykyinenAsiakasAvainObservable]).pipe(
      switchMap(([esikatseltava, asiakas]) => {
        if (!asiakas || !esikatseltava) {
          return observableOf<TositeJaNaytettavaSivut[]>(null as TositeJaNaytettavaSivut[])
        }
        return this._kirjanpitoImageHandlerService.muunnaTositteiksiJaSivuiksi(asiakas, esikatseltava.sivut, null, null, true)
      }),
    )

    // this._cdr.detach()

    this.valitunKuukaudenTilikausiObservable = combineLatest([this._asiakasService.nykyisenAsiakkaanTilikaudetObservable, this.valittuKuukausiJaLataustiedotJaRuutuObservable]).pipe(
      map(([tilikaudet, valittuKuukausi]) => {
        const valittuAsLocalDate: LocalDate = { year: valittuKuukausi.kuukausi.year, month: valittuKuukausi.kuukausi.month, day: 15 }
        for (const tilikausi of tilikaudet) {
          if (this._dateService.onkoLocalDateKahdenValissa(valittuAsLocalDate, tilikausi.alkaa, tilikausi.loppuu)) {
            return tilikausi
          }
          if (tilikausi.alkaa.year === valittuKuukausi.kuukausi.year && tilikausi.alkaa.month === valittuKuukausi.kuukausi.month) {
            return tilikausi
          }
          if (tilikausi.loppuu.year === valittuKuukausi.kuukausi.year && tilikausi.loppuu.month === valittuKuukausi.kuukausi.month) {
            return tilikausi
          }
        }
        return null
      }),
    )

    combineLatest([this.valitunKuukaudenTilikausiObservable, this.valittuKuukausiJaLataustiedotJaRuutuObservable])
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(([tilikausi, kuukausiJaLataustiedot]) => {
        if (tilikausi && kuukausiJaLataustiedot) {
          this._tilikarttaService.asetaAktiivinenTilikausiKonteksti(tilikausi, kuukausiJaLataustiedot.kuukausi)
        }
      })

    this._tilikarttaService.kirjauksenTilinValintaTilitObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(tilit => {
      this._kaikkiTilitMap = new Map()
      for (const tili of tilit ?? []) {
        this._kaikkiTilitMap.set(tili.numero, tili)
      }
      this._setupValittavatTilit()
    })

    this.kirjanpidonPerusteKirjaukselleObservable = combineLatest([this.nykyinenAsiakasObservable, this.valittuNaytettavaKirjausObservable]).pipe(
      map(([asiakas, valittuNaytettavaKirjaus]) => {
        if (!asiakas || !valittuNaytettavaKirjaus) {
          return null
        }
        const kirjauksenPvm = this._dateService.numberToLocalDate(valittuNaytettavaKirjaus.kirjaus.p)

        return this._asiakasJaettuService.annaKirjanpidonPeruste(asiakas, kirjauksenPvm)
      }),
    )

    this.tilinpaatosWarningObservable = combineLatest([
      this._asiakasService.nykyinenAsiakasObservable,
      this.valittuKuukausiJaLataustiedotJaRuutuObservable,
      this.valitunKuukaudenTilikausiObservable,
    ]).pipe(
      switchMap(([asiakas, valittuKuukausi, tilikausi]) => {
        if (!tilikausi) {
          return observableOf<string>(null)
        }

        if (asiakas.yritysmuoto !== Yritysmuoto.TOIMINIMI) {
          return observableOf<string>(null)
        }

        if (this._dateService.compareLocalMonths(valittuKuukausi.kuukausi, '!=', tilikausi.loppuu)) {
          return observableOf<string>(null)
        }

        if (this._isMurrettuTilikausi(tilikausi)) {
          return observableOf<string>('Huom! Tilikausi on murrettu, joten tilikaudelta on tehtävä tilinpäätös!')
        }

        const avainluvutUri = this._kirjanpitoUriService.annaTilikaudenAvainluvutUri(asiakas.avain, tilikausi)

        return this._lemonatorFirebase
          .firestoreDoc<TilikaudenAvainluvut>(avainluvutUri)
          .listen()
          .pipe(
            map(avainluvut => {
              if (!avainluvut) {
                return null
              }

              if (avainluvut.l > 700000 || avainluvut.t >= 350000) {
                return 'Huom! Tilikauden taseen loppusumma tai liikevaihto on yli rajojen. Tarkista, pitääkö tilinpäätös tehdä!'
              }
            }),
          )
      }),
    )

    this.valittuNaytettavaKirjausObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(kirjaus => {
      if (kirjaus) {
        document.body.classList.remove('kirjausta-ei-valittu')
      } else {
        document.body.classList.add('kirjausta-ei-valittu')
      }
    })

    this.previousMonthEndingSaldoObservable = combineLatest([
      this.valittuKuukausiJaLataustiedotJaRuutuObservable,
      this.valittuMaksutapaObservable,
      this._asiakasService.nykyinenAsiakasAvainObservable,
    ]).pipe(
      switchMap(([valittuKuukausi, valittuMaksutapa, asiakas]) => {
        if (!valittuKuukausi || !valittuMaksutapa || !asiakas) {
          return observableOf<string>(null)
        }
        if (valittuMaksutapa.kirjauksienLuontityyppi !== KirjauksienLuontityyppi.SAHKOINEN_TILIOTE) {
          return observableOf<string>(null)
        }

        const previousMonth = this._dateService.lisaaKuukausiaLocalMonth(valittuKuukausi.kuukausi, -1)
        const endingDayLocal = this._dateService.kuukaudenViimeinenPaikallinen({ year: previousMonth.year, month: previousMonth.month, day: 15 })
        const endingDayNum = this._dateService.localDateToNumber(endingDayLocal)

        const prevMonthUri = this._kirjanpitoUriService.annaBankTransactionsClosingBalancesUri(
          asiakas.avain,
          valittuMaksutapa.sahkoisenTiliotteenTunniste,
          previousMonth,
          this._getBankBalanceAlgo(valittuMaksutapa),
        )

        return this._lemonaidFirebase
          .firestoreDoc<BankBalancesPerMonth>(prevMonthUri)
          .listen()
          .pipe(
            map(prevMonthData => {
              const saldot = prevMonthData?.saldot || {}
              const dayEndSaldo = saldot['p' + endingDayNum] ?? null

              if (!dayEndSaldo) {
                return ''
              }

              return (
                'Saldo ' +
                this._dateService.muotoileNumberPaiva(dayEndSaldo.paiva, 'fi') +
                '  ' +
                this._currencyService.formatoiRahaIlmanValuuttaSymbolia(dayEndSaldo.saldo, 'fi') +
                ' ' +
                (dayEndSaldo?.currency || 'EUR')
              )
            }),
          )
      }),
    )

    const dailyBalanceTextsMapObservable: Observable<Map<string, string>> = combineLatest([
      this.valittuKuukausiJaLataustiedotJaRuutuObservable,
      this._asiakasService.nykyinenAsiakasAvainObservable,
      this.valittuMaksutapaObservable,
    ]).pipe(
      switchMap(([valittuKuukausi, asiakas, valittuMaksutapa]) => {
        const kuukaudenPaivasaldotMap: Map<string, string> = new Map()

        if (!valittuKuukausi || !asiakas || !valittuMaksutapa) {
          return observableOf(kuukaudenPaivasaldotMap)
        }

        if (valittuMaksutapa.sahkoisenTiliotteenAlatyyppi !== SahkoisenTiliotteenAlatyyppi.AIIA && valittuMaksutapa.sahkoisenTiliotteenAlatyyppi !== SahkoisenTiliotteenAlatyyppi.ENABLE_BANKING) {
          return observableOf(kuukaudenPaivasaldotMap)
        }
        const currentKuukausiAsNum = this._dateService.localMonthToNumber(valittuKuukausi.kuukausi)
        const monthlyBalancesCollection = this._kirjanpitoUriService.annaBankTransactionsClosingBalancesCollectionUri(asiakas.avain)

        return this._lemonaidFirebase
          .firestoreCollection<BankBalancesPerMonth>(monthlyBalancesCollection)
          .where('kuukausi', '==', currentKuukausiAsNum)
          .where('algoVersion', '==', this._getBankBalanceAlgo(valittuMaksutapa))
          .listen()
          .pipe(
            map(monthlySaldot => {
              for (const monthlySaldo of monthlySaldot ?? []) {
                for (const paivasaldo of Object.values(monthlySaldo.saldot ?? {})) {
                  const saldoText =
                    'Saldo ' +
                    this._dateService.muotoileNumberPaiva(paivasaldo.paiva, 'fi') +
                    '   ' +
                    this._currencyService.formatoiRahaIlmanValuuttaSymbolia(paivasaldo.saldo, 'fi') +
                    ' ' +
                    (paivasaldo?.currency || 'EUR')
                  kuukaudenPaivasaldotMap.set(monthlySaldo.iban + '_' + paivasaldo.paiva, saldoText)
                }
              }

              return kuukaudenPaivasaldotMap
            }),
          )
      }),
    )

    dailyBalanceTextsMapObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(dailyBalanceTextsMap => {
      this._dailyBalanceTextsMap = dailyBalanceTextsMap
      if (this._kirjauksetMaksutavoittainSubject.value?.mjk?.length) {
        for (const maksutapaJaKirjaukset of this._kirjauksetMaksutavoittainSubject.value.mjk) {
          if (
            maksutapaJaKirjaukset.maksutapa.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.AIIA ||
            maksutapaJaKirjaukset.maksutapa.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.WEB_SERVICES ||
            maksutapaJaKirjaukset.maksutapa.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.ENABLE_BANKING
          ) {
            // console.time('saldot 1')
            this._updateTotals(maksutapaJaKirjaukset)
            // console.timeEnd('saldot 1')
          }
        }
      }
      this._changeDetectorRef.markForCheck()
    })

    this._tilikarttaService.nykyisenAsiakkaanSelvitettavatOstotTilitObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(selvitettavatOstotTilit => {
      this._selvitettavatOstotTilitMap.clear()
      for (const k of selvitettavatOstotTilit) {
        this._selvitettavatOstotTilitMap.set(k.numero, k)
      }
    })
    this._tilikarttaService.nykyisenAsiakkaanSelvitettavatMyynnitTilitObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(selvitettavatMyynnitTilit => {
      this._selvitettavatMyynnitTilitMap.clear()
      for (const k of selvitettavatMyynnitTilit) {
        this._selvitettavatMyynnitTilitMap.set(k.numero, k)
      }
    })

    this.suodatetutKirjanpitotilitObservable = this.tilinumeroSubject.pipe(
      map(nimi => {
        const suodatetut: Kirjanpitotili[] = nimi ? this._filterTili(nimi, this._kaikkiValittavissaOlevatTilitList) : []

        // Jos tili löytyi ja vain yksi jäljellä, sulje ja tyhjennä
        const tili: Kirjanpitotili = this._kaikkiValittavissaOlevatTilitMap.get((nimi || '').toLowerCase().trim())
        if (tili && suodatetut.length === 1) {
          if (this._tiliAutocomplete.isOpen) {
            this._tiliAutocompleteTrigger.closePanel()
          }
          return []
        }

        // Jos tilejä löytyi, ja valintaboksi kiinni, avaa se.
        if (suodatetut.length > 0 && !this._tiliAutocomplete.isOpen) {
          setTimeout(() => this._tiliAutocompleteTrigger.openPanel(), 50)
        }

        return suodatetut
      }),
    )

    combineLatest([this.alvSubject, this._kaikkiValittavissaOlevatAlvt])
      .pipe(
        map(([nimi, alvt]) => {
          const suodatetut = nimi ? this._filterAlv(nimi, alvt) : []
          // Jos alv löyty ja vain yksi jäljellä, sulje ja tyhjennä
          const tr = (nimi || '').toLowerCase().trim()
          const alv = this._kaikkiAlvtLyhenteenMukaanMap.get(tr) || this._kaikkiAlvtLyhenteenMukaanMap.get('o' + tr) || this._kaikkiAlvtLyhenteenMukaanMap.get('m' + tr) || null
          if (alv && suodatetut.length < 2) {
            if (this._alvAutocomplete.isOpen) {
              this._alvAutocompleteTrigger.closePanel()
            }
            return []
          }
          return suodatetut.sort(this._alvService.alvMaarityksenJarjestaja)
        }),
        takeUntil(this._ngUnsubscribe),
      )
      .subscribe(suodatetutTilit => {
        // console.log(suodatetutTilit)
        this._suodatetutAlvtSubject.next(suodatetutTilit)
      })

    this.kommenttiSubject
      .pipe(
        map(kommentti => {
          const kommentit = this._asiakas.laskunKieli === 'en' ? this._kaikkiAutocompleteKommentitEn : this._kaikkiAutocompleteKommentitFi
          const suodatetut = kommentti ? this._filterKommentti(kommentti, kommentit) : kommentit
          if (kommentit.findIndex(a => a === kommentti) > -1 && suodatetut.length < 2) {
            if (this._kommenttiAutocomplete.isOpen) {
              this._kommenttiAutocompleteTrigger.closePanel()
            }
            return []
          }
          return suodatetut
        }),
        takeUntil(this._ngUnsubscribe),
      )
      .subscribe(suodatetutKommentit => {
        this._suodatetutKommentitSubject.next(suodatetutKommentit)
      })

    this.kirjanpitajanAnnetaanMuokataMitaTahansaKirjauksiaObservable = this._tilintarkastajaService.tilintarkastajaObservable.pipe(
      switchMap(tilintarkastaja => {
        // Tilintarkastajat eivät voi muokata mitä tahansa kirjausta
        if (tilintarkastaja) {
          return of(false)
        }
        return this._kirjautunutKayttajaService.kirjanpitajanAnnetaanMuokataMitaTahansaKirjauksiaObservable
      }),
    )

    this.naytaAlvIlmoitusValilehtiObservable = combineLatest([this._asiakasService.nykyinenAsiakasObservable, this.valittuKuukausiJaLataustiedotJaRuutuObservable]).pipe(
      map(([asiakas, valittuKuukausi]) => {
        if (asiakas && valittuKuukausi) {
          const jaksotiedot = this._kirjanpitoJaettuService.annaAlvIlmoituksenJaksotiedot(valittuKuukausi.kuukausi, asiakas)
          if (jaksotiedot) {
            return valittuKuukausi.kuukausi.year === jaksotiedot.aikavali.end.year && valittuKuukausi.kuukausi.month === jaksotiedot.aikavali.end.month
          }
        }
        return false
      }),
      distinctUntilChanged(),
    )

    const asiakasJaKuukausiNumberObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this.valittuKuukausiJaLataustiedotJaRuutuObservable]).pipe(
      map(([asiakas, valittuKuukausi]) => {
        if (asiakas && valittuKuukausi) {
          return {
            asiakasAvain: asiakas.avain,
            kuukausiNumber: this._dateService.localMonthToNumber(valittuKuukausi.kuukausi),
          }
        }
        return null
      }),
    )

    const yhteisomyyntiDraftObservable = asiakasJaKuukausiNumberObservable.pipe(
      switchMap(data => {
        if (!data) {
          return observableOf(null)
        }
        const draftUri = this._kirjanpitoUriService.annaYhteisomyyntiIlmoituksenDraftUri(data.asiakasAvain, data.kuukausiNumber)
        return this._lemonatorFirebase.firestoreDoc<OmaveroYhteisomyyntiDraft>(draftUri).listen()
      }),
    )

    const yhteisomyyntiLahetetytObservable = asiakasJaKuukausiNumberObservable.pipe(
      switchMap(data => {
        if (!data) {
          return observableOf([])
        }
        const lahetettyCollectionUri = this._kirjanpitoUriService.annaOmaveroYhteisomyyntiIlmoitusLahetettyCollectionUri(data.asiakasAvain)
        return this._lemonatorFirebase.firestoreCollection<OmaveroYhteisomyyntilaskuLahetetty>(lahetettyCollectionUri).where('jakso', '==', data.kuukausiNumber).listen()
      }),
    )

    this.naytaYhteisomyyntiIlmoitusValilehtiObservable = combineLatest([yhteisomyyntiDraftObservable, yhteisomyyntiLahetetytObservable, this.valittuKuukausiJaLataustiedotJaRuutuObservable]).pipe(
      map(([draft, lahetetyt, kuukausiJaLataustiedotJaRuutu]) => {
        if (!kuukausiJaLataustiedotJaRuutu || !kuukausiJaLataustiedotJaRuutu.kuukausi) {
          return false
        }
        const valittuKuukausi = kuukausiJaLataustiedotJaRuutu.kuukausi
        const aloitusPvm = YHTEISOMYYNTI_ALOITUSPVM
        const kuukaudenAlku = { year: valittuKuukausi.year, month: valittuKuukausi.month, day: 1 }
        if (this._dateService.compareLocalDates(kuukaudenAlku, '<', aloitusPvm)) {
          return false
        }

        // Näytä jos on draft jossa on rivejä TAI on lähetetty ilmoitus
        const onDraftRiveja = draft && draft.rivit && draft.rivit.length > 0
        const onLahetettyIlmoitus = lahetetyt && lahetetyt.length > 0
        return onDraftRiveja || onLahetettyIlmoitus
      }),
      distinctUntilChanged(),
    )

    // Yhdistetään molemmat: näytä ilmoitukset välilehti jos jompikumpi on totta
    this.naytaIlmoitusValilehtiObservable = combineLatest([this.naytaAlvIlmoitusValilehtiObservable, this.naytaYhteisomyyntiIlmoitusValilehtiObservable]).pipe(
      map(([onAlvKuukausi, naytaYhteisomyyntiIlmoitus]) => {
        return onAlvKuukausi || naytaYhteisomyyntiIlmoitus
      }),
      distinctUntilChanged(),
    )

    // Yhdistetty status: huomioi sekä ALV että yhteisömyynti
    // Logiikka: Vihreä vain jos molemmat OK (jos molemmat soveltuvat)
    this.yhdistettyStatusObservable = combineLatest([
      this.nykyisellaKuukaudellaOnAlvMuutoksiaObservable,
      this.nykyisellaKuukaudellaOnYhteisomyyntiMuutoksiaObservable,
      this.naytaAlvIlmoitusValilehtiObservable,
      this.naytaYhteisomyyntiIlmoitusValilehtiObservable,
    ]).pipe(
      map(([alvStatus, yhteisomyyntiStatus, onAlvKuukausi, onYhteisomyyntiTarve]) => {
        if (onAlvKuukausi && onYhteisomyyntiTarve) {
          if (alvStatus === 'no' && yhteisomyyntiStatus === 'no') {
            return 'no' as const
          } else if (alvStatus === 'yes' || yhteisomyyntiStatus === 'yes') {
            return 'yes' as const
          } else {
            return 'not-saved-yet' as const
          }
        } else if (onAlvKuukausi) {
          // Jos vain ALV, käytä ALV-statusta
          return alvStatus
        } else if (onYhteisomyyntiTarve) {
          // Jos vain yhteisömyynti, käytä yhteisömyynti-statusta
          return yhteisomyyntiStatus
        }
        // Ei kumpikaan
        return 'no' as const
      }),
      distinctUntilChanged(),
    )

    // Seurataan kuukauden vaihtumista manuaalisen valinnan nollaamiseksi
    const kuukausiStringObservable = this.valittuKuukausiJaLataustiedotJaRuutuObservable.pipe(map(data => (data?.kuukausi ? `${data.kuukausi.year}-${data.kuukausi.month}` : null)))

    // Kuunnellaan muutoksia ja valitaan välilehti automaattisesti
    // Sisällytetään kuukausi combineLatestiin jotta kaikki päivitykset tapahtuvat samassa subscriptionissa
    combineLatest([
      this.naytaAlvIlmoitusValilehtiObservable,
      this.naytaYhteisomyyntiIlmoitusValilehtiObservable,
      this.nykyisellaKuukaudellaOnAlvMuutoksiaObservable,
      this.nykyisellaKuukaudellaOnYhteisomyyntiMuutoksiaObservable,
      kuukausiStringObservable,
    ])
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(([onAlvKuukausi, onYhteisomyynti, alvStatus, yhteisomyyntiStatus, kuukausiString]) => {
        // Tarkistetaan onko kuukausi vaihtunut ja nollataan lippu
        if (kuukausiString !== this._edellinenIlmoitusKuukausi) {
          this._kayttajaValitsiIlmoitusTabinManuaalisesti = false
          this._edellinenIlmoitusKuukausi = kuukausiString
        }

        // Jos käyttäjä on manuaalisesti valinnut välilehden, ei tehdä automaattista valintaa
        if (this._kayttajaValitsiIlmoitusTabinManuaalisesti) {
          // Tarkistetaan kuitenkin että nykyinen valinta on pätevä (välilehti on näkyvissä)
          const currentTab = this._valittuIlmoitusTabSubject.value
          if (currentTab === 'alv' && !onAlvKuukausi) {
            this._valittuIlmoitusTabSubject.next(onYhteisomyynti ? 'yhteisomyynti' : 'alv')
          } else if (currentTab === 'yhteisomyynti' && !onYhteisomyynti) {
            this._valittuIlmoitusTabSubject.next(onAlvKuukausi ? 'alv' : 'yhteisomyynti')
          }
          return
        }

        const alvTarvitseeHuomiota = alvStatus === 'yes' || alvStatus === 'not-saved-yet'
        const yhteisomyyntiTarvitseeHuomiota = yhteisomyyntiStatus === 'yes' || yhteisomyyntiStatus === 'not-saved-yet'

        // Määritetään mikä välilehti näytetään
        let newTab: 'alv' | 'yhteisomyynti' = this._valittuIlmoitusTabSubject.value
        if (onAlvKuukausi && alvTarvitseeHuomiota) {
          newTab = 'alv'
        } else if (onYhteisomyynti && yhteisomyyntiTarvitseeHuomiota) {
          newTab = 'yhteisomyynti'
        } else {
          // Yksikään välilehti ei tarvitse huomiota, varmistetaan että nykyinen valinta on pätevä
          const currentTab = this._valittuIlmoitusTabSubject.value
          if (currentTab === 'alv' && !onAlvKuukausi) {
            newTab = onYhteisomyynti ? 'yhteisomyynti' : 'alv'
          } else if (currentTab === 'yhteisomyynti' && !onYhteisomyynti) {
            newTab = onAlvKuukausi ? 'alv' : 'yhteisomyynti'
          } else {
            newTab = currentTab
          }
        }

        if (this._valittuIlmoitusTabSubject.value !== newTab) {
          this._valittuIlmoitusTabSubject.next(newTab)
        }
      })

    this.ilmoitusTabSelectedIndexObservable = this.valittuIlmoitusTabObservable.pipe(
      map(valittuTab => (valittuTab === 'alv' ? 0 : 1)),
      distinctUntilChanged(),
    )

    this.naytaVeroilmoitusValilehtiObservable = combineLatest([this._asiakasService.nykyinenAsiakasObservable, this.valittuKuukausiJaLataustiedotJaRuutuObservable]).pipe(
      map(([asiakas, valittuKuukausi]) => {
        if (asiakas && valittuKuukausi) {
          const tilikausi = this._kirjanpitoJaettuService.annaKuukaudenAikanaPaattyvaTilikausi(asiakas.tilikaudet, valittuKuukausi.kuukausi)
          return !!tilikausi
        }
        return false
      }),
      distinctUntilChanged(),
    )
    this.naytaLahetysValilehtiObservable = of(false)
    this.veroilmoitusLahetettyObservable = this.valittuKuukausiJaLataustiedotJaRuutuObservable.pipe(
      map(kuuk => {
        return !!kuuk?.ruutu?.vil
      }),
      distinctUntilChanged(),
    )

    const alvIlmoitusjaksoObservable: Observable<AlvIlmoitusjakso> = combineLatest([this.valittuKuukausiJaLataustiedotJaRuutuObservable, this._asiakasService.nykyinenAsiakasObservable]).pipe(
      map(([valittuKuukausi, asiakas]) => {
        if (valittuKuukausi && asiakas) {
          const date = this._dateService.localDateToDate({ year: valittuKuukausi.kuukausi.year, month: valittuKuukausi.kuukausi.month, day: 5 })
          const jakso = this._asiakasJaettuService.annaNykyinenAlvIlmoitusjaksoPaivalleIlmanObjektia(asiakas, date) || AlvIlmoitusjakso.TUNTEMATON
          return jakso
        }
        return AlvIlmoitusjakso.TUNTEMATON
      }),
      distinctUntilChanged(),
    )

    const naytettavatMaksutavatObservable = this._asiakasService.nykyisenAsiakkaanKirjanpidossaNaytettavatMaksutavatObservable.pipe(
      map(maksutavat => {
        if (!maksutavat) {
          return null
        }
        return maksutavat
      }),
      distinctUntilChanged((previous, current) => {
        if (!previous && !!current) {
          return false
        }
        if (!!previous && !current) {
          return false
        }
        if (!previous && !current) {
          return true
        }
        if (previous.length !== current.length) {
          return false
        }
        for (let i = 0; i < current.length; i++) {
          const old = previous[i]
          const nev = current[i]
          // NOTE!! WE ONLY CHECK THE AVAIN - IF SOMETHING ELSE CHANGES, IT'LL BE TAKE INTO ACCOUNT NEXT TIME NAVIGATED HERE!!
          if (
            old.avain !== nev.avain // ||
            // old.tunniste !== nev.tunniste ||
            // old.aktiivinen !== nev.aktiivinen ||
            // old.nimi !== nev.nimi ||
            // this._
          ) {
            return false
          }
        }
        return true
      }),
    )

    const harvoinMuuttuvatTiedot2Observable: Observable<HarvoinMuuttuvatTiedot2> = combineLatest([
      this._asiakasService.nykyinenAsiakasAvainObservable.pipe(
        tap(() => {
          /* this.isInitialLoadForMonth = true; */ console.log('nykyinenAsiakasAvainObservable muuttui')
        }),
      ),
      this._kirjanpidonProjektitMapObservable.pipe(
        tap(() => {
          console.log('_kirjanpidonProjektitMapObservable muuttui')
        }),
      ),
      naytettavatMaksutavatObservable.pipe(
        tap(() => {
          console.log('naytettavatMaksutavatObservable muuttui')
        }),
      ),
      this._naytaPoistetutKirjauksetSubject.pipe(
        tap(() => {
          console.log('_naytaPoistetutKirjauksetSubject muuttui')
        }),
      ),
      this.valittuKuukausiJaLataustiedotJaRuutuObservable.pipe(
        tap(kk => {
          // this.isInitialLoadForMonth = kk.isInitialLoadForMonth
          // this.isInitialLoadForMonthPreselectedKirjausAvain = kk.preselectedKirjausAvain
          // this.isInitialLoadForMonthPreselectedKirjausnumero = kk.preselectedKirjausnumero
          // this.isInitialLoadForMonthPreselectedMaksutapaTunniste = kk.preselectedMaksutapaTunniste
          console.log('valittuKuukausiJaLataustiedotJaRuutuObservable muuttui')
          return kk
        }),
      ),
      alvIlmoitusjaksoObservable.pipe(
        tap(() => {
          console.log('alvIlmoitusjaksoObservable muuttui')
        }),
      ),
      this._allKirjauksetAndAccountsCanBeEdited.pipe(
        tap(() => {
          console.log('_kirjauksetAreLockedSubject muuttui')
        }),
      ),
    ]).pipe(
      map(([asiakas, projektitMap, maksutavat, naytaPoistetut, valittuKuukausi, jakso, kirjauksetAreLocked]) => {
        // console.log('LOADING DUE TO PREVIOUS CHANGE!')
        const retVal: HarvoinMuuttuvatTiedot2 = {
          asiakas: asiakas,
          maksutavat: maksutavat,
          projektitMap: projektitMap,
          alvIlmoitusjakso: jakso,
          kuukausi: valittuKuukausi,
          tilikausiLukossa: true, // Tilintarkastajat: lukitaan tilikausi ettei voi muokata
        }
        return retVal
      }),
    )

    const kirjauksetMuutoksetObservable: Observable<{ harvoinmuuttuvatTiedot: HarvoinMuuttuvatTiedot2; muutokset: QuerySnapshot<DocumentData> }> = harvoinMuuttuvatTiedot2Observable.pipe(
      tap(() => {
        // Clear all caches
        this._kirjauksetLataaSubject.next(true)
        this.naytettavatKirjauksetByKirjausavainMap.clear()
        this.maksutavatJaKirjauksetMap.clear()
        this._kirjausMap.clear()
        this._riviMap.clear()
      }),
      tap(harvoinMuuttuvatTiedot => {
        // Calculate the ALV locked state
        const ilmoitusjakso = harvoinMuuttuvatTiedot.alvIlmoitusjakso
        this._asiakkaanAlvtLukossa = this._kirjanpitoJaettuService.onkoAsiakkaanAlvtLukossa(ilmoitusjakso)
        this._tilikausiLukossa = harvoinMuuttuvatTiedot.tilikausiLukossa
        this._kirjanpidonProjektitMap = harvoinMuuttuvatTiedot.projektitMap
        this._kirjanpidonProjektitAktiivisia = false
        const projs = this._kirjanpidonProjektitMap.values()
        for (const projekti of projs) {
          if (projekti.projekti.usableInLemonator) {
            this._kirjanpidonProjektitAktiivisia = true
            break
          }
        }
      }),
      switchMap(harvoinMuuttuvatTiedot => {
        const asiakas = harvoinMuuttuvatTiedot.asiakas
        const kk = harvoinMuuttuvatTiedot.kuukausi
        const maksutavat = harvoinMuuttuvatTiedot.maksutavat

        if (asiakas && kk && maksutavat && maksutavat.length > 0) {
          const firstOfMonth: LocalDate = { year: kk.kuukausi.year, month: kk.kuukausi.month, day: 1 }
          const lastOfMonth: LocalDate = this._dateService.kuukaudenViimeinenPaikallinen(firstOfMonth)

          const start = this._dateService.localDateToNumber(firstOfMonth) - 1
          const end = this._dateService.localDateToNumber(lastOfMonth) + 1
          const query: Query<Kirjaus> = this._lemonatorFirebase
            .firestoreCollection<Kirjaus>(this._kirjanpitoUriService.annaKirjausCollectionUri(asiakas.avain))
            .where('p', '>', start)
            .where('p', '<', end)
            .orderBy('p', 'asc')
            .getNativeQuery()
          return fromRef(query, { includeMetadataChanges: true }).pipe(
            map(querySnapshot => {
              return { harvoinmuuttuvatTiedot: harvoinMuuttuvatTiedot, muutokset: querySnapshot }
            }),
          )
        }

        return observableOf<{ harvoinmuuttuvatTiedot: HarvoinMuuttuvatTiedot2; muutokset: QuerySnapshot<DocumentData> }>(null)
      }),
    )

    this.showReskontraObservable = this._tilikarttaService.nykyisenAsiakkaanTilikartanJaPaatilikartanTilitObservable.pipe(
      map(tilit => {
        return tilit.some(t => t.reskontraActive)
      }),
    )

    this.showSmallTabsObservable = this.showReskontraObservable
      .pipe(
        switchMap(reskontraBtnVisible => {
          if (reskontraBtnVisible) {
            return this._breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, '(min-width: 1280px) and (max-width: 1599.99px)'])
          }
          return this._breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, '(min-width: 1280px) and (max-width: 1523.99px)'])
        }),
      )
      .pipe(
        map(br => {
          return br.matches
        }),
      )

    // const filterInflightSaveMuutoksetObservable = kirjauksetMuutoksetObservable.pipe(
    //   map(changes => {
    //     return changes.filter(change => {
    //       if (change.type === 'modified' && this._savesInFlightMap.size > 0) {
    //         const kirjaus = change.doc.data() as Kirjaus
    //         if (kirjaus.tallennustunnus && this._savesInFlightMap.get(kirjaus.avain) === kirjaus.tallennustunnus) {
    //           this._savesInFlightMap.delete(kirjaus.avain)
    //           const naytettavaKirjaus = this.etsiKirjausCachestaKirjauksella(kirjaus)
    //           if (naytettavaKirjaus) {
    //             // this.poistaKirjausMaksutavasta(naytettavaKirjaus)
    //             this.paivitaInflightSaveNaytettavaKirjausKirjauksesta(naytettavaKirjaus, kirjaus)
    //             this.asetaKirjausValimuistiin(naytettavaKirjaus)
    //             setTimeout(() => {
    //               if (this._valittuNaytettavaKirjausSubject.value?.kirjaus?.avain === kirjaus.avain) {
    //                 this._valittuNaytettavaKirjausSubject.next(naytettavaKirjaus)
    //               }
    //             }, 0)
    //             // this.asetaKirjausMaksutapaan(naytettavaKirjaus, maksutavat)

    //             for (const maksutapaJaKirjaukset of this.maksutavatJaKirjauksetMap.values()) {
    //               if (maksutapaJaKirjaukset.maksutapa.tunniste + '' === kirjaus.maksutavanTunniste + '') {
    //                 this.paivitaKirjaamattomienMaara(maksutapaJaKirjaukset)
    //               }
    //             }

    //             return false
    //           }
    //         }
    //       }
    //       return true
    //     })
    //   }),
    //   filter(changes => {
    //     const filter = this.isInitialLoadForMonth || changes.length > 0
    //     if (!filter) {
    //       this._kirjauksetMaksutavoittainTabeilleSubject.next(Array.from(this.maksutavatJaKirjauksetMap.values()))
    //     }
    //     return filter
    //   })
    // )

    // const kirjauksetJaSideFeeditObservable = merge(kirjauksetMuutoksetObservable, this._sidefeedChangesSubject)

    const kirjauksetJaMaksutavatObservable: Observable<MaksutavatJaKirjauksetJaHarvoinMuuttuvatTiedot> = kirjauksetMuutoksetObservable.pipe(
      tap(() => console.log('kirjauksetMuutoksetObservable muuttui!')),
      withLatestFrom(
        naytettavatMaksutavatObservable.pipe(tap(() => console.log('naytettavatMaksutavatObservable muuttui!'))),
        this._naytaPoistetutKirjauksetSubject.pipe(tap(() => console.log('_naytaPoistetutKirjauksetSubject muuttui!'))),
      ),
      tap(([kirjausmuutokset, maksutavat, naytaPoistetutKirjaukset]) => {
        // TODO: COMBINE THREE LATEST AS ONE OBSERVABLE AND EMIT ONLY WHEN ALL ARE READY!!

        if (!maksutavat || maksutavat.length < 1) {
          if (kirjausmuutokset?.muutokset && kirjausmuutokset.muutokset.docChanges().length > 0) {
            throw new Error('Maksutavat puuttuvat ja silti kirjausmuutoksia!')
          }
          return
        }

        const valittuKuukausi = kirjausmuutokset.harvoinmuuttuvatTiedot.kuukausi.kuukausi

        this._varmistaMaksutavat(maksutavat, valittuKuukausi)

        // console.time('KASITTELY')

        if (kirjausmuutokset?.muutokset) {
          const changes = kirjausmuutokset.muutokset.docChanges()
          for (const change of changes) {
            const kirjaus = change.doc.data() as Kirjaus
            const naytettavaKirjaus = this.etsiKirjausCachestaKirjauksella(kirjaus)
            if (kirjaus.poistettu && !naytaPoistetutKirjaukset) {
              if (naytettavaKirjaus) {
                this.poistaKirjausMaksutavasta(naytettavaKirjaus)
              }
              this.naytettavatKirjauksetByKirjausavainMap.delete(change.doc.id)
            } else if (change.type === 'added' || change.type === 'modified') {
              if (naytettavaKirjaus) {
                this.poistaKirjausMaksutavasta(naytettavaKirjaus)
                this.paivitaNaytettavaKirjausKirjauksesta(naytettavaKirjaus, kirjaus)
                this.asetaKirjausValimuistiin(naytettavaKirjaus)
                this._asetaKirjausMaksutapaan(naytettavaKirjaus, valittuKuukausi)
              } else {
                const luotu = this.luoNaytettavaKirjausKirjauksesta(kirjaus)
                this.asetaKirjausValimuistiin(luotu)
                this._asetaKirjausMaksutapaan(luotu, valittuKuukausi)
              }
            } else if (change.type === 'removed') {
              if (naytettavaKirjaus) {
                this.poistaKirjausMaksutavasta(naytettavaKirjaus)
              }
              this.naytettavatKirjauksetByKirjausavainMap.delete(change.doc.id)
            }
          }
        }

        if (kirjausmuutokset?.muutokset?.metadata && !kirjausmuutokset.muutokset.metadata.fromCache) {
          setTimeout(() => {
            if (this._kirjauksetLataaSubject.value) {
              this._kirjauksetLataaSubject.next(false)
            }
          }, 250)
        }
      }),
      map(([kirjausmuutokset]) => {
        const returnValue: MaksutapaJaKirjaukset[] = []
        for (const mjk of this.maksutavatJaKirjauksetMap.values()) {
          if (mjk.maksutapa.aktiivinen || mjk.kirjaukset.length) {
            returnValue.push(mjk)
          }
        }

        returnValue.sort((a, b) => {
          if (a.maksutapa.tunniste === AsiakkaanMaksutavat.MAKSUTAPA_MUU.tunniste) {
            return -1
          }
          if (b.maksutapa.tunniste === AsiakkaanMaksutavat.MAKSUTAPA_MUU.tunniste) {
            return 1
          }
          return a.maksutapa.tunniste - b.maksutapa.tunniste
        })

        const ret: MaksutavatJaKirjauksetJaHarvoinMuuttuvatTiedot = {
          harvoinMuuttuvatTiedot: kirjausmuutokset.harvoinmuuttuvatTiedot,
          mjk: returnValue,
        }

        return ret
      }),
      lemonShare(),
    )

    kirjauksetJaMaksutavatObservable
      .pipe(
        tap(maksutavatJaKirjaukset => {
          const kirjausSort = this._kirjanpitoJaettuService.annaKirjaustenVertailuFunktio()
          const naytettavaKirjausSort: (a: NaytettavaKirjaus, b: NaytettavaKirjaus) => number = (a: NaytettavaKirjaus, b: NaytettavaKirjaus): number => {
            return kirjausSort(a.kirjaus, b.kirjaus)
          }

          for (const maksutapaJaKirjaukset of maksutavatJaKirjaukset.mjk) {
            maksutapaJaKirjaukset.kirjaukset.sort(naytettavaKirjausSort)

            if (
              maksutapaJaKirjaukset.maksutapa.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.AIIA ||
              maksutapaJaKirjaukset.maksutapa.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.WEB_SERVICES ||
              maksutapaJaKirjaukset.maksutapa.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.ENABLE_BANKING
            ) {
              // console.time('saldot 2')
              this._updateTotals(maksutapaJaKirjaukset)
              // console.timeEnd('saldot 2')
            }

            this.paivitaKirjaamattomienMaara(maksutapaJaKirjaukset)
          }

          // console.timeEnd('KASITTELY')
        }),
        filter(maksutavoittain => !!maksutavoittain && !!maksutavoittain.mjk && !!maksutavoittain.harvoinMuuttuvatTiedot),
        takeUntil(this._ngUnsubscribe),
      )
      .subscribe(async maksutavoittain => {
        console.log('MAKSUTAVOITTAIN MUUTTUI!', maksutavoittain?.harvoinMuuttuvatTiedot?.kuukausi?.lataustiedot?.isInitialLoadForMonth)

        if (maksutavoittain?.harvoinMuuttuvatTiedot?.kuukausi?.lataustiedot?.isInitialLoadForMonth && maksutavoittain?.mjk) {
          console.log('Aktivoi ensimmäistä kertaa', maksutavoittain.mjk.length)
          maksutavoittain.harvoinMuuttuvatTiedot.kuukausi.lataustiedot.isInitialLoadForMonth = false
          await this._aktivoiEnsimmaistaKertaa(maksutavoittain.harvoinMuuttuvatTiedot.kuukausi, maksutavoittain.mjk)
          maksutavoittain.harvoinMuuttuvatTiedot.kuukausi.lataustiedot.preselectedMaksutapaTunniste = null
        }

        this._kirjauksetMaksutavoittainSubject.next(maksutavoittain)
        this._kirjauksetMaksutavoittainTabeilleSubject.next(maksutavoittain?.mjk)
      })

    arvonMuutokset(this.suodatusLomake.naytaVainTileihinRajatut, { injector: this._injector })
      .pipe(
        debounceTime(350),
        map(arvo => {
          if (arvo) {
            const set = new Set<string>()
            const tilit = (arvo + '').split(',')
            for (const tili of tilit) {
              const trimmed = tili.trim()
              if (trimmed) {
                set.add(trimmed)
              }
            }
            return set
          }
          return new Set<string>()
        }),
        takeUntil(this._ngUnsubscribe),
      )
      .subscribe(tilirajaukset => {
        this._naytaVainTileihinRajatutSubject.next(tilirajaukset)
      })

    this.valitunKuukaudenJaMaksutavanKirjauksetObservable = combineLatest([
      this._kirjauksetMaksutavoittainObservable.pipe(tap(() => console.log('_kirjauksetMaksutavoittainObservable muuttui'))),
      this._naytaVainHyvaksymattomatSubject.pipe(tap(() => console.log('_naytaVainHyvaksymattomatSubject muuttui'))),
      this._naytaVainTileihinRajatutSubject.pipe(tap(() => console.log('_naytaVainTileihinRajatutSubject muuttui'))),
      this.valittuSivuSubject.pipe(tap(() => console.log('valittuSivuSubject muuttui'))),
      this.kirjauksiaPerSivuSubject.pipe(tap(() => console.log('kirjauksiaPerSivuSubject muuttui'))),
    ]).pipe(
      switchMap(async ([maksutavoittain, naytaVainHyvaksymattomat, suodatettavatTilitSet, valittuSivu, kirjauksiaPerSivu]) => {
        // console.log('SIVUTUSTIEDOT: ', valittuSivu.sivu, kirjauksiaPerSivu)
        // console.time('Filter only correct maksutapa')
        for (const maksutapaJaKirjaukset of maksutavoittain.mjk) {
          // console.log('LÖYTYI?', maksutapaJaKirjaukset.maksutapa.avain, maksutapaJaKirjaukset.valittu)
          if (maksutapaJaKirjaukset.valittu) {
            let kirj: NaytettavaKirjaus[] = null
            if (naytaVainHyvaksymattomat && suodatettavatTilitSet.size > 0) {
              kirj = maksutapaJaKirjaukset.kirjaukset.filter(a => !a.kirjaus.kirjanpitajaHyvaksynyt && a.kirjaus.rivit.find(b => suodatettavatTilitSet.has(b.t)))
            } else if (naytaVainHyvaksymattomat) {
              kirj = maksutapaJaKirjaukset.kirjaukset.filter(a => !a.kirjaus.kirjanpitajaHyvaksynyt)
            } else if (suodatettavatTilitSet.size > 0) {
              kirj = maksutapaJaKirjaukset.kirjaukset.filter(a => a.kirjaus.rivit.find(b => suodatettavatTilitSet.has(b.t)))
            } else {
              kirj = maksutapaJaKirjaukset.kirjaukset
            }

            const mjk: MaksutapaJaKirjaukset = {
              kasiteltyja: maksutapaJaKirjaukset.kasiteltyja,
              kasittelematta: maksutapaJaKirjaukset.kasittelematta,
              kirjaukset: kirj,
              sivutetutKirjaukset: kirj.length > kirjauksiaPerSivu ? kirj.slice((valittuSivu.sivu - 1) * kirjauksiaPerSivu, valittuSivu.sivu * kirjauksiaPerSivu) : kirj,
              maksutapa: maksutapaJaKirjaukset.maksutapa,
              maksutavanKuva: maksutapaJaKirjaukset.maksutavanKuva,
              naytaLisaa: maksutapaJaKirjaukset.naytaLisaa,
              valittu: maksutapaJaKirjaukset.valittu,
            }

            // NOTE! DO NOT BLOCK THIS CALL!
            // The kirjaukset must be rendered in order for the code to
            // Be able to activate it.
            this._aktivoiKirjaus(mjk, valittuSivu, maksutavoittain.harvoinMuuttuvatTiedot.kuukausi)
            // console.timeEnd('Filter only correct maksutapa')

            return mjk
          }
        }
        // console.timeEnd('Filter only correct maksutapa')
        return null
      }),
    )

    // this.valittuKuukausiJaLataustiedotJaRuutuObservable.pipe(
    //   takeUntil(this._ngUnsubscribe)
    // ).subscribe(valittuKuukausi => {
    //   this._kirjanpitoImageService.asetaValittuKuukausi(valittuKuukausi)
    // })

    const ylarivinNappuloidenMaaraObservable: Observable<number> = combineLatest([this.naytaIlmoitusValilehtiObservable, this.naytaVeroilmoitusValilehtiObservable]).pipe(
      map(([naytaAlvIlmoitusValilehti, naytaVeroilmoitusValilehti]) => {
        return naytaAlvIlmoitusValilehti && naytaVeroilmoitusValilehti ? 4 : 5
      }),
      distinctUntilChanged(),
    )

    this.rivinKirjauksetMaksutavottainObservable = combineLatest([
      this._kirjauksetMaksutavoittainTabeilleSubject,
      this._maksutavatJoissaOnKirjaamattomiaTositteitaSubject,
      ylarivinNappuloidenMaaraObservable,
    ]).pipe(
      map(([maksutavoittain, kirjaamattomia]) => {
        const kaikki = this.suodataJaJarjestaMaksutavat(maksutavoittain, kirjaamattomia)
        return kaikki
      }),
    )

    this._selectTabInternal(valilehti)

    // this.nykyinenAsiakasObservable.pipe(
    //   map(asiakas => asiakas?.kasittelija === 'QgPvtcCjoOdf6Zg7lgMwqLWp2BG2')
    // ).subscribe(onkoHolvi => {
    //   this._onkoHolviAsiakas = onkoHolvi
    // })

    // this._asiakasService.nykyisenAsiakkaanKayttajatObservable.pipe(take(1)).subscribe(kayttajat => {
    //   this._vahintaanYhdellaKayttajallaOlevatMaksutavatSet.clear()
    //   if (!kayttajat?.length) {
    //     return
    //   }
    //   for (const kayttaja of kayttajat) {
    //     for (const maksutapa of (kayttaja.maksutavat || [])) {
    //       this._vahintaanYhdellaKayttajallaOlevatMaksutavatSet.add(maksutapa + '')
    //     }
    //   }
    // })

    this.displayAlgoComparisonToolObservable = combineLatest([this.isAdminObservable, this.valittuMaksutapaObservable]).pipe(
      map(([isAdmin, valittuMaksutapa]) => {
        if (!isAdmin) {
          return false
        }
        return valittuMaksutapa?.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.AIIA
      }),
    )

    const devaajaTaiTukiObservable = this._tilintarkastajaService.tilintarkastajaObservable.pipe(
      switchMap(tilintarkastaja => {
        // Tilintarkastajat eivät ole kehittäjiä tai tukea
        if (tilintarkastaja) {
          return of(false)
        }
        return this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaTaiTukiObservable
      }),
    )

    arvonMuutokset(this.adminAsetuksetLomake.bankBalanceAlgoComparisonFirst, { injector: this._injector })
      .pipe(takeUntil(this._ngUnsubscribe), withLatestFrom(this.displayAlgoComparisonToolObservable))
      .subscribe(async ([selectedAlgo, displayAlgoComparisonTool]) => {
        const secondAlgo = this.adminAsetuksetLomake.bankBalanceAlgoComparisonSecond().value()
        this._bankBalanceComparisonSubject.next({ first: selectedAlgo, second: secondAlgo })

        if (displayAlgoComparisonTool) {
          await this._updatePaivasaldotErottaaKolmiot(selectedAlgo) // Use the first algorithm in the comparison to update the saldot-erotttaa triangles
        }
      })

    arvonMuutokset(this.adminAsetuksetLomake.bankBalanceAlgoComparisonSecond, { injector: this._injector })
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(async selectedAlgo => {
        const firstAlgo = this.adminAsetuksetLomake.bankBalanceAlgoComparisonFirst().value()
        this._bankBalanceComparisonSubject.next({ first: firstAlgo, second: selectedAlgo })
      })

    this.valittuMaksutapaObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(mt => {
      if (!mt) {
        return
      }

      const selectedAlgo = this.adminAsetuksetLomake.bankBalanceAlgoComparisonFirst().value()
      if (mt.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.WEB_SERVICES || mt.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.ENABLE_BANKING) {
        if (BankBalanceCalcAlgorithm.VERSION_ONE !== selectedAlgo) {
          asetaArvo(this.adminAsetuksetLomake.bankBalanceAlgoComparisonFirst, BankBalanceCalcAlgorithm.VERSION_ONE)
        }
      } else {
        const maksutapaHasDefaultAlgo = mt.sahkoisenTiliotteenAlatyyppi === SahkoisenTiliotteenAlatyyppi.AIIA && mt.bankBalanceCalcAlgorithm
        if (maksutapaHasDefaultAlgo && mt.bankBalanceCalcAlgorithm !== selectedAlgo) {
          asetaArvo(this.adminAsetuksetLomake.bankBalanceAlgoComparisonFirst, mt.bankBalanceCalcAlgorithm)
        }
      }
    })

    this.saldoUriObservable = combineLatest([
      this._asiakasService.nykyinenAsiakasAvainObservable,
      this.valittuMaksutapaObservable,
      this.valittuKuukausiJaLataustiedotJaRuutuObservable,
      arvonMuutokset(this.adminAsetuksetLomake.bankBalanceAlgoComparisonFirst, { injector: this._injector }).pipe(startWith(BankBalanceCalcAlgorithm.AIIA_OLD)),
    ]).pipe(
      map(([asiakas, maksutapa, tiedot, algo]) => {
        if (!asiakas || !maksutapa?.sahkoisenTiliotteenTunniste || !tiedot?.kuukausi || !algo) {
          return null
        }
        return (
          'customers/' +
          asiakas.avain +
          '/bank-transactions-closing-balances/' +
          asiakas.avain +
          '_' +
          maksutapa.sahkoisenTiliotteenTunniste +
          '_' +
          this._dateService.localMonthToNumber(tiedot.kuukausi) +
          (!!algo && algo !== BankBalanceCalcAlgorithm.AIIA_OLD ? '_' + algo : '')
        )
      }),
    )

    this.saldoEncodedUriObservable = this.saldoUriObservable.pipe(
      map(uri => {
        if (!uri) {
          return null
        }
        return this._debugService.createFirestoreLinkLemonaid(uri)
      }),
    )

    this.onkoSuoriteTaiLaskuperusteinenObservable = combineLatest([this._asiakasService.nykyinenAsiakasObservable, this.valittuKuukausiJaLataustiedotJaRuutuObservable]).pipe(
      map(([asiakas, tiedot]) => {
        if (!asiakas?.kirjanpidonPerusteet?.length || !tiedot?.kuukausi) {
          return false
        }

        const kuukausiLocalDate: LocalDate = { year: tiedot.kuukausi.year, month: tiedot.kuukausi.month, day: 1 }
        const peruste = this._asiakasJaettuService.annaKirjanpidonPeruste(asiakas, kuukausiLocalDate)

        return peruste === KirjanpidonPeruste.SUORITE || peruste === KirjanpidonPeruste.LASKU
      }),
    )
  }

  // this.isInitialLoadForMonthPreselectedKirjausAvain
  private async _aktivoiKirjaus(maksutapaJaKirjaukset: MaksutapaJaKirjaukset, sivutiedot: Sivutiedot, kuukausiJaLataustiedot: KuukausiJaLataustiedot) {
    console.log('_aktivoiKirjaus 1')

    if (!maksutapaJaKirjaukset) {
      return
    }

    console.log('_aktivoiKirjaus 2')

    if (kuukausiJaLataustiedot.lataustiedot.preselectedKirjausAvain) {
      console.log('_aktivoiKirjaus 5')
      const kirjaus = maksutapaJaKirjaukset.kirjaukset.find(a => a.kirjaus.avain === kuukausiJaLataustiedot.lataustiedot.preselectedKirjausAvain)
      if (kirjaus?.kirjaus?.avain) {
        console.log('_aktivoiKirjaus 6')
        kuukausiJaLataustiedot.lataustiedot.preselectedKirjausAvain = null
        // console.log('Löytyi preselected ja aktivoitavaKirjausAvain 1', kirjaus.kirjaus.avain, maksutapaJaKirjaukset.maksutapa.tunniste)
        await this._odotaKirjauksenIlmestymistaJaAktivoiSe(kirjaus.kirjaus.avain)
        // setTimeout(() => {
        //   // Stupid but hold on to this for some time before overwriting it, as there maybe multiple emits near the time
        //   // we're still scrolling.
        //   this.isInitialLoadForMonthPreselectedKirjausAvain = null
        // }, 4000)
      }
    } else if (kuukausiJaLataustiedot.lataustiedot.preselectedKirjausnumero) {
      console.log('_aktivoiKirjaus 7')
      const kirjaus = maksutapaJaKirjaukset.kirjaukset.find(a => a.kirjaus.kirjausnumero === kuukausiJaLataustiedot.lataustiedot.preselectedKirjausnumero)
      if (kirjaus?.kirjaus?.avain) {
        console.log('_aktivoiKirjaus 8')
        kuukausiJaLataustiedot.lataustiedot.preselectedKirjausnumero = null
        // console.log('Löytyi preselected ja aktivoitavaKirjausAvain 2', kirjaus.kirjaus.avain, maksutapaJaKirjaukset.maksutapa.tunniste)
        await this._odotaKirjauksenIlmestymistaJaAktivoiSe(kirjaus.kirjaus.avain)
        // setTimeout(() => {
        //   // Stupid but hold on to this for some time before overwriting it, as there maybe multiple emits near the time
        //   // we're still scrolling.
        //   this.isInitialLoadForMonthPreselectedKirjausnumero = null
        // }, 4000)
      }
    } else if (sivutiedot.aktivoiEnsimmainen) {
      console.log('_aktivoiKirjaus 3')
      const kirjaus = maksutapaJaKirjaukset.sivutetutKirjaukset[0]
      if (kirjaus?.kirjaus?.avain) {
        console.log('_aktivoiKirjaus 4', kirjaus.kirjaus.kirjausnumero, kirjaus.kirjaus.avain)
        await this._odotaKirjauksenIlmestymistaJaAktivoiSe(kirjaus.kirjaus.avain)
      }
    }

    sivutiedot.aktivoiEnsimmainen = false
    // setTimeout(() => {
    //   this._changeDetectorRef.markForCheck()
    // }, 250)
  }

  private _setupValittavatTilit() {
    this._kaikkiValittavissaOlevatTilitMap.clear()
    this._kaikkiValittavissaOlevatTilitList.length = 0
    for (const tili of this._kaikkiTilitMap.values()) {
      /** Never ever ever save any values to this account! */
      /** This is special account and must not be used! */
      if (tili.numero === '2370') {
        continue
      }
      if (tili.numero.length > 3 && tili.aktiivinen) {
        tili.nimi = this._tilikarttaJaettuService.annaKirjanpitotilinNimi(tili, 'fi')
        if (tili.reskontraActive) {
          tili.nimi += ' (reskontra)'
        }
        if (tili.poistotiedot) {
          tili.nimi += ' (A' + tili.poistotiedot.poistoprosentti + ')'
        }
        if (
          this._allKirjauksetAndAccountsCanBeEdited.value ||
          tili.numero === '2946' || // TODO: SPECIAL CASE! IF WE EVER IMPLEMENT AUTOMAATTITYHJENNYS -> PLEASE DO REMOVE THIS! THERE ARE OTHER PLACES, SEARH FOR THE NUMBER!!
          (tili.numero !== '1764' && tili.numero !== '2937')
        ) {
          this._kaikkiValittavissaOlevatTilitList.push(tili)
          this._kaikkiValittavissaOlevatTilitMap.set(tili.numero, tili)
        }
      }
    }
  }

  private _updateTotals(maksutapaJaKirjaukset: MaksutapaJaKirjaukset) {
    const iban = maksutapaJaKirjaukset.maksutapa.sahkoisenTiliotteenTunniste
    const kirjaukset = maksutapaJaKirjaukset.kirjaukset
    const kirjauksiaKpl = kirjaukset.length
    let index = 0
    let panotKpl = 0,
      panotKplKk = 0
    let panotSumma = 0,
      panotSummaKk = 0
    let ototKpl = 0,
      ototKplKk = 0
    let ototSumma = 0,
      ototSummaKk = 0
    for (const kirjaus of kirjaukset) {
      const summa = kirjaus.kirjaus.kirjauksenSumma
      if (summa > 0) {
        panotKpl++
        panotKplKk++
        panotSumma += summa
        panotSummaKk += summa
      } else if (summa < 0) {
        ototKpl++
        ototKplKk++
        ototSumma += summa
        ototSummaKk += summa
      }

      index++
      if (index === kirjauksiaKpl || kirjaukset[index].kirjaus.p !== kirjaus.kirjaus.p) {
        const saldoText: string = this._dailyBalanceTextsMap.get(iban + '_' + kirjaus.kirjaus.p) ?? ''

        // const startLength = 6

        // Collect longest numbers for formatting
        let longestNumberCharCount = 0

        // const saldoFormatted = this._currencyService.formatoiRahaIlmanValuuttaSymbolia(saldo, 'fi')
        const panotFormatted = this._currencyService.formatoiRahaIlmanValuuttaSymbolia(panotSumma, 'fi')
        const ototFormatted = this._currencyService.formatoiRahaIlmanValuuttaSymbolia(ototSumma, 'fi')

        // if (longestNumberCharCount < saldoFormatted.length) { longestNumberCharCount = saldoFormatted.length }
        if (longestNumberCharCount < panotFormatted.length) {
          longestNumberCharCount = panotFormatted.length
        }
        if (longestNumberCharCount < ototFormatted.length) {
          longestNumberCharCount = ototFormatted.length
        }

        longestNumberCharCount += 2

        const dayString = this._dateService.muotoileNumberPaiva(kirjaus.kirjaus.p, 'fi')

        const panotStringLenght = (panotKpl + '').length + 4
        const ototStringLenght = (ototKpl + '').length + 4
        const padLengthForKpl = Math.max(panotStringLenght, ototStringLenght, dayString.length)

        if (!!saldoText) {
          kirjaus.pvmSaldo = saldoText
        } else {
          delete kirjaus.pvmSaldo
        }

        if (panotKpl) {
          kirjaus.pvmPanot = 'Panot ' + this._stringService.leftpad(panotKpl + ' kpl', padLengthForKpl, ' ') + ' ' + this._stringService.leftpad(panotFormatted, longestNumberCharCount, ' ') + ' EUR'
        } else {
          delete kirjaus.pvmPanot
        }

        if (ototKpl) {
          kirjaus.pvmOtot = 'Otot  ' + this._stringService.leftpad(ototKpl + ' kpl', padLengthForKpl, ' ') + ' ' + this._stringService.leftpad(ototFormatted, longestNumberCharCount, ' ') + ' EUR'
        } else {
          delete kirjaus.pvmOtot
        }

        panotKpl = 0
        panotSumma = 0
        ototKpl = 0
        ototSumma = 0
      } else {
        delete kirjaus.pvmSaldo
        delete kirjaus.pvmPanot
        delete kirjaus.pvmOtot
      }
    }

    if (kirjaukset.length) {
      const day = this._dateService.numberToLocalDate(kirjaukset[0].kirjaus.p)
      const kkString = (day.month < 10 ? '0' + day.month : day.month) + '/' + day.year
      const padKpl = Math.max((ototKplKk + '').length, (panotKplKk + '').length) + 1
      const panotSummaString = this._currencyService.formatoiRahaIlmanValuuttaSymbolia(panotSummaKk, 'fi')
      const ototSummaString = this._currencyService.formatoiRahaIlmanValuuttaSymbolia(ototSummaKk, 'fi')
      const padSumma = Math.max(panotSummaString.length, ototSummaString.length) + 2
      maksutapaJaKirjaukset.panot =
        'Panot ' + kkString + ' ' + this._stringService.leftpad(panotKplKk + '', padKpl, ' ') + ' kpl ' + this._stringService.leftpad(panotSummaString, padSumma, ' ') + ' EUR'
      maksutapaJaKirjaukset.otot = 'Otot  ' + kkString + ' ' + this._stringService.leftpad(ototKplKk + '', padKpl, ' ') + ' kpl ' + this._stringService.leftpad(ototSummaString, padSumma, ' ') + ' EUR'
    } else {
      delete maksutapaJaKirjaukset.panot
      delete maksutapaJaKirjaukset.otot
    }
  }

  ngOnDestroy() {
    if (this._kirjausSelectedBroadcastChannel) {
      this._kirjausSelectedBroadcastChannel.close()
      this._kirjausSelectedBroadcastChannel = null
    }
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  private _filterTili(numeroTaiNimi: string, kirjanpitotilit: Kirjanpitotili[]): Kirjanpitotili[] {
    const filterValue = numeroTaiNimi.toLowerCase()
    if (this._currencyService.onkoMerkkijonoKokonaisluku(filterValue)) {
      return kirjanpitotilit.filter(tili => {
        if (
          tili.numero.startsWith(filterValue) &&
          ('2946' === tili.numero || // TODO: SPECIAL CASE! IF WE EVER IMPLEMENT AUTOMAATTITYHJENNYS -> PLEASE DO REMOVE THIS! THERE ARE OTHER PLACES, SEARCH FOR THE NUMBER!!
            !this._kirjanpitoJaettuService.onkoAlvTilinumero(tili.numero) ||
            this._allKirjauksetAndAccountsCanBeEdited.value)
        ) {
          return true
        }
        return false
      })
    }
    return kirjanpitotilit.filter(tili => {
      if (
        this._tilikarttaJaettuService.annaKirjanpitotilinNimi(tili, 'fi').toLowerCase().indexOf(filterValue) > -1 &&
        ('2946' === tili.numero || // TODO: SPECIAL CASE! IF WE EVER IMPLEMENT AUTOMAATTITYHJENNYS -> PLEASE DO REMOVE THIS! THERE ARE OTHER PLACES, SEARCH FOR THE NUMBER!!
          !this._kirjanpitoJaettuService.onkoAlvTilinumero(tili.numero) ||
          this._allKirjauksetAndAccountsCanBeEdited.value)
      ) {
        return true
      }
      return false
    })
  }

  private _filterAlv(lyhenneTaiNimi: string, alvt: AlvMaaritys[]): AlvMaaritys[] {
    const filterValue = lyhenneTaiNimi.toLowerCase()
    return alvt.filter(alv => alv.lyhenne.toLowerCase().indexOf(filterValue) > -1 || alv.nimi.toLowerCase().indexOf(filterValue) > -1)
  }

  private _filterKommentti(kommentti: string, kommentit: string[]): string[] {
    const filterValue = kommentti.toLowerCase()
    return kommentit.filter(k => k.toLowerCase().indexOf(filterValue) > -1)
  }

  displayTiliFn(tili?: Kirjanpitotili): string | undefined {
    const palautettava = tili && tili.numero ? tili.numero : (tili as any as string) // + ' ' + tili.nimi
    // console.log(palautettava, tili)
    return palautettava
  }

  displayAlvFn(alv?: AlvMaaritys): string | undefined {
    // + ' ' + alv.nimi
    return alv && alv.lyhenne ? alv.lyhenne : (alv as any as string)
  }

  private poistaValittuNaytettavaKirjaus() {
    this.poistaNykyisenValitunKirjauksenCssLuokat()
    if (this._valittuNaytettavaKirjausSubject.value !== null) {
      this._valittuNaytettavaKirjausSubject.next(null)
    }
  }

  private async _vaihdaKuukausiJosTarvitsee(
    vuosi: number,
    kuukausi: number,
    preselectedKirjausAvain: string,
    preselectedKirjausnumero: string,
    preselectedMaksutapaTunniste: string,
    nytValittuKuukausi: LocalMonth,
  ) {
    console.log('_vaihdaKuukausiJosTarvitsee 1')
    if (!nytValittuKuukausi || nytValittuKuukausi.year !== vuosi || nytValittuKuukausi.month !== kuukausi) {
      const asiakas = await firstValueFrom(this._asiakasService.nykyinenAsiakasAvainObservable)
      if (asiakas) {
        console.log('_vaihdaKuukausiJosTarvitsee 2')
        this.poistaValittuNaytettavaKirjaus()
        const kk: LocalMonth = { year: vuosi, month: kuukausi }
        const numberKk = this._dateService.localMonthToNumber(kk)
        this._ensilataustiedotSubject.value.set(numberKk, {
          isInitialLoadForMonth: true,
          preselectedMaksutapaTunniste: preselectedMaksutapaTunniste,
          preselectedKirjausnumero: preselectedKirjausnumero,
          preselectedKirjausAvain: preselectedKirjausAvain,
        })
        this._ensilataustiedotSubject.next(this._ensilataustiedotSubject.value)
        this._valittuKuukausiSubject.next(kk)
        this._location.replaceState('/asiakkaat/' + asiakas.avain + '/tilintarkastus/' + vuosi + '/' + kuukausi + '/' + this.valittuvalilehti)
        // await this.sleep(250)
        return true
      }
    } else {
      if (preselectedKirjausAvain) {
        await this.vaihdaMaksutapaJosTarvitseeJaKohdistaKirjaukseen(preselectedKirjausAvain, preselectedMaksutapaTunniste)
      } else if (preselectedKirjausnumero) {
        await this.vaihdaMaksutapaJosTarvitseeJaKohdistaKirjaukseenKirjausnumerolla(preselectedKirjausnumero, preselectedMaksutapaTunniste)
      } else if (preselectedMaksutapaTunniste) {
        await this.vaihdaMaksutapaJosTarvitseeJaKohdistaKirjaukseen(null, preselectedMaksutapaTunniste)
      }
    }
  }

  async laskeKirjausnumerotUudelleen() {
    const [asiakas, tiedot] = await firstValueFrom(combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this.valittuKuukausiJaLataustiedotJaRuutuObservable]))

    const tamaKuukausi = tiedot.kuukausi
    const tyojonoData: KirjanpitoKirjausnumeronPaivittaminenTyojonotiedot = {
      asiakasAvain: asiakas.avain,
      jonoonTallennettuAika: this._timestampService.now(),
      maxMuokattuPvm: { year: tamaKuukausi.year, month: tamaKuukausi.month, day: 1 },
      minMuokattuPvm: { year: tamaKuukausi.year, month: tamaKuukausi.month, day: 1 },
    }
    const avain = this._lemonatorFirebase.firestoreCreateId()
    const uri = this._kirjanpitoUriService.annaTyojonoKirjausnumerojenPaivitysUri(tyojonoData.asiakasAvain, avain)

    return this._lemonatorFirebase.firestoreSetData(uri, tyojonoData)
  }

  async lisaaKirjaus(maksutapaJaKirjaukset: MaksutapaJaKirjaukset) {
    // Cannot be any of
    if (
      maksutapaJaKirjaukset.maksutapa.kirjauksienLuontityyppi !== KirjauksienLuontityyppi.KASIN_SYOTETTAVA_TILIOTE &&
      maksutapaJaKirjaukset.maksutapa.kirjauksienLuontityyppi !== KirjauksienLuontityyppi.TOSITTEISTA_GENEROITAVA_TILIOTE &&
      maksutapaJaKirjaukset.maksutapa.sahkoisenTiliotteenAlatyyppi !== SahkoisenTiliotteenAlatyyppi.AIIA &&
      maksutapaJaKirjaukset.maksutapa.sahkoisenTiliotteenAlatyyppi !== SahkoisenTiliotteenAlatyyppi.WEB_SERVICES &&
      maksutapaJaKirjaukset.maksutapa.sahkoisenTiliotteenAlatyyppi !== SahkoisenTiliotteenAlatyyppi.ENABLE_BANKING
    ) {
      return
    }

    try {
      this._ladataanService.aloitaLataaminen()

      const observable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this._tilikarttaService.nykyisenAsiakkaanTilikartanJaPaatilikartanTilitObservable])
      const [asiakas, tilit] = await firstValueFrom(observable)
      if (!asiakas || !tilit) {
        return
      }

      const tili = tilit.find(a => a.numero === maksutapaJaKirjaukset.maksutapa.oletusVastatili)
      const kirjaus: Kirjaus = await this.annaUusiKirjaus(tili, maksutapaJaKirjaukset.maksutapa)
      const pyynto: KirjauksenTallennuspyyntoUusi = {
        asiakasAvain: asiakas.avain,
        kirjaus: kirjaus,
        liitetyt: null,
      }

      const vastaus = await this._lemonatorFirebase.functionsCall<KirjauksenTallennuspyyntoUusi, KirjauksenTallennusvastaus>('kirjanpitoKirjauksetTallennaIlmanTositteidenPaivittamista', pyynto, {
        timeout: 540 * 1000,
      })

      while (!this.naytettavatKirjauksetByKirjausavainMap.get(kirjaus.avain)?.kirjaus?.kirjausnumero) {
        await this.sleep(10)
      }
      await this.sleep(10)

      const kirjausnro = this.naytettavatKirjauksetByKirjausavainMap.get(kirjaus.avain)?.kirjaus?.kirjausnumero

      if (this.paginator && this.paginator.hasNextPage()) {
        const kirj: KlikattuKirjaus = { kirjausnumero: kirjausnro }
        await this.raporttikirjaustaKlikatiinUusi(kirj)
      } else {
        this.vaihdaViimeinenKirjausValituksi('tili')
      }
    } finally {
      this._ladataanService.lopetaLataaminen()
    }
  }

  // private kirjausToSideFeedAction(kirjaus: Kirjaus, action: DocumentChangeType): firebase.firestore.DocumentChange {

  //   const sidefeedSnap: QueryDocumentSnapshot<Kirjaus> = {
  //     data: () => kirjaus,
  //     exists: true,
  //     id: kirjaus.avain,
  //     isEqual: (snap) => false,
  //     metadata: null,
  //     ref: null,
  //     get: (p) => null
  //   }

  //   const sidefeedAction: firebase.firestore.DocumentChange = {
  //     oldIndex: 0,
  //     newIndex: 0,
  //     type: action,
  //     doc: sidefeedSnap
  //   }

  //   return sidefeedAction

  //   // const sidefeedChangeAction: DocumentChangeAction<Kirjaus> = {
  //   //   payload: sidefeedAction,
  //   //   type: action
  //   // }

  //   // return sidefeedChangeAction

  // }

  // private annaUusiKirjaus(tapahtuma: Tilitapahtuma, tili: Kirjanpitotili, defaultMyyntitili: Kirjanpitotili, kaikkiKirjanpitotilit: Kirjanpitotili[], maksutavat: AsiakkaanMaksutapa[]): Kirjaus {
  private async annaUusiKirjaus(tili: Kirjanpitotili, maksutapa: AsiakkaanMaksutapa): Promise<Kirjaus> {
    const ekaKirjausrivi: Kirjausrivi = {
      av: this._lemonatorFirebase.firestoreCreateId(),
      a: null,
      d: null,
      k: null,
      t: tili?.numero || null,
    }

    const tiedot = await firstValueFrom(this.valittuKuukausiJaLataustiedotJaRuutuObservable)
    const valittuKuukausi = tiedot.kuukausi
    const kuukaudenViimeinen = this._dateService.kuukaudenViimeinenPaikallinen({ day: 15, month: valittuKuukausi.month, year: valittuKuukausi.year })

    const kirjaus: Kirjaus = {
      avain: this._lemonatorFirebase.firestoreCreateId(),
      kommentti: null,
      kirjauksenLuoja: null,
      kirjauksenSaajaTaiMaksaja: null,
      kirjauksenSaajaTaiMaksajaIban: null,
      kirjauksenLemonaidViesti: null,
      kirjauksenViesti: null,
      kirjauksenViitenumero: null,
      kirjausLuotu: null, // set by the saving function later. this._timestampProvider.now(),
      kirjausTallennettu: null,
      kirjausnumero: null,
      kirjauksenJarjestysTilitapahtumasta: null,
      p: this._dateService.localDateToNumber(kuukaudenViimeinen),
      kirjauksenSumma: null,
      maksutavanTunniste: maksutapa.tunniste + '',
      rivit: [ekaKirjausrivi],
      versioita: false,
      kirjanpitajaHyvaksynyt: false,
      kirjanpitajaHyvaksynytAinakinKerran: false,
      automaattinenHyvaksynta: false,
      poistettu: false,
      lukittu: false,
      tilinSaldo: null,
      kanava: 'kasin',
    }
    // // Luo oletusmyynti
    // if (tapahtuma.creditDebitCode === 'CRDT') {

    //   // Myyntitilille
    //   const myynninKirjausrivi: Kirjausrivi = {
    //     kommentti: null,
    //     alv: null, // defaultMyyntitili ? defaultMyyntitili.oletusAlvKasittely : null,
    //     debet: null,
    //     kredit: null,
    //     tili: null // defaultMyyntitili
    //   }
    //   // let alvnOsuus = 0
    //   // if (myynninKirjausrivi.alv && myynninKirjausrivi.alv.prosentti) {
    //   //   alvnOsuus = this._currencyService.annaAlvMaaraAlvillisestaHinnasta(Number(tapahtuma.summa), Number(myynninKirjausrivi.alv.prosentti))
    //   //   alvnOsuus = this._currencyService.roundHalfUp(alvnOsuus, 2)
    //   // }
    //   myynninkirjausrivi.k = Number(tapahtuma.summa) // - alvnOsuus
    //   kirjaus.rivit.push(myynninKirjausrivi)

    //   // // ALV-verovelkatilille
    //   // if (alvnOsuus) {
    //   //   const alvnTili = kaikkiKirjanpitotilit.find(a => a.numero === myynninKirjausrivi.alv.kirjaustili)
    //   //   const alvinKirjausrivi: Kirjausrivi = {
    //   //     kommentti: null,
    //   //     alv: null,
    //   //     debet: null,
    //   //     kredit: alvnOsuus,
    //   //     tili: alvnTili
    //   //   }
    //   //   kirjaus.rivit.push(alvinKirjausrivi)
    //   // }

    // } else {
    //   const kirjausrivi: Kirjausrivi = {
    //     kommentti: null,
    //     alv: null,
    //     debet: null,
    //     kredit: null,
    //     tili: null
    //   }
    //   kirjausrivi.d = Number(tapahtuma.summa)
    //   kirjaus.rivit.push(kirjausrivi)
    // }
    return kirjaus
  }

  katseltavanTositteenSivuVaihdettiin() {
    setTimeout(() => {
      this.palautaViimeisinTiedossaOlevaFokus()
    }, 50)
  }

  private annaErotusTaiKaavanArvo(suspect: string, naytettavaKirjaus: NaytettavaKirjaus): number | null {
    const suodatettu = this._stringService.removeAllWhiteSpaces(suspect.replace(/,/g, '.'))
    if (suodatettu === '=') {
      const summat = this._kirjanpitoJaettuService.annaKirjauksenSummat(naytettavaKirjaus?.kirjaus)
      return Math.abs(summat.debet - summat.kredit)
    }
    return this.calculateFormulaValue(suodatettu)
  }

  // TODO: EXTRACT OWN SERVICE
  private _parser = new hotFormulaParser.Parser()
  private calculateFormulaValue(suspect: string): number | null {
    if (!suspect) {
      return null
    }

    const lastCharOfString = suspect.slice(-1)
    if (!this._currencyService.onkoSallittuMerkkiNumerossa(lastCharOfString, 3) && lastCharOfString !== ')') {
      suspect = suspect.slice(0, -1)
    }

    const result = this._parser.parse(suspect)
    if (result.error) {
      // console.log('Suspect', suspect, 'RESULT', result)
      return null
    }
    if (result.result === null || result.result === undefined || isNaN(result.result)) {
      // console.log('Suspect', suspect, 'RESULT', result)
      return null
    }
    // console.log('Suspect', suspect, 'RESULT', result)
    return result.result
  }

  kirjaamattomatAuki: boolean = true
  // private _edellinenValilehti: ValilehdenTunnus = null
  private _selectTabInternal(valilehti: ValilehdenTunnus) {
    // valilehti === 'raportit' ||
    if (valilehti === 'raportit-uusi' || valilehti === 'tilinpaatos' || valilehti === 'reskontra') {
      this.kirjaamattomatAuki = false
      // console.log('RAPORTIT this.kirjaamattomatAuki', this.kirjaamattomatAuki)
    } else if (valilehti === 'tositteet') {
      this.kirjaamattomatAuki = true
      // console.log('TOSITTEET, this.kirjaamattomatAuki', this.kirjaamattomatAuki)
    }
    // this._edellinenValilehti = this.valittuvalilehti
    this.valittuvalilehti = valilehti

    const tabTiedotObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this.valittuTabObservable, this.valittuKuukausiJaLataustiedotJaRuutuObservable]).pipe(
      filter<[AsiakkaanAvainTiedot, TabTyypit, KuukausiJaLataustiedotJaRuutu]>(([asiakas, tab, kuukausi]) => {
        return !!asiakas
      }),
    )

    firstValueFrom(tabTiedotObservable).then(([asiakas, tab, kuukausiJaLataustiedotJaRuutu]) => {
      const tamaKuukausi = kuukausiJaLataustiedotJaRuutu.kuukausi
      if (asiakas && tamaKuukausi && tab) {
        this._location.replaceState('/asiakkaat/' + asiakas.avain + '/tilintarkastus/' + tamaKuukausi.year + '/' + tamaKuukausi.month + '/' + this.valittuvalilehti) //  + '/' + tab
      }
    })
  }
  selectTab(valilehti: ValilehdenTunnus) {
    this._selectTabInternal(valilehti)
    this.katseltavanTositteenSivuVaihdettiin()
  }
  async avaaUudetRaportitUudessaIkkunassa(event: MouseEvent) {
    this.preventEvent(event)
    // asiakkaat/:asiakasAvain/kirjanpidon-raportit/:vuosi/:kuukausi/:tyyppi
    const asiakas = await firstValueFrom(this.nykyinenAsiakasObservable)
    const kuukausi = await firstValueFrom(this.valittuKuukausiJaLataustiedotJaRuutuObservable)

    if (!asiakas || !kuukausi) {
      return
    }

    const start = window.location.protocol + '//' + window.location.host
    const valilehti: KirjanpitoRaporttiValilehti = 'tase-ja-tulos'
    const url = start + '/asiakkaat/' + asiakas.avain + '/tilintarkastus/kirjanpidon-raportit/' + kuukausi.kuukausi.year + '/' + kuukausi.kuukausi.month + '/' + valilehti
    window.open(url, 'raportti_' + asiakas.avain, 'height=500,width=500,modal=yes,alwaysRaised=yes')
  }
  // async avaaRaportitUudessaIkkunassa(event: MouseEvent) {
  //   this.preventEvent(event)
  //   // asiakkaat/:asiakasAvain/kirjanpito-raportit/:vuosi/:kuukausi
  //   const asiakas = await firstValueFrom(this.nykyinenAsiakasObservable)
  //   const kuukausi = await firstValueFrom(this.valittuKuukausiJaLataustiedotJaRuutuObservable)

  //   if (!asiakas || !kuukausi) {
  //     return
  //   }

  //   const start = window.location.protocol + '//' + window.location.host
  //   const url = start + '/asiakkaat/' + asiakas.avain + '/kirjanpito-raportit/' + kuukausi.year + '/' + kuukausi.month
  //   window.open(url, 'raportit_' + asiakas.avain, 'height=500,width=500,modal=yes,alwaysRaised=yes')
  // }
  toggleKirjaamattomat(event: MouseEvent) {
    console.log('this.kirjaamattomatAuki', this.kirjaamattomatAuki)
    this.kirjaamattomatAuki = !this.kirjaamattomatAuki
    this.preventEvent(event)
  }

  // hoidaKuitinEsikatselunRaahaaminen(event: DragEvent) {
  //   // console.log(event)
  //   // const wholeHeight = document.body.offsetHeight
  //   const wholeHeight = window.innerHeight
  //   const currentPosition = event.y - 22
  //   const vhs = currentPosition / wholeHeight
  //   const top = 100 * vhs
  //   const min = Math.max(top, 20)
  //   const final = Math.min(min, 90)
  //   this._tositteenKorkeusSubject.next(final)
  //   // console.log(final, wholeHeight, currentPosition)
  // }

  // aloitaKuitinEsikatselunResize(event: DragEvent) {
  //   // console.log('START', event)
  //   const div = document.createElement('img')
  //   div.id = 'drag-image'
  //   div.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
  //   document.body.appendChild(div)
  //   event.dataTransfer.setDragImage(div, 0, 0)
  //   event.dataTransfer.setData('text', 'foo')
  // }

  // lopetaKuitinEsikatselunResize(event: DragEvent) {
  //   document.getElementById('drag-image').remove()
  // }

  setSpostiCheck(bool: boolean) {
    this.onkoSpostejaLahetetty = bool
  }

  setLatestAlvIlmoitus(ilmoitus: AlvIlmoitus) {
    this.latestAlvIlmoitusSubject.next(ilmoitus)
  }

  ilmoituksetTabVaihtui(index: number) {
    const newTab = index === 0 ? 'alv' : 'yhteisomyynti'
    // Merkitään manuaaliseksi valinnaksi vain jos tab oikeasti vaihtuu (ei alustuksessa)
    if (this._valittuIlmoitusTabSubject.value !== newTab) {
      this._kayttajaValitsiIlmoitusTabinManuaalisesti = true
      this._valittuIlmoitusTabSubject.next(newTab)
    }
  }

  async ruksiaNapautettiinHandler(tosite: TositeJaNaytettavaSivut) {
    try {
      const dialogData: AreYouSureDialogData = {
        rightAction: 'Siirrä tosite',
        text: 'Haluatko varmasti irroittaa tositteen kirjauksesta ja siirtää sen kirjaamattomien tositteiden listaan?',
      }
      await firstValueFrom(this._dialog.open(AreYouSureDialog, { data: dialogData }).afterClosed()).then(poista => {
        if (poista) {
          return this._poistaKirjauksenSivu(tosite)
        }
      })
    } catch (err) {
      this._errorHandler.handleError(err)
    }
  }

  private async _poistaKirjauksenSivu(tosite: TositeJaNaytettavaSivut) {
    // const naytettavaKirjaus = this._valittuNaytettavaKirjausSubject?.value
    // const kirjaus = naytettavaKirjaus?.kirjaus
    // const poistettavaKuva = event?.kuva
    // // Do we have all the data?
    // if (!poistettavaKuva || !poistettavaKuva.kuvanAvain || !naytettavaKirjaus || !kirjaus) {
    //   return
    // }
    // const kirjattavaKuitti = kirjaus.liitetytKuitit[poistettavaKuva.kirjattavaKuitti?.avain]
    // if (kirjattavaKuitti) {
    //   const poistettavaFirestoreTositteenKuva = kirjattavaKuitti.kuitti?.kuvat[poistettavaKuva.kuvanAvain]
    //   if (poistettavaFirestoreTositteenKuva) {
    //     if (!naytettavaKirjaus.poistettavatKuitit) { naytettavaKirjaus.poistettavatKuitit = [] }
    //     naytettavaKirjaus.poistettavatKuitit.push(poistettavaKuva.kuvanAvain)
    //     // Merkitse poistetuksi
    //     poistettavaFirestoreTositteenKuva.poistettu = true
    //     // Poista myös näytettävistä kuvista (Näihin cachetaan kuva / preload)
    //     for (const naytettevaLiittettyKuitti of naytettavaKirjaus.naytettavatLiitetytKuitit) {
    //       if (naytettevaLiittettyKuitti.kirjattavaKuitti.avain === poistettavaKuva.kirjattavaKuitti.avain) {
    //         const removeIndex = naytettevaLiittettyKuitti.kuvat.findIndex(a => a.kuvanAvain === event.kuva.kuvanAvain)
    //         if (removeIndex > -1) {
    //           naytettevaLiittettyKuitti.kuvat.splice(removeIndex, 1)
    //         }
    //         break
    //       }
    //     }
    //     this._valittuNaytettavaKirjausSubject.next(naytettavaKirjaus)
    //     await this.tallennaKirjaus(naytettavaKirjaus)
    //   }
    // }
  }

  toggleVainHyvaksymattomat() {
    this._naytaVainHyvaksymattomatSubject.next(!this._naytaVainHyvaksymattomatSubject.value)
  }

  toggleNaytaPoistetut() {
    this._naytaPoistetutKirjauksetSubject.next(!this._naytaPoistetutKirjauksetSubject.value)
  }

  private _saveIsCommentShowing() {
    firstValueFrom(this._asiakasService.nykyinenAsiakasObservable)
      .then(asiakas => {
        if (asiakas) {
          return this._asiakasService.tallennaKirjanpidonMuistiinpanonAukiolo(asiakas, !asiakas.kirjanpidonMuistiinpanoAuki)
        }
      })
      .catch(error => {
        this._errorHandler.handleError(error)
      })
  }

  toggleComment() {
    this._saveIsCommentShowing()
  }

  clickListaukseen(event: MouseEvent) {
    this.preventEvent(event)
    return firstValueFrom(this._asiakasService.nykyinenAsiakasObservable).then(asiakas => {
      if (asiakas?.kasittelija === 'QgPvtcCjoOdf6Zg7lgMwqLWp2BG2') {
        return this._router.navigate(['zen'])
      }
      const palvelupaketti = this._sopimuskausiService.annaPalvelupakettiPaivalle(asiakas?.sopimuskaudet, this._dateService.currentLocalDate())
      if (palvelupaketti === SopimusPalvelupaketti.KASVU_SUORITEPERUSTEINEN) {
        return this._router.navigate(['asiakkaat', 'kasvu'])
      }
      if (asiakas?.uudessaListassa) {
        return this._router.navigate(['asiakkaat'])
      }
      return this._router.navigate(['asiakkaat', 'fivaldi'])
    })
  }

  clickKotiin(event: MouseEvent) {
    this.preventEvent(event)
    return this._router.navigate(['/tilintarkastajat/aloitus'])
  }

  async liitaTositeValittuunKirjaukseenHandler(tosite: TositeJaNaytettavaSivut) {
    const esikatselunTiedot = await firstValueFrom(this._kirjanpitoImageHandlerService.esikatseltavaTositeObservable)
    const asiakas = await firstValueFrom(this._asiakasService.nykyinenAsiakasAvainObservable)
    const naytettavaKirjaus = await firstValueFrom(this.valittuNaytettavaKirjausObservable)

    if (!asiakas || !esikatselunTiedot || !naytettavaKirjaus) {
      return
    }

    if (esikatselunTiedot.naytettavaKuitti) {
      this._kirjanpitoImageHandlerService.lopetaEsikatselu()
      return this._kirjanpitoTositeService.liitaKuittiKirjaukseen(asiakas, naytettavaKirjaus.kirjaus, esikatselunTiedot.naytettavaKuitti.kirjattavaKuitti).catch(err => {
        this._errorHandler.handleError(err)
        this._snackbar.open('Tositteen liittäminen epäonnistui. Yritä uudelleen.', 'OK', { duration: 2500 })
      })
    }

    if (esikatselunTiedot.naytettavaLasku) {
      this._kirjanpitoImageHandlerService.lopetaEsikatselu()
      return this._kirjanpitoTositeService.liitaLaskuKirjaukseen(asiakas, naytettavaKirjaus.kirjaus, esikatselunTiedot.naytettavaLasku.kirjattavaLasku).catch(err => {
        this._errorHandler.handleError(err)
        this._snackbar.open('Laskun liittäminen epäonnistui. Yritä uudelleen.', 'OK', { duration: 2500 })
      })
    }

    if (esikatselunTiedot.naytettavaRaahattava) {
      this._kirjanpitoImageHandlerService.lopetaEsikatselu()
      return this._kirjanpitoTositeService.liitaRahaattuKirjaukseen(asiakas, naytettavaKirjaus.kirjaus, esikatselunTiedot.naytettavaRaahattava).catch(err => {
        this._errorHandler.handleError(err)
        this._snackbar.open('Tiedoston liittäminen epäonnistui. Yritä uudelleen.', 'OK', { duration: 2500 })
      })
    }
  }
  async paivitaValittavatTilit() {
    this._kaikkiTilitMap = await firstValueFrom(this._tilikarttaService.kirjauksenTilinValintaTilitObservable).then(tilit => {
      const tiliMap: Map<string, Kirjanpitotili> = new Map()
      for (const tili of tilit) {
        tiliMap.set(tili.numero, tili)
      }
      return tiliMap
    })

    this._setupValittavatTilit()
  }

  private _updatePaivasaldotErottaaKolmiot(selected: BankBalanceCalcAlgorithm) {
    const tyojonoAvain = this._lemonatorFirebase.firestoreCreateId()
    const tyojonoUri = this._kirjanpitoUriService.annaTyojonoKuukaudenErotusPaivitysUri(this._asiakas.avain, tyojonoAvain)
    const tyojonoData: KirjanpitoKuukausiruutujenErotustenPaivittaminenTyojonotiedot = {
      aloituskuukausi: { year: 2022, month: 12 },
      asiakasAvain: this._asiakas.avain,
      jonoonTallennettuAika: this._lemonatorFirebase.firestoreTimestampFromDate(new Date()),
      bankBalanceCalcAlgoVersion: selected,
    }

    return this._lemonatorFirebase.firestoreSetData(tyojonoUri, tyojonoData)
  }

  private _isMurrettuTilikausi(tilikausi: Tilikausi): boolean {
    if (tilikausi.loppuu.month === 12 && tilikausi.loppuu.day === 31) {
      return false
    }

    return true
  }

  async onOpenKirjaus(data: { kirjausAvain: string; pvm: NumberDate; maksutapa: number }) {
    await this._raportointiKirjausValittiin(data.kirjausAvain, null, this._dateService.numberToLocalDate(data.pvm), '' + data.maksutapa)
  }

  openBankBalanceEditDialog(maksutapa: AsiakkaanMaksutapa) {
    const data: KirjanpitoLisaaTiliotteenSaldoDialogData = {
      asiakasAvain: this._asiakas.avain,
      maksutapa: maksutapa,
    }
    this._dialog.open(KirjanpitoLisaaTiliotteenSaldoDialog, { data: data })
  }

  async lataaTiliote(maksutapa: AsiakkaanMaksutapa) {
    this._ladataanService.aloitaLataaminen()
    try {
      const asiakas = await firstValueFrom(this._asiakasService.nykyinenAsiakasObservable)
      const valittuKuukausi = this._valittuKuukausiSubject.value
      const kuukaudenAlku: LocalDate = { year: valittuKuukausi.year, month: valittuKuukausi.month, day: 1 }
      const kuukaudenLoppu = this._dateService.kuukaudenViimeinenPaikallinen(kuukaudenAlku)
      const haku: RaporttiRequest = {
        a: asiakas.avain,
        k: 'fi',
        w: RaporttiType.TILIOTE,
        s: this._dateService.localDateToNumber(kuukaudenAlku),
        e: this._dateService.localDateToNumber(kuukaudenLoppu),
        mt: maksutapa.avain,
        datasource: 'raportointikirjaukset',
      }
      const data = await this._lemonatorFirebase.functionsCall<RaporttiRequest, RaporttiPdfResponse>('kirjanpitoRaportitPdf', haku)
      if (data.base64File) {
        const fileName = data.fileName || 'tiliote.pdf'
        this._fileSaverService.saveBase64As(data.base64File, fileName, 'pdf')
      } else {
        this._snackbar.open('Tiliotteen lataaminen epäonnistui.', 'OK')
      }
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open('Tiliotteen lataaminen epäonnistui.', 'OK')
    } finally {
      this._ladataanService.lopetaLataaminen()
    }
  }

  avaaTilitapahtumaDialog() {
    // Get all maksutapas with sahkoisenTiliotteenTunniste
    const maksutavatWithTiliote = Array.from(this._kaikkiMaksutavatMap.values()).filter(mt => mt.sahkoisenTiliotteenTunniste)

    const dialogData: LisaaTilitapahtumaDialogData = {
      asiakasAvain: this._asiakas.avain,
      kaikkiMaksutavat: maksutavatWithTiliote,
    }

    this._dialog.open(LisaaTilitapahtumaDialog, {
      data: dialogData,
      width: '600px',
    })
  }

  async jaksotaKuluUseallekuukaudelle(kirjaus: Kirjaus) {
    const hierarkia = await firstValueFrom(this._tilikarttaService.nykyisenAsiakkaanTilikartanTilihierarkiaObservable)
    const kulutilit = this._tilikarttaJaettuService.annaKulutilitMap(hierarkia)

    const kulutilirivit = kirjaus.rivit?.length ? kirjaus.rivit.filter(rivi => kulutilit.has(rivi.t)) : []

    if (!kulutilirivit.length) {
      return this._avaaKulunJaksotusVirheDialog('ei-kulutileja')
    }

    const dialogData: KirjausJaksotaKuluDialogData = {
      asiakas: this._asiakas,
      kirjaus: kirjaus,
      kirjauksenKulurivit: kulutilirivit,
    }
    this._dialog.open(KirjausJaksotaKuluDialog, { data: dialogData })
  }

  private _avaaKulunJaksotusVirheDialog(virhe: 'ei-kulutileja') {
    const dialogData: InfoDialogData = {
      header: 'Jaksotaminen',
      text: this._annaJaksotusVirheTeksti(virhe),
    }
    this._dialog.open(InfoDialog, { data: dialogData })
  }

  private _annaJaksotusVirheTeksti(virhe: 'ei-kulutileja') {
    if (virhe === 'ei-kulutileja') {
      return 'Kirjauksessa ei kulutilejä; ominaisuutta ei voida käyttää'
    }
    throw new Error('Tuntematon jaksotusvirhe: ' + virhe)
  }

  kirjauksessaYhteisomyyntiVatKentta(kirjaus: Kirjaus): boolean {
    if (!kirjaus) {
      return false
    }
    const yhteisomyyntiVatTunnisteet = MyyntiAlvt.yhteisomyynti.map(alv => alv.tunniste)
    return kirjaus.rivit?.some(rivi => yhteisomyyntiVatTunnisteet.includes(rivi.a)) ?? false
  }

  private paivitaKirjauksessaYhteisomyyntiVatKentta(naytettavaKirjaus: NaytettavaKirjaus) {
    naytettavaKirjaus.kirjauksessaYhteisomyyntiVatKentta = this.kirjauksessaYhteisomyyntiVatKentta(naytettavaKirjaus.kirjaus)
  }
}
